export const algo = {
  "How to find the duplicate elements in an array in linear time":
    "https://www.codevscolor.com/find-duplicate-elements-array",
  "Find all elements in an array which are greater than other right elements":
    "https://www.codevscolor.com/elements-array-greater-other-right",
};
export const android = {
  "Android Material Design Tutorial : Part 1 : Toolbar":
    "https://www.codevscolor.com/material-design-tutorial-1-toolbar",
  "Android Material Design Tutorial : Part 2 : Collapsing Toolbar Layout":
    "https://www.codevscolor.com/material-design-tutorial-2-collapsing-toolbar",
  "Android Material Design Tutorial : Part 3 : Fab and Snackbar":
    "https://www.codevscolor.com/material-design-tutorial-3-fab-snackbar",
  "Android Material Design Tutorial : Part 4 : Floating label edit text":
    "https://www.codevscolor.com/material-design-tutorial-4-floating-label-edit-text",
  "Android Material Design Tutorial : Part 5 : Tab Layout":
    "https://www.codevscolor.com/material-design-tutorial-5-tab-layout",
  "Android Material Design Tutorial : Part 5.1 : Tab layout part 2":
    "https://www.codevscolor.com/tab-layout-part-2",
  "Android Material Design Tutorial : Part 6 : Navigation View":
    "https://www.codevscolor.com/material-design-tutorial-6-navigationview",
  "Android Material Design Tutorial : Part 8 : Recyclerview - Basics":
    "https://www.codevscolor.com/material-design-tutorial-8-recyclerview-basics",
  "Android Material Design Tutorial : Part 9 : Recyclerview tutorial to create Grids":
    "https://www.codevscolor.com/recyclerview-creating-grids",
  "Android Material Design Tutorial : Part 10 : Password Visibility Toggle":
    "https://www.codevscolor.com/android-material-design-tutorial-10-password-visibility-toggle",
  "Android Material Design Tutorial : Part 11 : Bottom Navigation View":
    "https://www.codevscolor.com/android-material-bottom-navigation-view",
  "Android Day-night view tutorial":
    "https://www.codevscolor.com/android-daynight-view-tutorial",
  "Android working with Vector Drawable":
    "https://www.codevscolor.com/android-working-vectordrawable",
  "Android Vector Drawable Part 2":
    "https://www.codevscolor.com/android-working-vector-drawable-part-2",
  "Android Studio webp images tutorial":
    "https://www.codevscolor.com/android-studio-2-3-update-webp-images-png-webp",
  "Android Unit Testing Part 1 : Introduction":
    "https://www.codevscolor.com/android-unit-testing-part-1-introduction",
  "Android Unit Testing Part 2":
    "https://www.codevscolor.com/android-unit-testing-part-2",
  "Android Testing Part 3 : Testing using mockito":
    "https://www.codevscolor.com/testing-android-part-3-using-mockito",
  "Android Testing Part 4 : Instrumented unit test":
    "https://www.codevscolor.com/testing-in-android-part-4-instrumented-unit-test",
  "Android Testing Part 5 : Automated UI Testing using Espresso":
    "https://www.codevscolor.com/testing-in-android-part-5-automated-ui-test-using-espresso",
  "Android Retrofit 2 Tutorial":
    "https://www.codevscolor.com/android-retrofit-2-tutorial",
  "Firebase Tutorial Part 1 : introduction":
    "https://www.codevscolor.com/firebase-using-android-studio-part-1",
  "Firebase Tutorial Part 2 : Signup/SignIn and SignOut":
    "https://www.codevscolor.com/firebase-using-android-studio-part-2-signupsigninsignout-using-firebase",
  "Firebase Tutorial Part 3 : Firebase realtime database":
    "https://www.codevscolor.com/firebase-android-tutorial-part-3-firebase-realtime-database",
  "Firebase Tutorial Part 4 : Firebase Storage":
    "https://www.codevscolor.com/firebase-android-tutorial-part-4-firebase-storage",
  "Java 8 in Android Studio Tutorial - 1":
    "https://www.codevscolor.com/java-8-android-studio-tutorial-1",
  "Android Kotlin program to load image from url using glide":
    "https://www.codevscolor.com/android-kotlin-load-image-url",
  "Android Kotlin example to pass data from one Activity to another":
    "https://www.codevscolor.com/android-kotlin-pass-data-activity",
  "How to create a basic recyclerview in Android using Kotlin":
    "https://www.codevscolor.com/android-kotlin-create-basic-recyclerview",
  "How to validate an email in Kotlin in Android":
    "https://www.codevscolor.com/android-kotlin-validate-email",
  "How to hide soft keyboard in Android (Kotlin) programmatically":
    "https://www.codevscolor.com/android-kotlin-hide-soft-keyboard-programmatically",
  "How to change the theme of Android Studio":
    "https://www.codevscolor.com/android-studio-change-theme",
  "Create a recyclerview with image from API in Kotlin Android":
    "https://www.codevscolor.com/android-kotlin-recyclerview-with-image",
  "How to delete an item from a recyclerview in Android(Kotlin)":
    "https://www.codevscolor.com/android-kotlin-delete-item-recyclerview",
  "How to add pull to refresh/ swipe refresh in an Android project in Kotlin":
    "https://www.codevscolor.com/android-swipe-refresh-layout",
  "How to change the App name and package name in Android Studio":
    "https://www.codevscolor.com/android-studio-change-app-name-package-name",
  "Adapter callback in Android using lambda function of Kotlin":
    "https://www.codevscolor.com/kotlin-android-adapter-callback-using-lambda-function",
  "How to show/hide a menu button in Android dynamically in Kotlin":
    "https://www.codevscolor.com/android-show-hide-menu-button-dynamically",
  "Learn to create a simple Alert Dialog in Android using Kotlin":
    "https://www.codevscolor.com/android-simple-alert-dialog-kotlin",
  "How to create an alert dialog with a list in Android(Kotlin)":
    "https://www.codevscolor.com/android-kotlin-list-alert-dialog",
  "How to create an alert dialog with multiselection in Android(Kotlin)":
    "https://www.codevscolor.com/android-kotlin-multiselection-alert-dialog",
  "How to add a tooltip to a button in Android":
    "https://www.codevscolor.com/android-tooltip",
};
export const bootstrap = {
  "Button group in Bootstrap 4 : Explanation with example":
    "https://www.codevscolor.com/bootstrap-4-button-group",
  "Media objects in Bootstrap : Explanation with example":
    "https://www.codevscolor.com/bootstrap-media-objects",
};
export const cpp = {
  "C++ program to find simple interest":
    "https://www.codevscolor.com/c-plus-plus-program-to-find-simple-interest",
  "C++ program to check if a number is power of 2 or not using its binary":
    "https://www.codevscolor.com/cpp-check-if-number-is-power-of-2",
  "C++ getchar( function explanation with example":
    "https://www.codevscolor.com/c-getchar-function-explanation-with-example",
  "C++ program for Celsius to Fahrenheit and Fahrenheit to Celsius conversion":
    "https://www.codevscolor.com/c-plus-plus-celsius-fahrenheit-conversion",
  "C++ program to check if a number is Armstrong or not":
    "https://www.codevscolor.com/c-plus-plus-program-armstrong-number",
  "C++ sin( function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-sin",
  "C++ log10( function explanation with examples":
    "https://www.codevscolor.com/c-log10-function-explanation-with-examples",
  "C++ puts( function explanation with examples":
    "https://www.codevscolor.com/c-puts-function-explanation-with-examples",
  "C++ program to change the case of all characters in a string":
    "https://www.codevscolor.com/c-plus-plus-change-character-case-string",
  "C++ program to find out the total vowels in a string":
    "https://www.codevscolor.com/c-program-to-find-out-the-total-vowels-in-a-string",
  "C++ program to count the total number of digits in a string":
    "https://www.codevscolor.com/cpp-count-digits-in-string",
  "C++ tutorial to find the largest of two user input numbers":
    "https://www.codevscolor.com/c-plus-plus-find-largest-two-numbers",
  "C++ program to find LCM of two numbers":
    "https://www.codevscolor.com/c-plus-plus-find-lcm-two-numbers",
  "C++ tutorial to swap two numbers without using a third variable":
    "https://www.codevscolor.com/c-plus-plus-swap-two-numbers-without-third-variable",
  "Find if a number is prime or not in C++":
    "https://www.codevscolor.com/c-plus-plus-check-prime-number",
  "C++ program to check if all characters of a string are alphanumeric or not":
    "https://www.codevscolor.com/c-plus-plus-check-alphanumeric-character",
  "log function in C++ explanation with example":
    "https://www.codevscolor.com/c-plus-plus-log-function",
  "C++ program to print a hollow triangle using star":
    "https://www.codevscolor.com/c-plus-plus-print-triangle",
  "How to read a string in C++ using getline":
    "https://www.codevscolor.com/c-plus-plus-getline",
  "C++ if-else if-else ladder example":
    "https://www.codevscolor.com/c-if-else-if-else-ladder-example",
  "C++ program to print Floyd’s triangle using for and while loop":
    "https://www.codevscolor.com/c-plus-plus-print-floyd-triangle",
  "Find the cube root of a number in C++":
    "https://www.codevscolor.com/find-cube-root-number",
  "C++ program to find the centroid of a triangle":
    "https://www.codevscolor.com/c-plus-plus-centroid-of-triangle",
  "C++ program to check if a character is vowel or not":
    "https://www.codevscolor.com/c-plus-plus-check-vowel",
  "How to add comments in C++ with example":
    "https://www.codevscolor.com/c-plus-plus-add-comments",
  "C++ example program to reverse a number":
    "https://www.codevscolor.com/c-plus-plus-reverse-number",
  "C++ program to find the power of a number":
    "https://www.codevscolor.com/c-plus-plus-find-power-of-number",
  "C++ program to find the second highest number in an array":
    "https://www.codevscolor.com/c-plus-plus-second-highest-array-number",
  "C++ program to print the ASCII values of all English alphabets":
    "https://www.codevscolor.com/c-program-to-print-the-ascii-values-of-all-english-alphabets",
  "C++ different ways to find the length of a string":
    "https://www.codevscolor.com/c-plus-plus-find-length-string",
  "C++ program to count total digits in a number":
    "https://www.codevscolor.com/c-plus-plus-count-digits-number",
  "C++ program to find armstrong numbers in a range":
    "https://www.codevscolor.com/c-plus-plus-find-armstrong-range",
  "C++ program to find the larger string":
    "https://www.codevscolor.com/c-plus-plus-find-larger-string",
  "C++ program to find the first and the last occurrence of a character in a string":
    "https://www.codevscolor.com/c-plus-plus-first-last-character-occurrence-string",
  "C++ program to check if a number is palindrome or not":
    "https://www.codevscolor.com/c-plus-plus-check-palindrome",
  "C++ program to check if a number is perfect or not":
    "https://www.codevscolor.com/c-plus-plus-check-perfect-number",
  "C++ program to print a square hollow pattern":
    "https://www.codevscolor.com/c-plus-plus-print-square-hollow-pattern",
  "C++ program to print half pyramid or right angled triangle":
    "https://www.codevscolor.com/c-plus-plus-half-pyramid",
  "C++ print inverted right-angled triangle":
    "https://www.codevscolor.com/c-plus-plus-inverted-right-angle-triangle",
  "Two different ways to find the circle area in C++":
    "https://www.codevscolor.com/c-plus-plus-circle-area",
  "C++ fdim, fdimf and fdiml functions example":
    "https://www.codevscolor.com/c-plus-plus-fdim-fdimf-fdiml",
  "C++ program to find the maximum and minimum of two numbers using cmath":
    "https://www.codevscolor.com/c-plus-plus-fmax-fmin",
  "C++ program to calculate arithmetic mean":
    "https://www.codevscolor.com/c-plus-plus-arithmetic-mean",
  "C++ program to find all prime numbers in a range":
    "https://www.codevscolor.com/c-plus-plus-prime-in-range",
  "Different ways to convert one string to integer in C++":
    "https://www.codevscolor.com/c-plus-plus-string-to-int",
  "C++ program to find all perfect numbers in a given range":
    "https://www.codevscolor.com/perfect-numbers-in-range",
  "C++ program to find the factorial of a number using pointer":
    "https://www.codevscolor.com/c-plus-plus-factorial-number",
  "C++ program to read student names and marks":
    "https://www.codevscolor.com/c-program-to-read-student-names-and-marks",
  "C++ program to print values at odd and even index of an array":
    "https://www.codevscolor.com/c-plus-plus-print-odd-even-index-array-values",
  "C++ program to print the ASCII values of all characters of a string":
    "https://www.codevscolor.com/c-plus-plus-print-ascii-characters-string",
  "C++ program to store student details using class":
    "https://www.codevscolor.com/c-plus-plus-student-details-class",
  "endl in C++ and why we use it instead of newline":
    "https://www.codevscolor.com/c-plus-plus-endl",
  "setbase operator in C++": "https://www.codevscolor.com/c-plus-plus-setbase",
  "C++ program to print a random number":
    "https://www.codevscolor.com/c-plus-plus-print-random-number",
  "Find the area of a triangle in C++":
    "https://www.codevscolor.com/c-plus-plus-area-of-triangle",
  "C++ program to find the smallest and the largest elements in an array":
    "https://www.codevscolor.com/c-plus-plus-find-array-smallest-largest",
  "C++ Interview question : Find the sum of the series 1 + 3 + 5 + …..":
    "https://www.codevscolor.com/c-plus-plus-find-sum-series-1-3-5",
  "C++ if...else, if..elseif...else and nested if...else":
    "https://www.codevscolor.com/c-plus-plus-if-else-elseif-nested-if",
  "while loop in C++": "https://www.codevscolor.com/c-plus-plus-while-loop",
  "C++ program to find out the missing number in an array":
    "https://www.codevscolor.com/c-plus-plus-find-missing-number-in-array",
  "C++ program to find palindrome numbers between 1 to 100":
    "https://www.codevscolor.com/c-plus-plus-palindrome-range",
  "C++ program to check if a string is palindrome or not":
    "https://www.codevscolor.com/c-plus-plus-string-check-palindrome",
  "5 different C++ programs to print one string without a semicolon":
    "https://www.codevscolor.com/c-plus-plus-print-without-semicolon",
  "C++ program to find the first and the last digit of a number":
    "https://www.codevscolor.com/c-plus-plus-find-last-digit-number",
  "C++ program to find the area of a square using three different methods":
    "https://www.codevscolor.com/c-plus-plus-area-square",
  "Find the factorial in C++ using a for and while loop":
    "https://www.codevscolor.com/c-plus-plus-factorial-for-loop",
  "C++ program to find the last character of a string":
    "https://www.codevscolor.com/c-plus-plus-find-last-string-character",
  "C++ program to read file line by line":
    "https://www.codevscolor.com/c-plus-plus-read-file-line-by-line",
  "C++ program to print data in a table":
    "https://www.codevscolor.com/c-plus-plus-print-data-table",
  "C++ program to create array of objects by taking user inputs":
    "https://www.codevscolor.com/c-plus-plus-array-of-objects-user-input",
  "C++ program to create a file and write data to it":
    "https://www.codevscolor.com/c-plus-plus-create-file-write-data",
  "C++ program to remove the last character from a string in different ways":
    "https://www.codevscolor.com/c-plus-plus-remove-string-last-character",
  "C++ read string with spaces from console":
    "https://www.codevscolor.com/c-plus-plus-read-string-with-spaces-from-console",
  "C++ program to find the square root of a number":
    "https://www.codevscolor.com/c-plus-plus-find-square-root-number",
  "Singly linked list implementation in c++":
    "https://www.codevscolor.com/c-plus-plus-singly-linked-list",
  "C++ linked list insert nodes to start and end":
    "https://www.codevscolor.com/c-plus-plus-singly-linked-list-insert-node",
  "C++ linked list example to delete a node":
    "https://www.codevscolor.com/c-plus-plus-singly-linked-list-delete-node",
  "How to reverse a linked list in C++":
    "https://www.codevscolor.com/c-plus-plus-reverse-linked-list",
  "C++ program to find the sum of first n natural numbers":
    "https://www.codevscolor.com/c-plus-plus-find-sum-first-n-numbers",
  "C++ program to find permutation and combination npr and ncr":
    "https://www.codevscolor.com/c-plus-plus-find-permutation-combination",
  "C++ program to find out the sum of factorial series 1! + 2! + 3! + 4!...":
    "https://www.codevscolor.com/c-plus-plus-find-sum-factorial-series",
  "C++ program to find the sum of digits of a number":
    "https://www.codevscolor.com/c-plus-plus-find-sum-digits-number",
  "C++ program to delete a file":
    "https://www.codevscolor.com/c-plus-plus-delete-a-file",
  "C++ program to find the sum of digits in a String":
    "https://www.codevscolor.com/c-plus-plus-sum-digits-string",
  "3 different C++ program to find the largest of three numbers":
    "https://www.codevscolor.com/c-plus-plus-largest-three-numbers",
  "How to convert decimal to binary in C++":
    "https://www.codevscolor.com/c-plus-plus-decimal-binary-conversion",
  "C++ program to find student grades using if-else":
    "https://www.codevscolor.com/c-plus-plus-find-student-grades",
  "C++ program to find a value in a linkedList":
    "https://www.codevscolor.com/c-plus-plus-find-value-in-linkedlist",
  "C++ program to print a triangle with 1 and 0":
    "https://www.codevscolor.com/c-plus-plus-print-triangle-one-zero",
  "C++ program to implement binary search":
    "https://www.codevscolor.com/c-plus-plus-binary-search",
  "C++ program to delete the middle node in a linked list":
    "https://www.codevscolor.com/c-plus-plus-delete-middle-node-linked-list",
  "C++ program to capitalize first and last character of each word in a string":
    "https://www.codevscolor.com/c-plus-plus-capitalize-first-last-character-word-string",
  "What are the differences between puts and cout in C++":
    "https://www.codevscolor.com/c-plus-plus-difference-between-puts-cout",
  "Two different C++ program to find the largest of n numbers":
    "https://www.codevscolor.com/cpp-find-largest-n-numbers",
  "C++ program to print the current date, day and time":
    "https://www.codevscolor.com/c-plus-plus-print-current-date-day-time",
  "Write a count-down timer program in C++":
    "https://www.codevscolor.com/cpp-count-down-timer",
  "C++ std::copy() function explanation with examples":
    "https://www.codevscolor.com/c-plus-plus-std-copy",
  "C++ array::fill() STL, standard template library explanation with example":
    "https://www.codevscolor.com/c-plus-plus-array-fill",
  "C++ program to invert all bits of a bitset variable":
    "https://www.codevscolor.com/c-plus-plus-invert-bits",
  "How to find the sum of two complex numbers in C++":
    "https://www.codevscolor.com/c-plus-plus-find-sum-two-complex-numbers",
  "3 different C++ programs to find the last index of a character in a string":
    "https://www.codevscolor.com/c-plus-plus-find-last-index-character-in-string",
  "C++ program to print a multiplication table from 1 to n":
    "https://www.codevscolor.com/c-plus-plus-print-multiplication-table",
  "C++ program to print a Pascal's triangle":
    "https://www.codevscolor.com/c-plus-plus-print-pascals-triangle",
  "Binary Search in C++ STL (Standard template library)":
    "https://www.codevscolor.com/c-plus-plus-stl-binary-search",
  "How to use std::move() in C++ to move numbers from one array to another":
    "https://www.codevscolor.com/c-plus-plus-std-move",
  "C++ STL std::replace() function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-std-replace",
  "C++ proram to find the difference between two time periods using Structure":
    "https://www.codevscolor.com/c-plus-plus-find-time-difference-using-structure",
  "How to find the sum of two distances in inch and feet in C++":
    "https://www.codevscolor.com/c-plus-plus-find-sum-two-distances",
  "C++ program to count no of positive, negative and zero from a list of numbers":
    "https://www.codevscolor.com/cpp-count-positive-negative-zero-from-list-numbers",
  "C++ program to print a rectangle using star or any other character":
    "https://www.codevscolor.com/c-plus-plus-print-a-rectangle",
  "C++ program to format a phone number":
    "https://www.codevscolor.com/c-plus-plus-format-phone-number",
  "C++ program to create a simple calculator program":
    "https://www.codevscolor.com/c-plus-plus-simple-calculator-program",
  "C++ program to find the first digit of the factorial of a number":
    "https://www.codevscolor.com/c-plus-plus-find-first-digit-of-factorial",
  "C++ program to print the rightmost digit of a number":
    "https://www.codevscolor.com/c-plus-plus-print-rightmost-digit-number",
  "C++ program to add two numbers":
    "https://www.codevscolor.com/c-plus-plus-add-two-numbers",
  "C++ program to print Fibonacci series":
    "https://www.codevscolor.com/c-plus-plus-print-fibonacci-series",
  "C++ program to check if two arrays hold the same values":
    "https://www.codevscolor.com/c-plus-plus-check-two-arrays-equal",
  "C++ to find the factorial of a number using class":
    "https://www.codevscolor.com/c-plus-plus-find-factorial-class",
  "C++ program to find the largest of four numbers using class":
    "https://www.codevscolor.com/c-plus-plus-find-largest-four-numbers-using-class",
  "C++ STL find() explanation with example":
    "https://www.codevscolor.com/c-plus-plus-stl-find",
  "C++ program to convert octal value to decimal":
    "https://www.codevscolor.com/c-plus-plus-octal-decimal-conversion",
  "How to print a full pyramid in C++":
    "https://www.codevscolor.com/c-plus-plus-print-full-pyramid",
  "How to print an inverted pyramid in C++":
    "https://www.codevscolor.com/c-plus-plus-print-inverted-pyramid",
  "C++ program to find the GCD of two numbers":
    "https://www.codevscolor.com/c-plus-plus-gcd-numbers",
  "C++ program to find the nth even number":
    "https://www.codevscolor.com/c-plus-plus-find-nth-even-number",
  "C++ program to find the nth odd Fibonacci number":
    "https://www.codevscolor.com/c-plus-plus-find-nth-odd-fibonacci-number",
  "C++ program to remove all numbers from a string":
    "https://www.codevscolor.com/c-plus-plus-remove-all-numbers-string",
  "C++ how to find the smallest of three numbers":
    "https://www.codevscolor.com/c-plus-plus-find-smallest-three-numbers",
  "C++ program to find the total number of characters in a string":
    "https://www.codevscolor.com/c-plus-plus-find-characters-in-string",
  "C++ isblank function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-isblank-example",
  "C++ program to check if a character is a punctuation using ispunct":
    "https://www.codevscolor.com/c-plus-plus-ispunct-example",
  "C++ program to check if a character is a hexadecimal using isxdigit":
    "https://www.codevscolor.com/c-plus-plus-isxdigit-example",
  "C++ check if a character is alphabetic using isalpha":
    "https://www.codevscolor.com/c-plus-plus-check-character-alphabetic",
  "C++ program to pass a structure to a function":
    "https://www.codevscolor.com/c-plus-plus-pass-structure-function",
  "How to run a C++ program in XCode in Mac":
    "https://www.codevscolor.com/c-plus-plus-run-xcode",
  "C++ program to convert a decimal value to hexadecimal":
    "https://www.codevscolor.com/c-plus-plus-decimal-to-hexadecimal",
  "C++ find the sum of digits of a number until a single digit is obtained":
    "https://www.codevscolor.com/c-plus-plus-sum-of-digits-until-single-digit",
  "C++ program to find the nearest smaller number to the left side in an array":
    "https://www.codevscolor.com/c-plus-plus-find-nearest-smaller-left-side-array",
  "C++ program to return an array from a function using a structure":
    "https://www.codevscolor.com/c-plus-plus-return-array-function-using-structure",
  "3 ways to Compare two strings in C++ ignoring case":
    "https://www.codevscolor.com/c-plus-plus-compare-strings-ignoring-case",
  "emplace_back method in C++ explanation with example":
    "https://www.codevscolor.com/emplace-back-c-plus-plus",
  "C++ program to find LCM using a separate function":
    "https://www.codevscolor.com/c-plus-plus-find-lcm-using-function",
  "C++ program to find if n factorial is divisible by sum of first n numbers or not":
    "https://www.codevscolor.com/c-plus-plus-find-n-factorial-divisible-by-sum-first-n",
  "How to append characters from a string to another string in C++":
    "https://www.codevscolor.com/c-plus-plus-append-characters-from-string-to-another-string",
  "C++ program to locate a character in a string using strpbrk":
    "https://www.codevscolor.com/c-plus-plus-locate-character-in-string",
  "C++ program to compare two strings using memcmp":
    "https://www.codevscolor.com/c-plus-plus-compare-strings-memcmp",
  "C++ program to copy from one array to another using memcpy":
    "https://www.codevscolor.com/c-plus-plus-copy-array-memcpy",
  "C++ program to merge two arrays into one array":
    "https://www.codevscolor.com/c-plus-plus-merge-two-arrays-to-one-array",
  "C++ example program to move a block of memory":
    "https://www.codevscolor.com/c-plus-plus-move-block-memory",
  "C++ setw function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-setw-function",
  "How to swap two numbers using pointer in C++":
    "https://www.codevscolor.com/c-plus-plus-swap-two-numbers-using-pointer",
  "C++ setfill method example":
    "https://www.codevscolor.com/c-plus-plus-setfill-method",
  "C++ program to convert 12 hours to 24 hours time format":
    "https://www.codevscolor.com/c-plus-plus-convert-twelve-twenty-four-hours",
  "How to find compound interest in C++":
    "https://www.codevscolor.com/c-plus-plus-find-compound-interest",
  "C++ program to Print all even numbers from 1 to 100":
    "https://www.codevscolor.com/c-plus-plus-print-even-numbers-one-hundred",
  "How to find the cube of a number using Macros in C++":
    "https://www.codevscolor.com/c-plus-plus-find-cube-number-using-macros",
  "C++ program to find the square root of a number by using sqrt":
    "https://www.codevscolor.com/c-plus-plus-find-square-root",
  "std::reverse() method in C++ explanation with example":
    "https://www.codevscolor.com/c-plus-plus-std-reverse",
  "How to use ternary operator in C++":
    "https://www.codevscolor.com/c-plus-plus-ternary-operator",
  "Implement bubble sort in C++":
    "https://www.codevscolor.com/c-plus-plus-bubble-sort",
  "C++ program to print all odd numbers from 1 to 100":
    "https://www.codevscolor.com/c-plus-plus-print-odd-numbers",
  "C++ program to check if a number is divisible by 5 and 11":
    "https://www.codevscolor.com/c-plus-plus-check-number-divisible-by-five-eleven",
  "C++ program to find the sum of 1 + 1/2 + 1/3 + 1/4+....n":
    "https://www.codevscolor.com/c-plus-plus-find-sum-harmonic-progression-series",
  "C++ program to print 1 to 100 in different ways":
    "https://www.codevscolor.com/c-plus-plus-print-one-hundred",
  "fabs and abs methods in C++ explanation with example":
    "https://www.codevscolor.com/c-plus-plus-abs-fabs",
  "C++ program to check if a number is greater than another by using isgreater":
    "https://www.codevscolor.com/c-plus-plus-check-number-greater-than-isgreater",
  "C++ cmath isless function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-cmath-isless",
  "C++ program to print the prime factors of a number":
    "https://www.codevscolor.com/c-plus-plus-print-prime-factors-number",
  "C++ program to print A to Z in different ways":
    "https://www.codevscolor.com/c-plus-plus-print-a-to-z",
  "C++ program to print from a to z in different ways":
    "https://www.codevscolor.com/c-plus-plus-print-a-to-z-small-case",
  "C++ program to find the sum of ASCII values of all characters of a string":
    "https://www.codevscolor.com/c-plus-plus-find-sum-ascii-characters-string",
  "C++ program to add a character at the end of the string by using push_back function":
    "https://www.codevscolor.com/c-plus-plus-add-characters-to-string-end-push-back",
  "C++ program to convert ASCII to character":
    "https://www.codevscolor.com/c-plus-plus-convert-ascii-to-character",
  "C++ program to convert binary to decimal":
    "https://www.codevscolor.com/c-plus-plus-convert-binary-to-decimal",
  "3 different C++ program to convert integer to string":
    "https://www.codevscolor.com/c-plus-plus-convert-integer-to-string",
  "C++ Increment and decrement operators":
    "https://www.codevscolor.com/c-plus-plus-increment-decrement-operators",
  "How to find the sum of two numbers by using a class in C++":
    "https://www.codevscolor.com/c-plus-plus-find-sum-two-numbers-using-class",
  "C++ and or && operator explanation with example":
    "https://www.codevscolor.com/c-plus-plus-and-operator-example",
  "C++ program to convert lowercase to uppercase":
    "https://www.codevscolor.com/c-plus-plus-convert-lowercase-to-uppercase",
  "How to use logical not operator,! operator in C++":
    "https://www.codevscolor.com/c-plus-plus-logical-not-operator",
  "How to use logical OR operator,|| operator in C++":
    "https://www.codevscolor.com/c-plus-plus-logical-or-operator",
  "C++ fill_n() function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-fill-n-example",
  "C++ iswlower() method explanation with example":
    "https://www.codevscolor.com/c-plus-plus-iswlower-example",
  "C++ iswupper() method explanation with example":
    "https://www.codevscolor.com/c-plus-plus-iswupper-example",
  "C++ program to convert miles to kilometers and kilometers to miles":
    "https://www.codevscolor.com/c-plus-plus-convert-miles-to-kilometers-kilometers-miles",
  "C++ program to sort strings alphabetically":
    "https://www.codevscolor.com/c-plus-plus-sort-strings-alphabetically",
  "C++ program to addition, subtraction, multiplication and division using a class":
    "https://www.codevscolor.com/c-plus-plus-addition-subtraction-multiplication-division-class",
  "C++ program to print the characters of a string using pointer":
    "https://www.codevscolor.com/c-plus-plus-print-string-characters-using-pointer",
  "C++ program to find the average of three numbers":
    "https://www.codevscolor.com/c-plus-plus-average-three-numbers",
  "How to add elements to the end of a vector in C++ using push_back":
    "https://www.codevscolor.com/c-plus-plus-add-elements-end-of-vector-push-back",
  "8 Different ways to initialize a vector in C++":
    "https://www.codevscolor.com/c-plus-plus-different-ways-to-initialize-vector",
  "Introduction to Vector containers in C++ STL":
    "https://www.codevscolor.com/c-plus-plus-introduction-vector-containers",
  "How to access an element of a vector using index in C++":
    "https://www.codevscolor.com/c-plus-plus-access-element-of-vector",
  "C++ program to check if a number is even or odd":
    "https://www.codevscolor.com/c-plus-plus-check-number-even-odd",
  "C++ program to print a right-angled number Pyramid":
    "https://www.codevscolor.com/c-plus-plus-right-angled-number-pyramid",
  "C++ program to print right-angled right-oriented pyramid of numbers":
    "https://www.codevscolor.com/c-plus-plus-right-angled-right-oriented-pyramid-numbers",
  "4 ways in C++ to concatenate two strings":
    "https://www.codevscolor.com/c-plus-plus-concatenate-two-strings",
  "C++ program to create multiple objects of a class":
    "https://www.codevscolor.com/c-plus-plus-create-multiple-objects-of-class",
  "delete vs free in C++":
    "https://www.codevscolor.com/c-plus-plus-delete-vs-free",
  "C++ program to calculate discounted price":
    "https://www.codevscolor.com/c-plus-plus-calculate-discounted-price",
  "C++ isdigit() function explanation with example":
    "https://www.codevscolor.com/c-plus-plus-isdigit",
  "C++ program to convert a hexadecimal value to binary":
    "https://www.codevscolor.com/c-plus-plus-convert-hexadecimal-to-binary",
  "C++ STL accumulate method explanation with example":
    "https://www.codevscolor.com/c-plus-plus-stl-accumulate",
  "C++ program to convert hexadecimal to decimal":
    "https://www.codevscolor.com/c-plus-plus-convert-hexadecimal-to-decimal",
  "C++ program to find the sum of the first and last digits of a number":
    "https://www.codevscolor.com/c-plus-plus-find-sum-first-last-digits-number",
  "C++ program to find all prime numbers to n using sieve of Eratosthenes algorithm":
    "https://www.codevscolor.com/c-plus-plus-sieve-of-eratosthenes",
  "C++ program to print all subsets of a set":
    "https://www.codevscolor.com/c-plus-plus-print-subset-of-set",
  "How to sort an array in ascending order in C++":
    "https://www.codevscolor.com/c-plus-plus-sort-array-ascending",
  "C++ program to solve a quadratic equation in different ways":
    "https://www.codevscolor.com/c-plus-plus-solve-quadratic-equation",
  "3 ways to find the exponent without using pow() method in C++":
    "https://www.codevscolor.com/c-plus-plus-exponent-without-pow",
  "3 different C++ programs to find electricity bill with user given units":
    "https://www.codevscolor.com/c-plus-plus-find-electricity-bill",
  "2 different C++ program to check if a number is spy number or not":
    "https://www.codevscolor.com/c-plus-plus-check-spy-number",
  "C++ program to insert an element to an array at any position":
    "https://www.codevscolor.com/c-plus-plus-insert-element-array",
  "C++ program to find the volume of a cylinder in 3 different ways":
    "https://www.codevscolor.com/c-plus-plus-find-volume-cylinder",
  "C++ program to find the sum of two numbers using friend function":
    "https://www.codevscolor.com/c-plus-plus-find-sum-friend-function",
  "C++ program to print the days of the week by using switch case":
    "https://www.codevscolor.com/c-plus-plus-print-days-of-week",
  "C++ program to find the area of a rectangle":
    "https://www.codevscolor.com/c-plus-plus-find-rectangle-area",
  "C++ program to add the content of two arrays":
    "https://www.codevscolor.com/c-plus-plus-add-arrays",
  "C++ program to convert pounds to kilogram":
    "https://www.codevscolor.com/c-plus-plus-pounds-to-kilogram",
  "C++ program to print a diamond shape star pattern":
    "https://www.codevscolor.com/c-plus-plus-print-diamond-shape",
  "2 different C++ program to copy the content of one file to another":
    "https://www.codevscolor.com/c-plus-plus-copy-content-one-file-another",
  "2 different C++ programs to implement selection sort":
    "https://www.codevscolor.com/c-plus-plus-implement-selection-sort",
  "C++ program to implement linear search":
    "https://www.codevscolor.com/c-plus-plus-implement-linear-search",
  "C++ program to convert a decimal value to octal":
    "https://www.codevscolor.com/c-plus-plus-convert-decimal-value-to-octal",
  "C++ program to check if a number is a Magic number in 3 ways":
    "https://www.codevscolor.com/c-plus-plus-check-magic-number",
  "C++ class destructor explanation with examples":
    "https://www.codevscolor.com/c-plus-plus-destructor",
  "C++ program to find the smallest and the second smallest numbers":
    "https://www.codevscolor.com/c-plus-plus-smallest-second-smallest",
};
export const c = {
  "C program to print the ASCII value of a character":
    "https://www.codevscolor.com/c-program-print-ascii-character",
  "C program to find if two numbers are Amicable or not":
    "https://www.codevscolor.com/c-program-find-two-numbers-amicable",
  "C program to check if a string is palindrome or not":
    "https://www.codevscolor.com/c-program-check-string-palindrome-not",
  "C program to find the surface area of a cube":
    "https://www.codevscolor.com/c-program-find-surface-area-cube",
  "C program to check if a number is magic number or not":
    "https://www.codevscolor.com/c-program-check-magic-number",
  "C program to find the factorial of a number using recursion":
    "https://www.codevscolor.com/c-find-factorial-using-recursion",
  "C program to find the maximum and minimum number in an array":
    "https://www.codevscolor.com/c-program-find-maximum-minimum-number-array",
  "C program to check if two strings are equal or not":
    "https://www.codevscolor.com/c-program-check-two-strings-equal-not",
  "C program to print fibonacci series using recursion":
    "https://www.codevscolor.com/c-program-print-fibonacci-series-using-recursion",
  "C program to find the third angle of a triangle if other two are given":
    "https://www.codevscolor.com/c-program-find-third-angle-triangle",
  "C program to separate even and odd numbers from an array":
    "https://www.codevscolor.com/c-program-separate-even-odd-numbers-array",
  "C program to remove the vowels from a string":
    "https://www.codevscolor.com/c-program-remove-vowels-from-string",
  "C program to find the power of a number using loop":
    "https://www.codevscolor.com/c-program-find-power-number-using-loop",
  "C program to calculate the total number of lines in a file":
    "https://www.codevscolor.com/c-program-calculate-total-number-lines-file",
  "C program to check if a year is leap year or not":
    "https://www.codevscolor.com/c-program-check-year-leap-year-not",
  "C program to count number of 1 using Brian Kernighan’s Algorithm":
    "https://www.codevscolor.com/c-count-number-1-binary",
  "C program to find the remainder without using modulo operator":
    "https://www.codevscolor.com/c-remainder-without-modulo-operator",
  "C program to add two numbers using their addresses":
    "https://www.codevscolor.com/c-program-add-using-address",
  "C program to calculate profit or loss":
    "https://www.codevscolor.com/c-program-calculate-profit-or-loss",
  "C program to print pyramid using star or any other character":
    "https://www.codevscolor.com/c-program-print-pyramid-star",
  "C program to find the sum of ‘n’ numbers using dynamic memory allocation":
    "https://www.codevscolor.com/c-find-sum-n-numbers-dynamic",
  "C program to copy one string to another":
    "https://www.codevscolor.com/c-program-copy-one-string-another",
  "C program to print a diamond pattern using star or any character":
    "https://www.codevscolor.com/c-program-print-diamond-star",
  "C program to print all uppercase and lowercase letters in the alphabet":
    "https://www.codevscolor.com/c-print-uppercase-lowercase-letter",
  "C program to convert a decimal number to octal":
    "https://www.codevscolor.com/c-program-convert-decimal-number-octal",
  "Compare two strings in C using strcoll(":
    "https://www.codevscolor.com/compare-two-strings-c-using-strcoll",
  "C program to print alternate numbers of an user input array":
    "https://www.codevscolor.com/c-print-alternate-numbers-array",
  "C program to concatenate two strings without using strcat(":
    "https://www.codevscolor.com/c-program-concatenate-strings-without-strcat",
  "C program to swap two numbers using call by reference":
    "https://www.codevscolor.com/c-swap-numbers-call-by-reference",
  "C program to find the largest two numbers in a number array":
    "https://www.codevscolor.com/c-program-find-largest-two-numbers-array",
  "C program to check if a substring exists in a string or not":
    "https://www.codevscolor.com/c-check-if-substring-exists-in-string",
  "C program to check if a number is a perfect number or not":
    "https://www.codevscolor.com/c-program-check-perfect-number",
  "C program to check if a number is Pronic or not":
    "https://www.codevscolor.com/c-program-check-number-pronic-not",
  "C program compare two numbers without using if-else":
    "https://www.codevscolor.com/c-program-compare-two-numbers-without-if-else",
  "C program to convert seconds into hour/minute/seconds":
    "https://www.codevscolor.com/c-program-convert-seconds-hour-minute-seconds",
  "C program tutorial to swap two strings":
    "https://www.codevscolor.com/c-program-tutorial-swap-two-strings",
  "C program to swap adjacent elements of a one-dimensional array":
    "https://www.codevscolor.com/c-swap-adjacent-elements-one-dimensional-array",
  "C program to swap two numbers using bitwise XOR operation":
    "https://www.codevscolor.com/c-swap-numbers-using-xor-operation",
  "C program to find the sum of first n odd numbers starting from 1":
    "https://www.codevscolor.com/c-program-find-sum-n-odd-numbers",
  "C program to remove all characters from a string keeping all numbers":
    "https://www.codevscolor.com/c-remove-characters-string-keeping-numbers",
  "C program to sort characters in a string as per their ASCII values":
    "https://www.codevscolor.com/c-sort-characters-string-ascii-values",
  "C program to reverse a user input integer array":
    "https://www.codevscolor.com/c-program-reverse-integer-array",
  "C program to print from 1 to N using recursive main function":
    "https://www.codevscolor.com/c-print-1-n-recursive-main",
  "C program to print a square table of a number using pow(":
    "https://www.codevscolor.com/c-print-square-table-pow",
  "C program to print a right angled triangle using numbers":
    "https://www.codevscolor.com/c-print-number-right-angle-triangle",
  "C program to print or format a number to words":
    "https://www.codevscolor.com/c-print-number-words",
  "C program to print a string without using semicolon in the printf":
    "https://www.codevscolor.com/c-print-string-without-semicolon-printf",
  "C program to print elements of an array and address of each element":
    "https://www.codevscolor.com/c-print-elements-array-address-each-element",
  "C program to print the addition table for a number":
    "https://www.codevscolor.com/c-print-addition-table-number",
  "C program to calculate the sum of positive/negative numbers in an array":
    "https://www.codevscolor.com/c-calculate-sum-array-positive-negative-numbers",
  "Nested printf statement in C with examples":
    "https://www.codevscolor.com/c-nested-printf",
  "Insertion sort implementation in C : Sorting an integer array":
    "https://www.codevscolor.com/c-insertion-sort-implementation",
  "C program to find the total digits in a number":
    "https://www.codevscolor.com/c-find-total-digits-number",
  "C program to find the length of a string":
    "https://www.codevscolor.com/c-program-find-length-string",
  "C program to find the last vowel in a string":
    "https://www.codevscolor.com/c-find-last-vowel-in-string",
  "C program to find the first and the last position of a character in a string":
    "https://www.codevscolor.com/c-find-first-last-position-character-string",
  "C program to find the first vowel in a user input string":
    "https://www.codevscolor.com/c-program-find-first-vowel-string",
  "C program to get the first uppercase letter in a string":
    "https://www.codevscolor.com/c-program-first-uppercase-letter-string",
  "C program to find the first non repeating character in a string":
    "https://www.codevscolor.com/c-find-first-non-repeating-character-string",
  "C program to ask the user to select a number within a range":
    "https://www.codevscolor.com/c-select-number-within-range",
  "C programming example to check if two strings are anagram or not":
    "https://www.codevscolor.com/c-check-strings-anagram",
  "C program to print the current time, day, month, and year":
    "https://www.codevscolor.com/c-print-current-time-day-month-year",
  "C program to pass different types of arguments to a function":
    "https://www.codevscolor.com/c-program-pass-different-arguments-function",
  "C program to explain how fmod and modf function works":
    "https://www.codevscolor.com/c-program-fmod-modf-function",
  "C program to create and iterate through a linked list":
    "https://www.codevscolor.com/c-program-create-iterate-linked-list",
  "C program tutorial to print a number pattern":
    "https://www.codevscolor.com/c-program-print-number-square-rectangle-pattern",
  "C program to print from A to Z with lower and upper case alternatively":
    "https://www.codevscolor.com/c-program-print-a-z-alternate-case",
  "C program to remove the first character of each word of a string":
    "https://www.codevscolor.com/c-remove-first-character-string",
  "C program to print a star or X pattern using any character":
    "https://www.codevscolor.com/c-program-star-x-pattern",
  "C program number pattern example for beginner":
    "https://www.codevscolor.com/c-program-number-pattern",
  "C program to remove the head node or first node from a linked list":
    "https://www.codevscolor.com/c-program-remove-head-first-node-linked-list",
  "C programming structure explanation with example":
    "https://www.codevscolor.com/c-programming-structure-basics",
  "C program to find total number of sub-array with product less than a value":
    "https://www.codevscolor.com/c-program-find-total-sub-array-less-than-value",
  "C program to find total lowercase,uppercase,digits etc in a string":
    "https://www.codevscolor.com/c-program-lowercase-uppercase-digits-special-characters",
  "C program to read user input and store them in two dimensional array":
    "https://www.codevscolor.com/c-program-read-store-two-dimensional-array",
  "C programming tutorial to learn atof, atoi and atol functions":
    "https://www.codevscolor.com/c-atof-atoi-atol-function",
  "What is auto variable in C and how it works":
    "https://www.codevscolor.com/auto-variable-in-c",
  "Find ‘sin’ ‘cos’ and ‘tan’ values of a ‘degree’ in C":
    "https://www.codevscolor.com/c-program-find-sin-cos-tan-values-of-degree",
  "C programming example to print the source code of the current program":
    "https://www.codevscolor.com/c-program-example-print-source-code",
  "C program to check if a number is positive,negative or zero using macros":
    "https://www.codevscolor.com/c-program-check-positive-negative-zero-macro",
  "C program to read the contents of a file character by character":
    "https://www.codevscolor.com/c-program-read-file-contents-character",
  "How to use strchr to print substring starting from a specific character":
    "https://www.codevscolor.com/c-strchr-example",
  "fabs function in C with example":
    "https://www.codevscolor.com/c-fabs-function",
  "C program to check if a number is palindrome or not":
    "https://www.codevscolor.com/c-check-palindrome-number",
  "C program to find compound interest using user input values":
    "https://www.codevscolor.com/c-program-find-compound-interest",
  "C program to find out the palindrome number in a range":
    "https://www.codevscolor.com/c-program-find-palindrome-in-range",
  "C program to count and print frequency of each letter in a word":
    "https://www.codevscolor.com/c-count-print-frequency-letter-in-word",
  "C program to calculate simple interest":
    "https://www.codevscolor.com/c-find-simple-interest",
  "C program to insert an element in an array at any specific position":
    "https://www.codevscolor.com/c-insert-element-array-specific-position",
  "C program to check if a number is in a range with one line":
    "https://www.codevscolor.com/c-check-number-in-range",
  "C program to print two arrays using a separate function":
    "https://www.codevscolor.com/c-print-two-arrays-using-function",
  "Swap two numbers without using a third number using a macro in C":
    "https://www.codevscolor.com/swap-two-numbers-using-macro-in-c",
  "C program to print a random number in a range":
    "https://www.codevscolor.com/c-program-print-random-number-range",
  "C program to check if a number is even or odd using bitwise operator":
    "https://www.codevscolor.com/c-check-even-odd-using-bitwise-operator",
  "C program to print half right angled triangle or half pyramid":
    "https://www.codevscolor.com/c-print-half-pyramid-right-angle-triangle",
  "C program to remove one specific element from an array":
    "https://www.codevscolor.com/c-program-remove-one-specific-element-from-array",
  "Write a C program to draw spiral two column number pattern":
    "https://www.codevscolor.com/c-program-draw-spiral-two-column-number-pattern",
  "C program to count even and odd numbers in a user input array":
    "https://www.codevscolor.com/c-program-count-odd-even-numbers-array",
  "How to write a multi-line Macro in C":
    "https://www.codevscolor.com/c-multi-line-macro",
  "C program to sort array in ascending or descending order using pointer":
    "https://www.codevscolor.com/c-program-sort-array-using-pointer",
  "perror function in C explanation with example":
    "https://www.codevscolor.com/perror-function-c-explanation-with-example",
  "C program to pass a two-dimensional array to a different function":
    "https://www.codevscolor.com/c-pass-two-dimensional-array",
  "C program to reverse an user provided number":
    "https://www.codevscolor.com/c-reverse-number",
  "C program to find the sum of A.P. series":
    "https://www.codevscolor.com/c-find-sum-arithmetic-progression-ap",
  "C program to print all combinations of three numbers":
    "https://www.codevscolor.com/c-combination-three-numbers",
  "C program to print the ASCII values of all lowercase characters":
    "https://www.codevscolor.com/c-print-ascii-characters",
  "C program to find the length of a linked list recursively":
    "https://www.codevscolor.com/c-find-length-linked-list",
  "C program to compare two strings using strcmp":
    "https://www.codevscolor.com/c-compare-strings-strcmp",
  "Use pointer to find the largest of three numbers in C":
    "https://www.codevscolor.com/c-find-largest-three-using-pointer",
  "C program to find the nth fibonacci number":
    "https://www.codevscolor.com/c-find-n-fibonacci-number",
  "C program to print Floyd’s triangle":
    "https://www.codevscolor.com/c-program-floyd-triangle",
  "How to print a pascal’s triangle in C with explanation":
    "https://www.codevscolor.com/c-print-pascal-triangle",
  "C strrchr library function explanation with example":
    "https://www.codevscolor.com/c-strrchr-example",
  "C strspn function explanation with examples":
    "https://www.codevscolor.com/c-strspn-example",
  "C program to find the square and cube of a number":
    "https://www.codevscolor.com/c-find-square-cube-number",
  "Logical operators in C with example":
    "https://www.codevscolor.com/c-logical-operator",
  "C program to print a new line without using \n":
    "https://www.codevscolor.com/c-print-new-line-without-n",
  "Logical OR operator explanation with example in C":
    "https://www.codevscolor.com/c-logical-or",
  "C program to convert meter to yard":
    "https://www.codevscolor.com/c-convert-meter-to-yard",
  "C example program to add numbers to an array":
    "https://www.codevscolor.com/c-program-add-numbers-array",
  "C program to print the length of each words in a string":
    "https://www.codevscolor.com/c-print-string-word-length",
  "C program to read user input string and print each word in a new line":
    "https://www.codevscolor.com/c-program-read-print-string-word-new-line",
  "C program to calculate the area of a rectangle":
    "https://www.codevscolor.com/c-calculate-area-rectangle",
  "5 different ways to find the volume of a cube in C":
    "https://www.codevscolor.com/c-find-volume-cube",
  "C toUpper( method explanation with example":
    "https://www.codevscolor.com/c-toupper-method-explanation-with-example",
  "C program to check if a character is white-space or not":
    "https://www.codevscolor.com/c-check-character-white-space",
  "C program to read contents of a file and print all characters in uppercase":
    "https://www.codevscolor.com/c-read-print-file-content-uppercase",
  "How to get the length of an array in C":
    "https://www.codevscolor.com/c-get-array-length",
  "Write a C program to find the frequency of vowels in a string":
    "https://www.codevscolor.com/c-program-find-vowel-frequency",
  "How to skip characters with scanf() in C":
    "https://www.codevscolor.com/c-skip-characters-with-scanf",
  "What is memset function in C and how it works":
    "https://www.codevscolor.com/c-memset-example",
  "C program to arrange numbers in ascending order":
    "https://www.codevscolor.com/c-arrange-numbers-ascending",
  "How to print double quotes in C using printf":
    "https://www.codevscolor.com/c-print-double-quotes",
  "C program to find the GCD of two user given numbers in 2 different ways":
    "https://www.codevscolor.com/c-find-gcd",
  "C program to convert Celsius to Fahrenheit":
    "https://www.codevscolor.com/c-convert-celsius-to-fahrenheit",
  "C program to read and write hexadecimal values":
    "https://www.codevscolor.com/c-read-write-hexadecimal",
  "Use switch case to find the number of days in a month in C":
    "https://www.codevscolor.com/c-find-number-days-in-month",
  "C program to sort names or strings in alphabetical order":
    "https://www.codevscolor.com/c-sort-string-names",
  "C program to print the current hour, minute and second values":
    "https://www.codevscolor.com/c-print-current-hour-minute-second",
  "C program to print multiplication table using goto statement":
    "https://www.codevscolor.com/c-print-multiplication-table-using-goto",
  "How can we access global variables in C":
    "https://www.codevscolor.com/c-global-variables",
  "C program to convert decimal to hexadecimal value":
    "https://www.codevscolor.com/c-convert-decimal-to-hexadecimal",
  "C program to check if a Hexadecimal number is even or odd":
    "https://www.codevscolor.com/c-check-hexadecimal-even-odd",
  "Escape sequence in C explanation with example":
    "https://www.codevscolor.com/c-escape-sequence",
  "C logical AND, && explanation with examples":
    "https://www.codevscolor.com/c-logical-and",
  "C program to find the ceiling of a number in a sorted array":
    "https://www.codevscolor.com/c-find-ceiling-number-in-sorted-array",
  "C program to convert a string to uppercase or capitalize all characters":
    "https://www.codevscolor.com/c-convert-string-to-uppercase",
  "C program to check if a character is a vowel or consonant":
    "https://www.codevscolor.com/c-check-character-vowel-consonant",
  "C program to print squares and cubes of all numbers from 1 to n":
    "https://www.codevscolor.com/c-print-square-cubes-numbers-1-n",
  "How to declare a variable dynamically in C":
    "https://www.codevscolor.com/c-declare-variable-dynamically",
  "Difference between %d and %i format specifiers in C":
    "https://www.codevscolor.com/c-difference-d-i",
  "Write a C program to add two distances using structure":
    "https://www.codevscolor.com/c-add-distances-structure",
  "Example of fseek() in C":
    "https://www.codevscolor.com/c-file-fseek-operation",
  "C program to find the missing number in an array":
    "https://www.codevscolor.com/c-find-missing-number-array",
  "C program to read numbers from a file and store them in an array":
    "https://www.codevscolor.com/c-read-numbers-file-store-array",
  "C program find the sum of the harmonic progression":
    "https://www.codevscolor.com/c-sum-harmonic-progression",
  "Write a C program to convert an integer value to character":
    "https://www.codevscolor.com/c-convert-integer-to-character",
  "What is %p modifier in C programming":
    "https://www.codevscolor.com/c-percent-p-modifier",
  "C program to add two distances in feet and inches using structure":
    "https://www.codevscolor.com/c-program-add-distances-feet-inches-structure",
  "C program to print a name multiple times without using loop or function":
    "https://www.codevscolor.com/c-program-print-name-multiple-times-without-loop-function",
  "What is compilation and how compilation process works in C":
    "https://www.codevscolor.com/c-compilation-process",
  "C program to check if a string is empty or not":
    "https://www.codevscolor.com/c-program-check-string-empty",
  "How to find the LCM of two numbers in C":
    "https://www.codevscolor.com/c-find-lcm-numbers",
  "C program to check if a character is uppercase without using a library function":
    "https://www.codevscolor.com/c-program-check-character-uppercase-without-library",
  "fork() method explanation with example in C":
    "https://www.codevscolor.com/c-fork-example",
  "C program to reverse a string without using any library function(strrev)":
    "https://www.codevscolor.com/c-program-reverse-string-without-library-function",
  "How to use strstr in C with example":
    "https://www.codevscolor.com/c-strstr-example",
  "How to split a string in C using strtok library function":
    "https://www.codevscolor.com/c-split-string-strtok",
  "C program to print all words in a string ends with a specific character":
    "https://www.codevscolor.com/c-program-print-words-ends-with-specific-character",
  "C program to convert hour to minute and seconds value":
    "https://www.codevscolor.com/c-program-convert-hour-minute-seconds",
  "C nanosleep method explanation with example":
    "https://www.codevscolor.com/c-nanosleep-example",
  "How to delete an empty directory in C":
    "https://www.codevscolor.com/c-delete-empty-directory",
  "How to copy a file in C programming":
    "https://www.codevscolor.com/c-copy-file",
  "C getc and putc methods explanation with example":
    "https://www.codevscolor.com/c-getc-putc-example",
  "C program to find the hypotenuse of a right-angled triangle":
    "https://www.codevscolor.com/c-find-hypotenuse-right-angled-triangle",
  "C program to print all printable characters":
    "https://www.codevscolor.com/c-print-printable-characters",
  "How to read an octal value using scanf in C":
    "https://www.codevscolor.com/c-read-octal-using-scanf",
  "How to find the square root of a number in C":
    "https://www.codevscolor.com/c-find-square-root-of-number",
  "C program to read an unsigned integer value using scanf":
    "https://www.codevscolor.com/c-read-unsigned-integer-scanf",
  "C program to convert decimal to binary":
    "https://www.codevscolor.com/c-convert-decimal-to-binary",
  "C program to get the integer and fraction or decimal part":
    "https://www.codevscolor.com/c-program-get-integer-fraction-decimal-part",
  "C program to print all perfect numbers in a range":
    "https://www.codevscolor.com/c-program-print-perfect-numbers-in-range",
  "C fsetpos method explanation with example":
    "https://www.codevscolor.com/c-fsetpos-method",
  "C program to print a two-digit number to word":
    "https://www.codevscolor.com/c-program-print-two-digit-number-to-word",
  "How to find the income tax of an employee in C":
    "https://www.codevscolor.com/c-find-income-tax-of-employee",
  "C program to multiply two numbers using plus or addition operator":
    "https://www.codevscolor.com/c-multiply-numbers-using-plus-addition-operator",
  "C program to print the name using array":
    "https://www.codevscolor.com/c-print-name-using-array",
  "C program to save the output of a program to file":
    "https://www.codevscolor.com/c-program-save-output-file",
  "C program to store and display the details of an employee by using structure":
    "https://www.codevscolor.com/c-store-display-employee-details-structure",
  "C program to find the average runs of cricket players using structure":
    "https://www.codevscolor.com/c-program-find-average-runs-structure",
  "C program to convert a string to hexadecimal value":
    "https://www.codevscolor.com/c-convert-string-to-hexadecimal",
  "C program to swap two bits of a number":
    "https://www.codevscolor.com/c-program-swap-two-bits-of-number",
  "C program to find the number of lines, words and characters in a string":
    "https://www.codevscolor.com/c-find-lines-words-characters-in-string",
  "How to create a hollow diamond star pattern in C":
    "https://www.codevscolor.com/c-create-hollow-diamond-star-pattern",
  "C program to print the size of the longest word in a string":
    "https://www.codevscolor.com/c-program-print-longest-word-size-in-string",
  "How to print the longest word of a string in C":
    "https://www.codevscolor.com/c-print-longest-word-of-string",
  "C program to convert binary values to octal":
    "https://www.codevscolor.com/c-program-convert-binary-to-octal",
  "C program to check if a number is Neon or not":
    "https://www.codevscolor.com/c-program-check-neon-number",
  "C program to check if a number is a Strong number or not":
    "https://www.codevscolor.com/c-program-check-strong-number",
  "C program to keep reading inputs until -1 is received":
    "https://www.codevscolor.com/c-program-read-inputs-until-minus-one-received",
  "4 different C program to check if a number is Armstrong number or not":
    "https://www.codevscolor.com/c-check-number-is-armstrong",
  "Keywords in C explanation with examples":
    "https://www.codevscolor.com/c-keywords-example",
  "C program to reverse a positive and negative number recursively":
    "https://www.codevscolor.com/c-reverse-number-recursively",
  "C program to delete an element from an Array":
    "https://www.codevscolor.com/c-delete-element-from-array",
  "C program to find the median of an array":
    "https://www.codevscolor.com/c-program-find-median-array",
  "C program to print box pattern using a number or any other character":
    "https://www.codevscolor.com/c-program-print-box-star-number",
  "C itoa() function implementation explanation with example":
    "https://www.codevscolor.com/c-itoa-function",
  "C program to write and read structures to and from a file":
    "https://www.codevscolor.com/c-program-read-write-structure-file",
  "C program to check if a number is a disarium number or not":
    "https://www.codevscolor.com/c-program-check-number-disarium-number",
  "C program to check if a number is Abundant or Excessive":
    "https://www.codevscolor.com/c-program-check-number-abundant-excessive",
  "C program to find if a number is a Deficient number or not":
    "https://www.codevscolor.com/c-program-check-number-deficient",
  "C program isxdigit method example to check if a character is hexadecimal":
    "https://www.codevscolor.com/c-program-check-character-hexadecimal-isxdigit",
  "C program to find all Abundant numbers from 1 to 100":
    "https://www.codevscolor.com/c-program-find-abundant-numbers-in-range",
  "C program to check if a character is lowercase using islower":
    "https://www.codevscolor.com/c-program-check-if-character-lowercase-islower",
  "C program to check if a character is uppercase using isupper":
    "https://www.codevscolor.com/c-program-check-character-uppercase",
  "C program to print all Deficient numbers from 1 to 100":
    "https://www.codevscolor.com/c-program-print-deficient-numbers-one-hundred",
  "C program to find all disarium numbers from 1 to 100":
    "https://www.codevscolor.com/c-program-find-disarium-numbers-in-range",
  "C program to check if a number is a Kaprekar number or not":
    "https://www.codevscolor.com/c-check-if-number-is-kaprekar",
  "C library function gets() explanation with examples":
    "https://www.codevscolor.com/c-program-gets-explanation-example",
  "putchar() method explanation with example":
    "https://www.codevscolor.com/c-putchar-method-example",
  "typedef in C explanation with examples":
    "https://www.codevscolor.com/c-typedef-example",
  "C program to find the nth Armstrong number":
    "https://www.codevscolor.com/c-find-nth-armstrong-number",
  "5 different C programs to print all natural numbers from 1 to n":
    "https://www.codevscolor.com/c-print-natural-nos-one-n",
  "C program to find the sum of first n natural numbers":
    "https://www.codevscolor.com/c-find-sum-first-n-natural-numbers",
  "3 different C programs to find the sum of first n odd natural numbers":
    "https://www.codevscolor.com/c-find-sum-first-n-odd-natural-numbers",
  "3 different C programs to find the sum of first n even natural numbers":
    "https://www.codevscolor.com/c-find-sum-first-n-even-natural-numbers",
  "4 different ways to print the natural numbers in reverse order in C":
    "https://www.codevscolor.com/c-print-natural-numbers-reverse",
  "C program to find the first and the last digits of a number":
    "https://www.codevscolor.com/c-find-first-last-digits-number",
  "C program to find the sum of digits of a number":
    "https://www.codevscolor.com/c-find-sum-digits-number",
  "2 different C programs to draw a butterfly pattern":
    "https://www.codevscolor.com/c-print-butterfly-pattern",
  "2 different C programs to find the volume and surface area of a cylinder":
    "https://www.codevscolor.com/c-find-volume-surface-area-cylinder",
  "2 different C programs to print a triangle of prime numbers":
    "https://www.codevscolor.com/c-print-triangle-prime-numbers",
  "4 different C programs to check if a number is prime or not":
    "https://www.codevscolor.com/c-check-number-prime",
  "3 different C programs to find all prime numbers in a range":
    "https://www.codevscolor.com/c-find-all-prime-numbers-in-range",
  "3 ways to find the area and circumference of a circle in C":
    "https://www.codevscolor.com/c-find-area-circumference-circle",
  "3 different C program to check for spy number":
    "https://www.codevscolor.com/c-check-number-spy-or-not",
  "3 different C programs to convert kilometers to miles":
    "https://www.codevscolor.com/c-convert-kilometers-to-miles",
  "3 different C programs to print a half diamond star pattern":
    "https://www.codevscolor.com/c-print-half-diamond-star-pattern",
  "3 different C programs to print a hollow parallelogram star pattern":
    "https://www.codevscolor.com/c-print-hollow-parallelogram-star-pattern",
  "3 different C programs to print odd numbers between 1 to 100":
    "https://www.codevscolor.com/c-print-odd-numbers-one-hundred",
  "3 different C programs to print the grade of a student":
    "https://www.codevscolor.com/c-print-student-grade",
  "3 different C programs to print an inverted Pyramid pattern":
    "https://www.codevscolor.com/c-print-inverted-pyramid-pattern",
  "C program to print the multiplication table using do...while loop":
    "https://www.codevscolor.com/c-print-multiplication-table",
  "10 different alphabet pattern programs in C":
    "https://www.codevscolor.com/c-alphabet-pattern-programs",
  "C program to find the distance between two cities in different units":
    "https://www.codevscolor.com/c-find-distance-between-two-cities",
  "C program to subtract two user input numbers":
    "https://www.codevscolor.com/c-subtract-two-numbers",
  "C program to print the current date-time in different formats":
    "https://www.codevscolor.com/c-print-date-month-year",
  "C program to find the perimeter of a rectangle":
    "https://www.codevscolor.com/c-find-rectangle-perimeter",
  "C program to check if a character is an Alphabet or not":
    "https://www.codevscolor.com/c-check-character-alphabet",
  "C program to print an alphabet triangle with user-input height":
    "https://www.codevscolor.com/c-print-alphabet-triangle",
  "How to take user inputs with spaces in C":
    "https://www.codevscolor.com/c-take-user-inputs-with-spaces",
};
export const csharp = {
  "How to compare two strings in C sharp":
    "https://www.codevscolor.com/c-sharp-compare-two-strings",
  "How to build and run c sharp project from the terminal":
    "https://www.codevscolor.com/how-to-build-and-run-c-sharp-project-from-the-terminal",
  "How to reverse a string in C sharp":
    "https://www.codevscolor.com/reverse-string-c-sharp",
  "2 ways in C# to check odd even numbers":
    "https://www.codevscolor.com/c-sharp-check-odd-even-number",
  "C sharp program to check if a number is positive, negative or zero":
    "https://www.codevscolor.com/c-sharp-check-number-positive-or-negative",
  "C# program to find the area of a circle":
    "https://www.codevscolor.com/c-sharp-find-circle-area",
  "C# program to find the largest of three numbers":
    "https://www.codevscolor.com/c-sharp-find-largest-three-numbers",
  "C# program to find the largest and smallest numbers in an user given array":
    "https://www.codevscolor.com/c-sharp-find-smallest-largest-in-array",
  "C# program to find random numbers in a range":
    "https://www.codevscolor.com/c-sharp-find-random-numbers-in-range",
  "C# program to check if a number is Strong number or not":
    "https://www.codevscolor.com/c-sharp-check-if-number-strong",
  "Different ways in C# to find the factorial of a number":
    "https://www.codevscolor.com/c-sharp-find-factorial-number",
  "C# program to convert Celsius to Fahrenheit":
    "https://www.codevscolor.com/c-sharp-convert-celsius-to-fahrenheit",
  "C# program to convert Fahrenheit to Celsius":
    "https://www.codevscolor.com/c-sharp-convert-fahrenheit-to-celsius",
  "C# program to replace a string in another string":
    "https://www.codevscolor.com/c-sharp-replace-string-in-another-string",
  "C# program to change the case of entered character":
    "https://www.codevscolor.com/c-sharp-change-case-entered-character",
  "C# program to replace all commas with newline in a string":
    "https://www.codevscolor.com/c-sharp-replace-commas-with-newline-string",
  "C# program to compare two dates":
    "https://www.codevscolor.com/c-sharp-compare-two-dates",
  "C# program to find the largest of two numbers":
    "https://www.codevscolor.com/c-sharp-find-largest-two-numbers",
  "C# program to print the weekday using switch case":
    "https://www.codevscolor.com/c-sharp-print-weekday-using-switch",
  "3 different ways in C# to print a new line":
    "https://www.codevscolor.com/c-sharp-print-new-line",
  "2 ways to compare two characters in C#":
    "https://www.codevscolor.com/c-sharp-compare-two-characters",
  "C# program to swap two numbers using XOR":
    "https://www.codevscolor.com/c-sharp-swap-two-numbers-xor",
  "C# program to reverse a number":
    "https://www.codevscolor.com/c-sharp-reverse-number",
  "Ternary operators in C#":
    "https://www.codevscolor.com/c-sharp-ternary-operator",
  "C# program to check if a number is prime or not":
    "https://www.codevscolor.com/c-sharp-check-prime-number",
  "C# program to find the sum of all digits of a number":
    "https://www.codevscolor.com/c-sharp-find-sum-digits-number",
  "C# program to find a value in an array":
    "https://www.codevscolor.com/c-sharp-array-find-method",
  "C# program to sort an array":
    "https://www.codevscolor.com/c-sharp-sort-array",
  "C# array GetLength method explanation with example":
    "https://www.codevscolor.com/c-sharp-array-getlength",
  "C# program to delete an item from a HashTable":
    "https://www.codevscolor.com/c-sharp-delete-item-hashtable",
  "C# how to check if a HashTable is equal to another HashTable":
    "https://www.codevscolor.com/c-sharp-check-hashtable-equal",
  "C# how to check for a palindrome number":
    "https://www.codevscolor.com/c-sharp-check-palindrome-number",
  "C# program to find the sum of all even numbers below a given number":
    "https://www.codevscolor.com/c-sharp-find-sum-even-below-number",
  "C# program to find the sum of all odd numbers below a given number":
    "https://www.codevscolor.com/c-sharp-find-sum-odd-below-number",
  "C# program to print from 1 to 10 in different ways":
    "https://www.codevscolor.com/c-sharp-print-1-to-n",
  "C# program to iterate over the characters of a string":
    "https://www.codevscolor.com/c-sharp-iterate-string-characters",
  "C# program to find the sum of odd and even numbers in an array":
    "https://www.codevscolor.com/c-sharp-sum-odd-even-array",
  "C# program to get the substring of a string":
    "https://www.codevscolor.com/c-sharp-get-substring",
  "C# string Join method explanation with example":
    "https://www.codevscolor.com/c-sharp-string-join",
  "C# string Copy method explanation with example":
    "https://www.codevscolor.com/c-sharp-string-copy",
  "C# program to find the average of odd and even numbers in an array":
    "https://www.codevscolor.com/c-sharp-average-odd-even-array",
  "C# program to check if a string starts with a number or not":
    "https://www.codevscolor.com/c-sharp-check-string-starts-with-number",
  "How to list all files in a folder in C#":
    "https://www.codevscolor.com/c-sharp-list-files-in-folder",
  "C# program to count the total number of vowels in a string":
    "https://www.codevscolor.com/c-sharp-count-vowels-array",
  "C# program to print the Floyd's triangle":
    "https://www.codevscolor.com/c-sharp-print-floyds-triangle.png",
  "C# program to find the sum of all numbers from 1 to n":
    "https://www.codevscolor.com/c-sharp-find-sum-all-numbers-1-to-n",
  "Find the seconds and milliseconds time difference between two time in C#":
    "https://www.codevscolor.com/c-sharp-seconds-milliseconds-time-difference",
  "C# program to find the days, hours, minutes, and seconds between two dates":
    "https://www.codevscolor.com/c-sharp-print-days-hours-minutes-seconds-between-dates",
  "C# program to check if a character is in a string or not":
    "https://www.codevscolor.com/c-sharp-check-character-is-in-string",
  "How to find the area of a Triangle in C#":
    "https://www.codevscolor.com/c-sharp-find-area-of-triangle",
  "How to read float inputs in C#":
    "https://www.codevscolor.com/c-sharp-read-float-inputs",
  "C# program to find the maximum occurring character in a string":
    "https://www.codevscolor.com/c-sharp-find-maximum-occurring-character-in-string",
  "2 different C# program to check if all numbers in an array are even or odd":
    "https://www.codevscolor.com/c-sharp-check-all-array-numbers-even-odd",
  "C# program to check if an item exists in an array":
    "https://www.codevscolor.com/c-sharp-check-item-exists-in-array",
  "C# program to find the area and perimeter of a rectangle":
    "https://www.codevscolor.com/c-sharp-find-area-perimeter-rectangle",
  "C# program to find the index of an element in an array":
    "https://www.codevscolor.com/c-sharp-find-index-element-array",
  "C# program to remove duplicate characters from a string":
    "https://www.codevscolor.com/c-sharp-remove-duplicate-characters-from-string",
  "C# program to convert a string to byte array":
    "https://www.codevscolor.com/c-sharp-convert-string-to-byte-array",
  "C# program to find the area of a triangle":
    "https://www.codevscolor.com/c-sharp-find-area-triangle",
  "C# program to get the OS version using Environment class":
    "https://www.codevscolor.com/c-sharp-get-os-version-environment-class",
  "Introduction to for loop in C#":
    "https://www.codevscolor.com/c-sharp-introduction-for-loop",
  "C# DivRem method explanation with examples":
    "https://www.codevscolor.com/c-sharp-divrem-explanation-example",
  "C# isNullOrEmpty method explanation with examples":
    "https://www.codevscolor.com/c-sharp-divrem-explanation-example",
  "C# program to find the circumference of a circle":
    "https://www.codevscolor.com/c-sharp-find-circle-circumference",
  "C# program to get the first N characters of a string":
    "https://www.codevscolor.com/c-sharp-get-first-n-characters-string",
  "C# program to get the DateTime for the start of the week":
    "https://www.codevscolor.com/sc-sharp-get-datetime-start-week",
  "C# program to convert a double to integer":
    "https://www.codevscolor.com/c-sharp-convert-double-integer",
  "How to print tomorrow's datetime in C#":
    "https://www.codevscolor.com/c-sharp-print-tomorrow-datetime",
  "How to print yesterday's date in C#":
    "https://www.codevscolor.com/c-sharp-print-yesterday-date",
  "C# program to remove first n characters from a string":
    "https://www.codevscolor.com/c-sharp-remove-first-n-characters-from-string",
  "C# program to remove the last n characters from a string":
    "https://www.codevscolor.com/c-sharp-remove-last-n-characters-from-string",
  "C# string.ToLower method explanation with example":
    "https://www.codevscolor.com/c-sharp-string-tolower-example",
  "C# String.ToUpper method explanation with example":
    "https://www.codevscolor.com/c-sharp-string-toupper-example",
  "C# program to create an array of objects":
    "https://www.codevscolor.com/c-sharp-array-of-objects",
  "4 different C# programs to convert a decimal number to binary":
    "https://www.codevscolor.com/c-sharp-convert-decimal-binary",
  "C# program to convert a binary value to decimal":
    "https://www.codevscolor.com/c-sharp-convert-binary-to-decimal",
  "C# program to print the result of the division of two numbers":
    "https://www.codevscolor.com/c-sharp-find-result-dividing-two-numbers",
  "3 different C# programs to print the name and age of a user":
    "https://www.codevscolor.com/c-sharp-print-name-age-user",
  "3 ways in C# to find the sum and average of user input numbers":
    "https://www.codevscolor.com/c-sharp-find-sum-average-user-input-numbers",
  "4 ways to print the Fibonacci series in C#":
    "https://www.codevscolor.com/c-sharp-print-fibonacci-series",
  "4 ways in C# to find the sum of first n numbers of the Fibonacci series":
    "https://www.codevscolor.com/c-sharp-find-sum-fibonacci-series",
  "3 ways in C# to find the nth number of the Fibonacci series":
    "https://www.codevscolor.com/c-sharp-find-nth-number-fibonacci-series",
  "3 ways in C# to print the Arithmetic Progression or AP":
    "https://www.codevscolor.com/c-sharp-print-arithmetic-progression",
  "4 ways in C# to print the Geometric Progression or GP":
    "https://www.codevscolor.com/c-sharp-print-geometric-progression",
  "4 ways in C# to convert a hexadecimal value to Decimal":
    "https://www.codevscolor.com/c-sharp-convert-hexadecimal-to-decimal",
  "C# program to convert a string to a character array":
    "https://www.codevscolor.com/c-sharp-convert-string-to-character-array",
  "4 ways in C# to reverse an array":
    "https://www.codevscolor.com/c-sharp-reverse-array-examples",
  "How to get the length of an array in C#":
    "https://www.codevscolor.com/c-sharp-get-array-length",
  "3 ways in C# to remove elements from an array":
    "https://www.codevscolor.com/c-sharp-remove-array-elements-different-ways",
  "C# program to initialize an array of objects":
    "https://www.codevscolor.com/c-sharp-initialize-array-objects",
  "4 different C# ways to find the LCM of two numbers":
    "https://www.codevscolor.com/c-sharp-find-lcm-four-ways",
  "4 different C# program to find the HCF of two numbers":
    "https://www.codevscolor.com/c-sharp-find-hcf-four-ways",
  "4 different C# programs to convert decimal number to hexadecimal":
    "https://www.codevscolor.com/c-sharp-decimal-to-hexadecimal",
  "C# program to print the area and perimeter of a square":
    "https://www.codevscolor.com/c-sharp-print-area-perimeter-square",
  "3 ways in C# to print Fibonacci triangle":
    "https://www.codevscolor.com/c-sharp-print-fibonacci-triangle",
  "C# program to print a right-angled triangle using any character or number":
    "https://www.codevscolor.com/c-sharp-print-right-angled-triangle-character-number",
  "3 different C# program to print an inverted right-angled triangle":
    "https://www.codevscolor.com/c-sharp-print-inverted-right-angled-triangle",
  "Different ways in C# to print a hollow square pattern":
    "https://www.codevscolor.com/c-sharp-print-hollow-square-pattern",
  "C# program to print a star square pattern":
    "https://www.codevscolor.com/c-sharp-print-star-square-pattern",
  "Different ways in C# to print a cross pattern":
    "https://www.codevscolor.com/c-sharp-print-cross-pattern",
  "C# program to print a diamond pattern":
    "https://www.codevscolor.com/c-sharp-print-diamond-pattern",
  "4 ways to concatenate two arrays in C sharp":
    "https://www.codevscolor.com/c-sharp-concatenate-arrays",
  "C# program to print the Pascal's triangle with user input height":
    "https://www.codevscolor.com/c-sharp-print-pascals-triangle",
  "C# program to multiply two numbers in different ways":
    "https://www.codevscolor.com/c-sharp-multiply-two-numbers",
  "C# program to find Amicable numbers in two ways":
    "https://www.codevscolor.com/c-sharp-find-amicable-numbers",
  "C# program to extract all email addresses from a text file":
    "https://www.codevscolor.com/c-sharp-extract-email-file",
};
export const dart = {
  "Dart 2 programming language Writing your first program (Introduction":
    "https://www.codevscolor.com/dart-introduction",
  "Dart tutorial : How to use Boolean in Dart":
    "https://www.codevscolor.com/dart-tutorial-how-to-use-boolean-in-dart",
  "Compare two numbers using compareTo method in Dart":
    "https://www.codevscolor.com/dart-compare-two-numbers-compareto-method",
  "Dart number datatype : integers and double":
    "https://www.codevscolor.com/dart-number-integer-double",
  "Dart tutorial : string (explanation with examples":
    "https://www.codevscolor.com/dart-tutorial-string-example",
  "Convert all characters of a string to uppercase or lowercase in dart":
    "https://www.codevscolor.com/convert-character-string-uppercase-lowercase",
  "Dart 2 tutorial : Variables in dart with example":
    "https://www.codevscolor.com/dart-variables-tutorial-example",
  "How to convert a string to DateTime and DateTime to ISO8601 in Dart":
    "https://www.codevscolor.com/dart-convert-string-datetime-iso8601",
  "Dart comparable example for comparing objects":
    "https://www.codevscolor.com/dart-comparable-example-compare-objects",
  "How to split a string in Dart":
    "https://www.codevscolor.com/how-to-split-a-string-in-dart",
  "Dart example program to iterate through a list":
    "https://www.codevscolor.com/dart-iterate-list",
  "Dart list : Explanation with example":
    "https://www.codevscolor.com/dart-list-explanation-example",
  "Dart program to check if an integer is odd or even":
    "https://www.codevscolor.com/dart-check-integer-odd-even",
  "Dart replace all substring in a string example":
    "https://www.codevscolor.com/dart-replace-substring-in-string",
  "Dart padLeft and padRight examples":
    "https://www.codevscolor.com/dart-padleft-padright-example",
  "Create a random integer, double or a boolean in dart using Random class":
    "https://www.codevscolor.com/dart-create-random-integer-double-boolean",
  "Dart example program to replace a substring":
    "https://www.codevscolor.com/dart-replace-substring",
  "Dart program to check if a string ends or starts with a substring":
    "https://www.codevscolor.com/dart-check-string-ends-with-starts-with-substring",
  "An introduction to dart string with examples":
    "https://www.codevscolor.com/an-introduction-to-dart-string-with-examples",
  "Inbuilt methods of dart string":
    "https://www.codevscolor.com/dart-string-methods",
  "Convert all characters in a string to uppercase and lowercase in dart":
    "https://www.codevscolor.com/convert-all-characters-in-a-string-to-uppercase-and-lowercase-in-dart",
  "Trim a string in Dart : Explanation with examples":
    "https://www.codevscolor.com/dart-trim-string-example",
  "How to get the ASCII value of an character in dart":
    "https://www.codevscolor.com/dart-get-ascii-value-character",
  "For loop in dart : explanation with example":
    "https://www.codevscolor.com/dart-for-loop-with-example",
  "How to install dart sdk on mac":
    "https://www.codevscolor.com/install-dart-sdk-mac",
  "Different ways to find the sum of all dart list elements":
    "https://www.codevscolor.com/dart-find-sum-list-elements",
  "7 different ways to find the largest, smallest number in dart list":
    "https://www.codevscolor.com/dart-list-find-smallest-largest",
  "Constructors of a Dart list":
    "https://www.codevscolor.com/constructors-dart-list",
  "Dart set explanation with examples":
    "https://www.codevscolor.com/dart-set-implementation",
  "Introduction to Dart Map class":
    "https://www.codevscolor.com/dart-map-introduction",
  "Dart program to check if a character is uppercase":
    "https://www.codevscolor.com/dart-check-character-uppercase",
  "How to print unicode of character in dart":
    "https://www.codevscolor.com/dart-print-unicode",
  "Runes in dart explanation with example":
    "https://www.codevscolor.com/dart-runes-explanation",
  "Keywords in dart": "https://www.codevscolor.com/dart-keywords",
  "Dart function introduction with examples":
    "https://www.codevscolor.com/dart-function",
  "Different examples to create dart functions":
    "https://www.codevscolor.com/dart-function-examples",
  "Dart program to find factorial of a number recursively":
    "https://www.codevscolor.com/dart-find-factorial-recursively",
  "Dart scope and lexical scoping":
    "https://www.codevscolor.com/dart-lexical-scoping",
  "Using optional parameters as required in dart":
    "https://www.codevscolor.com/dart-optional-required",
  "How to use stagehand to create dart projects":
    "https://www.codevscolor.com/dart-stagehand-example",
  "What is cascade notation or method chaining in Dart":
    "https://www.codevscolor.com/dart-cascade-notation",
  "Conditional expression in Dart":
    "https://www.codevscolor.com/dart-conditional-expression",
  "for-in loop in Dart with example":
    "https://www.codevscolor.com/dart-for-in-loop",
  "Dart for loop with example": "https://www.codevscolor.com/dart-for-loop",
  "if-else condition in Dart explanation with example":
    "https://www.codevscolor.com/dart-if-else",
  "Different ways to iterate through a Dart map":
    "https://www.codevscolor.com/dart-iterate-map",
  "Dart while loop explanation with example":
    "https://www.codevscolor.com/dart-while-loop",
  "Dart optional positional, named and default parameters":
    "https://www.codevscolor.com/dart-optional-positional-named-default",
  "do…while loop in Dart with examples":
    "https://www.codevscolor.com/dart-do-while-loop",
  "Dart switch case with example":
    "https://www.codevscolor.com/dart-switch-case",
  "assert statement in Dart explanation with example":
    "https://www.codevscolor.com/dart-assert-statement",
  "Dart break statement explanation with example":
    "https://www.codevscolor.com/dart-break-statement",
  "Dart continue statement explanation with example":
    "https://www.codevscolor.com/dart-continue-statement",
  "Exceptions and how to handle exceptions in Dart":
    "https://www.codevscolor.com/dart-exceptions",
  "How to throw an exception in Dart":
    "https://www.codevscolor.com/dart-throw-exception",
  "How to print exception StackTrace in Dart":
    "https://www.codevscolor.com/dart-print-exception-stacktrace",
  "Dart String replaceAll method":
    "https://www.codevscolor.com/dart-string-replaceall",
  "Dart program to remove the last character of a string":
    "https://www.codevscolor.com/dart-remove-last-string-character",
  "How to print the dollar sign in Dart":
    "https://www.codevscolor.com/dart-print-dollar-sign",
  "Different Dart class constructors":
    "https://www.codevscolor.com/dart-class-constructors",
  "How Dart class constructors initialized in subclass/superclass":
    "https://www.codevscolor.com/dart-superclass-constructor",
  "Dart instance variable examples":
    "https://www.codevscolor.com/dart-instance-variable",
  "Instance method in Dart with examples":
    "https://www.codevscolor.com/dart-instance-method",
  "Abstract method and abstract class in Dart":
    "https://www.codevscolor.com/dart-abstract-method-abstract-class",
  "Dart class inheritance : extends and override":
    "https://www.codevscolor.com/dart-inheritance-extends-override",
  "Implicit interface in Dart with examples":
    "https://www.codevscolor.com/dart-implicit-interface",
  "Enumeration in Dart explanation with example":
    "https://www.codevscolor.com/dart-enumeration",
  "Generics in Dart explanation with example":
    "https://www.codevscolor.com/dart-generics",
  "What is mixins in Dart": "https://www.codevscolor.com/dart-mixins",
  "How to do runtime type checking in Dart":
    "https://www.codevscolor.com/dart-runtime-type-checking",
  "Dart program to capitalize the first character of a string":
    "https://www.codevscolor.com/dart-capitalize-first-character-string",
  "Dart string splitMapJoin examples":
    "https://www.codevscolor.com/dart-string-splitmapjoin",
  "Dart: math library Point class":
    "https://www.codevscolor.com/dart-math-point-class",
  "Dart: math library, its classes, constants and functions":
    "https://www.codevscolor.com/dart-math-lib",
  "How to find random numbers in a range in Dart":
    "https://www.codevscolor.com/dart-find-random-in-range",
  "Asynchronous programming in Dart with examples":
    "https://www.codevscolor.com/dart-asynchronous-example",
  "Generators in dart with examples":
    "https://www.codevscolor.com/dart-generators",
  "What is a callable class in Dart programming language":
    "https://www.codevscolor.com/dart-callable-class",
  "Dart comments and types of comments supported in dart":
    "https://www.codevscolor.com/dart-comments",
  "Typedef in dart with examples": "https://www.codevscolor.com/dart-typedef",
  "Dart metadata and how to create custom metadata":
    "https://www.codevscolor.com/dart-metadata-example",
  "Dart program to concat string with integer":
    "https://www.codevscolor.com/dart-concat-string-integer",
  "How to remove string character using index in Dart":
    "https://www.codevscolor.com/dart-remove-string-character-using-index",
  "Dart check for any or every element in a list satisfy a given condition":
    "https://www.codevscolor.com/dart-any-every-element-list-satisfy-condition",
  "Dart program to check if a list contains a specific element or not":
    "https://www.codevscolor.com/dart-check-list-contains-specific-element",
  "Dart program to check if a list is empty or not":
    "https://www.codevscolor.com/dart-check-list-empty",
  "How to shuffle a dart list": "https://www.codevscolor.com/dart-list-shuffle",
  "Encoding/decoding JSON in Dart explanation with examples":
    "https://www.codevscolor.com/dart-encode-decode-json",
  "Dart program to check if a year is leap year or not":
    "https://www.codevscolor.com/dart-check-if-year-leap-year-or-not",
  "How to find the ceil and floor values of a number in Dart":
    "https://www.codevscolor.com/dart-ceil-floor-number",
  "Dart program to find the remainder using remainder() method":
    "https://www.codevscolor.com/dart-find-remainder",
  "Dart program to find substring in a string":
    "https://www.codevscolor.com/dart-find-substring-in-string",
  "How to use custom exceptions in dart":
    "https://www.codevscolor.com/dart-custom-exceptions",
  "How to convert string to integer in dart":
    "https://www.codevscolor.com/dart-convert-string-to-integer",
  "Dart program to convert a string to double":
    "https://www.codevscolor.com/dart-convert-string-to-double",
  "How to find the length of a string in Dart":
    "https://www.codevscolor.com/dart-find-string-length",
  "Dart program to convert hexadecimal to integer":
    "https://www.codevscolor.com/dart-convert-hexadecimal-to-integer",
  "How to reverse a list in dart":
    "https://www.codevscolor.com/dart-reverse-list",
  "Dart string contains method explanation with example":
    "https://www.codevscolor.com/dart-string-contains",
  "Dart program to convert degree to radian and vice versa":
    "https://www.codevscolor.com/dart-convert-degree-to-radian-vice-versa",
  "Dart program to change single or multiple list item":
    "https://www.codevscolor.com/dart-change-single-multiple-list-item",
  "Different ways to insert items to a list in dart":
    "https://www.codevscolor.com/dart-insert-items-to-list",
  "Different ways to remove items from a dart list":
    "https://www.codevscolor.com/dart-remove-items-from-list",
  "Dart program to swap two user given numbers":
    "https://www.codevscolor.com/dart-swap-two-user-given-numbers",
  "Constants defined in dart-math library":
    "https://www.codevscolor.com/dart-math-library-constants",
  "How to check if a string contains a number in Dart":
    "https://www.codevscolor.com/dart-string-contains-number",
  "How to get the current date-time in Dart":
    "https://www.codevscolor.com/dart-get-current-date-time",
  "Dart program to find the absolute value of a number":
    "https://www.codevscolor.com/dart-find-absolute-value",
  "Dart program to round a number to its nearest value":
    "https://www.codevscolor.com/dart-round-number",
  "Dart program to find the hash value of a string":
    "https://www.codevscolor.com/dart-string-hash",
  "How to multiply strings in Dart":
    "https://www.codevscolor.com/dart-string-multiply",
  "What is string interpolation in dart":
    "https://www.codevscolor.com/dart-string-interpolation",
  "try-catch in dart explanation with example":
    "https://www.codevscolor.com/dart-try-catch-example",
  "Dart map() function explanation with example":
    "https://www.codevscolor.com/dart-map-method-example",
  "Dart remove items from a list that doesn't satisfy a condition":
    "https://www.codevscolor.com/dart-remove-list-items-doesnot-satisfy-condition",
  "Get the only single element that satisfy a condition in dart list":
    "https://www.codevscolor.com/dart-list-get-single-element-that-satisfy-condition",
  "Dart program to get the first n elements from a list":
    "https://www.codevscolor.com/dart-get-n-elements-from-list",
  "How to create a string from ASCII values in Dart":
    "https://www.codevscolor.com/dart-create-string-from-ASCII",
  "Dart StringBuffer class explanation with examples":
    "https://www.codevscolor.com/dart-stringbuffer-class",
  "5 ways in Dart to print the multiplication table":
    "https://www.codevscolor.com/dart-print-multiplication-table",
  "Introduction to Queue in Dart and its methods":
    "https://www.codevscolor.com/dart-queue-methods",
  "How to add and remove items from a Queue in Dart":
    "https://www.codevscolor.com/dart-add-remove-queue-items",
  "How to remove and retain items from Queue in Dart with condition":
    "https://www.codevscolor.com/dart-remove-retain-queue-items-condition",
  "Dart Queue reduce function example":
    "https://www.codevscolor.com/dart-queue-reduce",
  "Dart HashMap explanation with examples":
    "https://www.codevscolor.com/dart-hashmap-introduction",
  "How to add and remove items of a HashMap in Dart":
    "https://www.codevscolor.com/dart-add-remove-items-hashmap",
  "How to iterate a HashMap in Dart in different ways":
    "https://www.codevscolor.com/dart-iterate-hashmap",
  "HashSet in Dart and its methods and properties":
    "https://www.codevscolor.com/dart-hashset-introduction",
  "How to add and remove items from a HashSet in Dart":
    "https://www.codevscolor.com/dart-add-remove-hashset-items",
  "Union and intersection of two HashSet in Dart":
    "https://www.codevscolor.com/dart-find-union-intersection-hashset",
  "Different ways to create a HashSet in Dart":
    "https://www.codevscolor.com/dart-create-hashset",
  "3 ways to find if a HashSet is empty or not in Dart":
    "https://www.codevscolor.com/dart-check-hashset-empty",
  "Dart HashSet.take and HashSet.takeWhile methods":
    "https://www.codevscolor.com/dart-hashset-take-takewhile",
  "Dart HashSet where and whereType explanation with examples":
    "https://www.codevscolor.com/dart-hashset-where-wheretype",
  "Dart HashSet fold and reduce methods explanation with examples":
    "https://www.codevscolor.com/dart-hashset-fold-reduce",
  "Dart HashSet skip and skipWhile methods explanation with example":
    "https://www.codevscolor.com/dart-hashset-skip-skipwhile",
  "Introduction to Dart LinkedHashMap class":
    "https://www.codevscolor.com/dart-linkedhashmap-class",
  "7 ways to create a LinkedHashMap in Dart":
    "https://www.codevscolor.com/dart-create-linkedhashmap",
  "3 ways to add items to a LinkedHashMap in Dart":
    "https://www.codevscolor.com/dart-add-items-linkedhashmap",
  "3 ways to remove items to a LinkedHashMap in Dart":
    "https://www.codevscolor.com/dart-remove-items-linkedhashmap",
  "Dart program to update single or multiple items of a LinkedHashMap":
    "https://www.codevscolor.com/dart-update-single-multiple-items-linkedhashmap",
  "5 ways to check if Dart LinkedHashMap contains a key or value":
    "https://www.codevscolor.com/dart-linkedhashmap-contains-key-value",
};
export const flutter = {
  "Create a basic flutter project in Android Studio":
    "https://www.codevscolor.com/flutter-android-studio-project",
  "How to create a Flutter web and mobile Application from command line":
    "https://www.codevscolor.com/flutter-create-web-mobile-app-command-line",
  "How to create a Floating Action Button in Flutter":
    "https://www.codevscolor.com/flutter-create-floating-action-button",
  "How to create an Alert dialog in Flutter":
    "https://www.codevscolor.com/flutter-create-alert-dialog",
  "How to create a circular image in flutter":
    "https://www.codevscolor.com/flutter-create-circular-image",
  "Learn to create a snackbar in flutter with example":
    "https://www.codevscolor.com/flutter-create-snackbar",
  "How to create a switch in Flutter and its properties":
    "https://www.codevscolor.com/flutter-switch-example",
  "How to create a horizontal set of toggle buttons in flutter":
    "https://www.codevscolor.com/flutter-horizontal-set-toggle-buttons",
  "Different ways to create a GridView in Flutter":
    "https://www.codevscolor.com/flutter-create-gridview",
  "TextField widget example in flutter and its different properties":
    "https://www.codevscolor.com/flutter-textfield-widget",
  "How to get user input text from a TextField in Flutter":
    "https://www.codevscolor.com/flutter-get-user-input-text-textfield",
  "How to customize the textfield cursor in Flutter":
    "https://www.codevscolor.com/flutter-customize-textfield-cursor",
  "Flutter TextField how to change the maximum and minimum lines":
    "https://www.codevscolor.com/flutter-textfield-change-max-min-lines",
  "How to remove the debug banner in Flutter apps in development mode":
    "https://www.codevscolor.com/flutter-remove-debug-banner",
  "Changing the size of a floating action button in Flutter":
    "https://www.codevscolor.com/flutter-floating-action-button-size",
  "Flutter AppBar widget and its properties":
    "https://www.codevscolor.com/flutter-appbar-widget",
  "How to change the colors of a Floating action button in Flutter":
    "https://www.codevscolor.com/flutter-floating-action-button-color",
  "Flutter expanded widget explanation with example":
    "https://www.codevscolor.com/flutter-expanded-example",
  "How to create a horizontal listview in Flutter":
    "https://www.codevscolor.com/flutter-horizontal-listview",
};
export const git = {
  "Git for beginners : part 1": "https://www.codevscolor.com/git-tutorial-1",
  "Git for beginners : part 2":
    "https://www.codevscolor.com/git-tutorial-part-2",
  "Git for beginners : part 3":
    "https://www.codevscolor.com/git-tutorial-3-git-with-android-studio",
};
export const java = {
  "Java math module":
    "https://www.codevscolor.com/java-tutorial-1-java-math-module",
  "Java lambda Expression":
    "https://www.codevscolor.com/java-8-lambda-expression",
  "Final keyword in Java": "https://www.codevscolor.com/java-final-keyword",
  "Java listiterator Example : Iterate through a list using listiterator":
    "https://www.codevscolor.com/java-listiterator-example",
  "Java StringJoiner example":
    "https://www.codevscolor.com/java-8-stringjoiner-tutorial-example",
  "Java 8 LocalDate Example program to find difference between two dates":
    "https://www.codevscolor.com/java-8-localdate-example-program-find-difference-two-date",
  "What is an Exception in Java and types of exceptions":
    "https://www.codevscolor.com/what-is-an-exception-in-java-exception-type",
  "Java System.nanoTime and System.currentTimeMillis":
    "https://www.codevscolor.com/java-nanotime-and-currenttimemillis",
  "SortedSet in Java explanation with Example":
    "https://www.codevscolor.com/sortedset-java-example",
  "Create Random int,float, boolean using ThreadLocalRandom in Java":
    "https://www.codevscolor.com/java-threadlocalrandom-example-int-float-boolean",
  "Bubble sort in Java with Examples":
    "https://www.codevscolor.com/java-program-on-bubble-sort",
  "Java BufferedReader and FileReader example read text file":
    "https://www.codevscolor.com/java-bufferedreader-filereader-example-open-read-text-file",
  "Java Linear Search : search one element in an array":
    "https://www.codevscolor.com/java-linear-search-search-one-element-array",
  "Java StringTokenizer example to Split a String":
    "https://www.codevscolor.com/java-stringtokenizer-example-split-a-string",
  "Java 8 Stream min and max method examples":
    "https://www.codevscolor.com/java-8-min-max",
  "Java ListIterator set method example":
    "https://www.codevscolor.com/java-listiterator-set-method",
  "Implement a Queue Data Structure in Java using LinkedList":
    "https://www.codevscolor.com/java-queue-using-linkedlist",
  "How to override toString method to print contents of a object in Java":
    "https://www.codevscolor.com/java-override-tostring-print-object",
  "Java 8 example to convert a string to integer stream (IntStream":
    "https://www.codevscolor.com/java-8-example-convert-string-integer-stream",
  "Java LinkedHashMap : create,iterate through a LinkedHashMap":
    "https://www.codevscolor.com/java-linkedhashmap-create-iterate",
  "Static import in Java explanation with example":
    "https://www.codevscolor.com/static-import-in-java",
  "Java DayOfWeek explanation with example":
    "https://www.codevscolor.com/java-dayofweek-example",
  "How to sort a list in Java : Explanation with example":
    "https://www.codevscolor.com/java-sort-a-list",
  "Java program to find the counts of each character in a String":
    "https://www.codevscolor.com/java-count-character-string",
  "Java program to check if a Matrix is Sparse Matrix or Dense Matrix":
    "https://www.codevscolor.com/sparse-matrix-java-program",
  "Java program to convert decimal to binary":
    "https://www.codevscolor.com/java-convert-decimal-binary",
  "Java program to print multiplication table":
    "https://www.codevscolor.com/java-print-multiplication-table",
  "Java program to print a Rhombus pattern":
    "https://www.codevscolor.com/java-program-print-rhombus",
  "Java program to print triangle and reverse triangle":
    "https://www.codevscolor.com/java-print-triangle-reverse-triangle",
  "Java program to find union and intersection of two arrays":
    "https://www.codevscolor.com/java-find-union-intersection-array",
  "Java program to find closest number to a given number without a digit :":
    "https://www.codevscolor.com/java-find-closest-number",
  "Java program to find all strong numbers in a range":
    "https://www.codevscolor.com/java-tutorial-find-strong-numbers-range",
  "Java program to find the number of vowels and digits in a String":
    "https://www.codevscolor.com/java-program-find-number-vowels-digits-string",
  "Java program to find pairs with a given sum in an array":
    "https://www.codevscolor.com/java-find-pairs-sum-array",
  "Java program to find the most frequent element in an array":
    "https://www.codevscolor.com/find-frequent-element-array-using-java",
  "Java program to find current resolution of the Screen":
    "https://www.codevscolor.com/java-program-current-screen-resolution",
  "Java program to find ASCII value of a Character":
    "https://www.codevscolor.com/java-program-find-ascii-character",
  "Java Program to convert decimal to Hexadecimal":
    "https://www.codevscolor.com/java-program-to-convert-decimal-to-hexadecimal",
  "Java program to find Saddle point of a Matrix":
    "https://www.codevscolor.com/java-program-to-find-saddle-point-of-a-matrix",
  "Java program to find Harshad or Niven number from 1 to 100":
    "https://www.codevscolor.com/java-program-to-find-harshad-niven-number",
  "Java program to write an infinite loop using for and while":
    "https://www.codevscolor.com/java-program-write-infinite-loop-using-for-while",
  "Java program to Print Floyd Triangle":
    "https://www.codevscolor.com/java-program-print-floyd-triangle",
  "Java Program to count the divisors of a number":
    "https://www.codevscolor.com/java-program-count-divisors",
  "Java program to copy file":
    "https://www.codevscolor.com/java-program-to-copy-file",
  "Java program to calculate Discount Price":
    "https://www.codevscolor.com/java-program-to-calculate-discount-price",
  "Java Program to find all Evil Number from 0 to 100":
    "https://www.codevscolor.com/java-program-find-evil-number",
  "Java program to read contents of a file using FileInputStream":
    "https://www.codevscolor.com/java-program-read-contents-file-using-fileinputstream",
  "Java program to read contents of a file using FileReader":
    "https://www.codevscolor.com/java-program-read-contents-file-using-filereader",
  "Java program to find square root and cubic root of a number":
    "https://www.codevscolor.com/java-program-to-find-square-root-and-cubic-root",
  "Java program to print all files and folders in a directory in sorted order":
    "https://www.codevscolor.com/java-print-all-files-folders-in-directory",
  "Java program to convert octal to binary":
    "https://www.codevscolor.com/java-program-convert-octal-binary",
  "Java program to rotate each words in a string":
    "https://www.codevscolor.com/java-program-rotate-words-string",
  "Java program to convert string to byte array and byte array to string":
    "https://www.codevscolor.com/java-convert-string-to-byte-array",
  "Java program to convert a string to lowercase and uppercase":
    "https://www.codevscolor.com/java-program-convert-string-lowercase-uppercase",
  "Java Program to calculate BMI or Body Mass Index":
    "https://www.codevscolor.com/java-program-to-calculate-bmi-body-mass-index",
  "Java program to find the area and perimeter of an equilateral triangle":
    "https://www.codevscolor.com/java-find-area-perimeter-of-equilateral-triangle",
  "Java Program to print the sum of square series 1^2 +2^2 + ….+n^2":
    "https://www.codevscolor.com/java-program-print-sum-square-series-12-22-32-42-n2",
  "Java Program to Delete a file using ‘File’ class":
    "https://www.codevscolor.com/java-program-delete-file-using-file",
  "Java program to find out the top 3 numbers in an array":
    "https://www.codevscolor.com/java-program-find-top-3-numbers-in-array",
  "Java program to print the ASCII value of an integer":
    "https://www.codevscolor.com/java-program-print-ascii-value-integer",
  "Java Program to get the last modified date and time of a file":
    "https://www.codevscolor.com/java-program-get-last-modified-date-time-file",
  "Java Program to Multiply Two Matrices":
    "https://www.codevscolor.com/java-program-multiply-two-matrices",
  "Java program to find Permutation and Combination ( nPr and nCr":
    "https://www.codevscolor.com/java-program-find-permutation-combination-npr-ncr",
  "Java Program to reverse a number":
    "https://www.codevscolor.com/java-program-to-reverse-a-number",
  "Java program to print a rectangle using any special character":
    "https://www.codevscolor.com/java-program-to-print-rectangle-using-character",
  "Java program to print a square using any character":
    "https://www.codevscolor.com/java-program-to-print-square",
  "Java program to find the kth smallest number in an unsorted array":
    "https://www.codevscolor.com/java-program-find-kth-smallest-number-in-unsorted-array",
  "Java Program to find the last non repeating character of a string":
    "https://www.codevscolor.com/java-program-to-find-last-non-repeating-character-in-string",
  "Java Program to get all the permutation of a string":
    "https://www.codevscolor.com/java-program-get-all-permutation-of-string",
  "Java program to get inputs from user using Scanner Class":
    "https://www.codevscolor.com/java-program-to-get-input-using-scanner",
  "Java Program to find Simple Interest":
    "https://www.codevscolor.com/java-program-to-find-simple-interest",
  "Java program to remove element from an ArrayList of a specific index":
    "https://www.codevscolor.com/java-program-remove-element-arraylist-specific-index",
  "Java Program to find Transpose of a matrix":
    "https://www.codevscolor.com/java-program-to-find-transpose-of-a-matrix",
  "Java Program to check if a number is Neon or not":
    "https://www.codevscolor.com/java-program-check-neon",
  "Java program to find maximum and minimum values of a list in a range":
    "https://www.codevscolor.com/java-find-max-min-list-in-range",
  "Java program to check if a number is perfect or not":
    "https://www.codevscolor.com/java-check-perfect-number",
  "Java program to find the circumference and area of a circle":
    "https://www.codevscolor.com/java-find-area-circumference-circle",
  "Java program to get the maximum number holder Student":
    "https://www.codevscolor.com/java-maximum-number-student",
  "Java program to calculate the area and perimeter of a rectangle":
    "https://www.codevscolor.com/java-calculate-area-perimeter-rectangle",
  "Java program to find the sum of all digits of a number":
    "https://www.codevscolor.com/java-sum-digits-number",
  "Java program to remove all white space from a string":
    "https://www.codevscolor.com/java-program-remove-white-space-string",
  "Java program to capitalize first letter of each word in a string":
    "https://www.codevscolor.com/java-program-capitalize-first-letter-words-string",
  "Java program to convert a string to boolean":
    "https://www.codevscolor.com/java-program-convert-string-boolean",
  "Java program to replace string in a file":
    "https://www.codevscolor.com/java-replace-string-in-file",
  "Java program to count the occurrence of each character in a string":
    "https://www.codevscolor.com/java-program-count-occurrence-each-character-string",
  "Java program to find count of words and find repeating words in a String":
    "https://www.codevscolor.com/java-count-words-repeating-words",
  "Java program to find the duplicate elements in an array of Strings":
    "https://www.codevscolor.com/java-find-duplicate-elements-array",
  "Java program to find the sublist in a list within range":
    "https://www.codevscolor.com/java-program-to-find-the-sublist",
  "Java program to swap first and last character of a string":
    "https://www.codevscolor.com/java-swap-first-last-character-string",
  "Java program to find the total count of words in a string":
    "https://www.codevscolor.com/java-find-count-words-string",
  "Java program to print random uppercase letter in a string":
    "https://www.codevscolor.com/java-print-random-uppercase-letter-string",
  "Java program to read and print a two dimensional array":
    "https://www.codevscolor.com/java-read-print-two-dimensional-array",
  "Java program to print an identity matrix":
    "https://www.codevscolor.com/java-program-print-identity-matrix",
  "Java program to print the boundary elements of a matrix":
    "https://www.codevscolor.com/java-print-boundary-elements-matrix",
  "Java program to extract all numbers from a string":
    "https://www.codevscolor.com/java-program-extract-numbers-string",
  "Java Program to create a temporary file in different locations":
    "https://www.codevscolor.com/java-program-create-temporary-file",
  "Java program to check if a number is Pronic or Heteromecic":
    "https://www.codevscolor.com/java-program-check-number-pronic-heteromecic",
  "Java program to check if all digits of a number are in increasing order":
    "https://www.codevscolor.com/java-check-all-digits-number-increasing-order",
  "Java program to move all zeros of an integer array to the start":
    "https://www.codevscolor.com/java-move-zeros-integer-array-start",
  "Java program to move all zero of an integer array to the end of the array":
    "https://www.codevscolor.com/java-move-zeros-integer-array-end",
  "Java program to check if a matrix is upper triangular matrix or not":
    "https://www.codevscolor.com/java-check-upper-triangular-matrix",
  "Java program to find three numbers in an array with total sum zero":
    "https://www.codevscolor.com/c-program-find-three-numbers-with-sum-zero",
  "Java program to compare two strings using contentEquals method":
    "https://www.codevscolor.com/java-program-compare-two-strings-contentequals",
  "Java program to extract a substring from a string":
    "https://www.codevscolor.com/java-extract-substring-from-string",
  "Java program to find if a substring exist in a user input string or not":
    "https://www.codevscolor.com/java-program-find-substring-exist-in-string",
  "Java program to find the maximum value between two BigInteger":
    "https://www.codevscolor.com/java-maximum-between-biginteger",
  "Java program to merge values of two integer arrays":
    "https://www.codevscolor.com/java-merge-arrays",
  "Java example to find missing number in an array of sequence":
    "https://www.codevscolor.com/java-example-find-missing-number-array",
  "Java program to remove vowel from a string":
    "https://www.codevscolor.com/java-remove-vowel-string",
  "What is Jagged Arrays in Java : explanation with examples":
    "https://www.codevscolor.com/java-jagged-arrays-explanation-with-examples",
  "Different usage of super keyword in Java":
    "https://www.codevscolor.com/java-different-usage-of-super-keyword",
  "Java Program to convert an ArrayList to an Array":
    "https://www.codevscolor.com/java-convert-an-arraylist-to-array",
  "Java program to Convert a double to string without exponential":
    "https://www.codevscolor.com/java-convert-double-to-string-without-exponential",
  "Java example to filter files in a directory using FilenameFilter":
    "https://www.codevscolor.com/java-example-filter-files-in-directory-filenamefilter",
  "Java program to do left rotation ‘n’ times to an array":
    "https://www.codevscolor.com/java-program-n-left-rotation",
  "Java RandomAccessFile explanation with examples":
    "https://www.codevscolor.com/java-randomaccessfile-explanation-example",
  "Java deep copy example using SerializationUtils":
    "https://www.codevscolor.com/java-deepcopy-serializationutils-example",
  "4 different ways to Sort String characters Alphabetically in Java":
    "https://www.codevscolor.com/4-different-ways-sort-string-characters-alphabetically-in-java",
  "Java strictfp keyword : Explanation with example":
    "https://www.codevscolor.com/java-strictfp-keyword",
  "Java program to convert a string to an array of string":
    "https://www.codevscolor.com/java-program-convert-string-array-of-string",
  "How to add zeros to the start of a number in Java":
    "https://www.codevscolor.com/java-add-zero-start-of-number",
  "Java Example to empty an Arraylist":
    "https://www.codevscolor.com/java-empty-an-arraylist",
  "Java user defined or custom exception example":
    "https://www.codevscolor.com/java-user-defined-custom-exception",
  "4 different ways to convert a string to double in Java":
    "https://www.codevscolor.com/java-convert-string-to-double",
  "How to convert stacktrace to string in Java":
    "https://www.codevscolor.com/java-stacktrace-to-string",
  "How to convert a boolean to string in Java":
    "https://www.codevscolor.com/java-convert-boolean-to-string",
  "Java program to print below and above average marks students":
    "https://www.codevscolor.com/java-print-below-above-average-marks-students",
  "How to remove elements of Java ArrayList using removeIf( method":
    "https://www.codevscolor.com/java-arraylist-removeif",
  "Java program to sort an array of integers in ascending order":
    "https://www.codevscolor.com/java-sort-integer-array-ascending",
  "Read json content from a file using GSON in Java":
    "https://www.codevscolor.com/java-read-json-content-from-file",
  "How to write json data to a file in Java":
    "https://www.codevscolor.com/java-write-json-to-file",
  "How to clone or copy a Vector in Java":
    "https://www.codevscolor.com/java-clone-vector",
  "How to read elements of a Java Vector using iterable":
    "https://www.codevscolor.com/how-to-read-elements-of-a-java-vector-using-iterable",
  "How to add elements to a Java vector using index":
    "https://www.codevscolor.com/add-elements-to-java-vector-using-index",
  "How to compare Substrings in Java using regionMatches":
    "https://www.codevscolor.com/java-compare-substring-using-regionmatches",
  "Java peek(, peekFirst( and peekLast( explanation with examples":
    "https://www.codevscolor.com/java-peek-peekfirst-peeklast",
  "Java LinkedList poll, pollFirst and pollLast example":
    "https://www.codevscolor.com/java-linkedlist-poll-pollfirst-polllast",
  "Java program to print all contents of a vector using enumeration":
    "https://www.codevscolor.com/java-print-vector-contents",
  "Java string compareToIgnoreCase and compareTo methods":
    "https://www.codevscolor.com/java-comparetoignorecase-compareto",
  "Java example program to create one ArrayList of ArrayList":
    "https://www.codevscolor.com/java-create-arraylist-of-arraylist",
  "Java compareToIgnoreCase method explanation with an example":
    "https://www.codevscolor.com/java-comparetoignorecase",
  "Java program to clear a vector or delete all elements of a vector":
    "https://www.codevscolor.com/how-to-clear-vector-in-java",
  "Difference between Java compareToIgnoreCase and equalsIgnoreCase":
    "https://www.codevscolor.com/java-comparetoignorecase-vs-equalsignorecase",
  "Java string intern method explanation with an example":
    "https://www.codevscolor.com/java-string-intern-example",
  "Java program to check if a number is a buzz number or not":
    "https://www.codevscolor.com/java-buzz-number",
  "Java String concat example":
    "https://www.codevscolor.com/java-string-concat",
  "Java arraylist set method example":
    "https://www.codevscolor.com/java-arraylist-set",
  "Java example program to left shift an array":
    "https://www.codevscolor.com/java-left-shift-array",
  "Introduction to Java JShell or Java Shell tool":
    "https://www.codevscolor.com/java-jshell-shell-tool",
  "Write a love calculator program in Java":
    "https://www.codevscolor.com/java-love-calculator",
  "Java program to subtract one matrix from another":
    "https://www.codevscolor.com/java-subtract-one-matrix-from-another",
  "How to use addExact and subtractExact in Java 8":
    "https://www.codevscolor.com/java-addexact-subtractexact",
  "Java Math incrementExact explanation with example":
    "https://www.codevscolor.com/java-math-incrementexact",
  "Java Math decrementExact explanation with example":
    "https://www.codevscolor.com/java-math-decrementexact",
  "Convert Java file to Kotlin in Intellij Idea":
    "https://www.codevscolor.com/java-to-kotlin-intellij",
  "Java program to calculate electricity bill":
    "https://www.codevscolor.com/java-calculate-electricity-bill",
  "What is a copy constructor in Java - Explanation with example":
    "https://www.codevscolor.com/java-copy-constructor-example",
  "Java program to find the third largest number in an unsorted array":
    "https://www.codevscolor.com/java-find-third-largest-number-in-unsorted-array",
  "Two different ways to start a thread in Java":
    "https://www.codevscolor.com/java-start-thread",
  "Java stream findFirst() explanation with example":
    "https://www.codevscolor.com/java-stream-findFirst",
  "Java Stream findAny method explanation with example":
    "https://www.codevscolor.com/java-stream-findany",
  "2 different ways to swap two elements in an ArrayList in Java":
    "https://www.codevscolor.com/java-swap-elements-arraylist",
  "How Java Collections.rotate method works":
    "https://www.codevscolor.com/java-collections-rotate-method",
  "What is static method shadowing in Java":
    "https://www.codevscolor.com/java-static-method-shadowing",
  "3 different ways to copy a string in Java":
    "https://www.codevscolor.com/java-copy-string",
  "Difference between findAny and findFirst of Java Stream API":
    "https://www.codevscolor.com/java-difference-findany-findfirst",
  "Java stream mapToInt explanation with examples":
    "https://www.codevscolor.com/java-stream-maptoint",
  "Java program to check if the first character of a string is number/digit":
    "https://www.codevscolor.com/java-check-first-character-string-number-digit",
  "How to get a random line from a file in Java":
    "https://www.codevscolor.com/java-get-random-line-from-file",
  "How to get the last element of a stream in Java":
    "https://www.codevscolor.com/java-get-last-element-stream",
  "Java program to check if a user input number is strong or not":
    "https://www.codevscolor.com/java-check-user-input-number-strong",
  "Java program to find the factors of a number":
    "https://www.codevscolor.com/java-find-factors-number",
  "Java Program to find the first digit of a positive or negative number":
    "https://www.codevscolor.com/java-first-digit-of-positive-negative-number",
  "Java program to get the sum of even numbers in an array":
    "https://www.codevscolor.com/java-sum-even-numbers-array",
  "Java program to find the sum of all odd numbers in an array":
    "https://www.codevscolor.com/java-find-sum-odd-numbers-array",
  "Java program to find the area of a Trapezoid":
    "https://www.codevscolor.com/java-find-area-trapezoid",
  "Java program to find all files with given extension in a directory and its subdirectories":
    "https://www.codevscolor.com/java-find-files-given-extension-directory-subdirectory",
  "Java program to read user input using Console":
    "https://www.codevscolor.com/java-read-user-input-console",
  "How to create a directory programmatically in Java using File class":
    "https://www.codevscolor.com/java-create-directory-programmatically",
  "Find the largest number from an array in Java":
    "https://www.codevscolor.com/java-find-largest-number-in-array",
  "Java program to find the absolute value of a number":
    "https://www.codevscolor.com/java-find-absolute-value",
  "Java program to get the epoch timestamp":
    "https://www.codevscolor.com/java-epoch-timestamp",
  "How to convert a negative number to positive in Java":
    "https://www.codevscolor.com/java-convert-negative-to-positive",
  "Java program to find the maximum element in a HashSet":
    "https://www.codevscolor.com/java-find-maximum-element-hashset",
  "How to add items to a HashSet in Java":
    "https://www.codevscolor.com/java-add-items-to-hashset",
  "How to remove specific items or remove all items from a HashSet":
    "https://www.codevscolor.com/java-remove-items-from-hashset",
  "3 different ways to iterate over a HashSet in Java":
    "https://www.codevscolor.com/java-iterate-over-hashset-items",
  "3 different ways in Java to convert comma-separated strings to an ArrayList":
    "https://www.codevscolor.com/java-convert-comma-separated-strings-to-arraylist",
  "Java program to convert a character to string":
    "https://www.codevscolor.com/java-convert-character-to-string",
  "Java program to convert byte to string":
    "https://www.codevscolor.com/java-convert-byte-to-string",
  "Java program to convert a string to ArrayList":
    "https://www.codevscolor.com/java-convert-string-to-arraylist",
  "How to remove empty values while split in Java":
    "https://www.codevscolor.com/java-remove-empty-values-while-split",
  "Java program to find the sum of the series 1 + 1/2 + 1/3 + 1/4 or harmonic series":
    "https://www.codevscolor.com/java-program-find-series-sum",
  "Java program to print the Arithmetic Progression series":
    "https://www.codevscolor.com/java-program-print-arithmetic-progression",
  "How to reverse a string in Java":
    "https://www.codevscolor.com/java-reverse-string",
  "Java example program to find the area of a Parallelogram":
    "https://www.codevscolor.com/java-find-area-parallelogram",
  "Write a number guessing game in Java":
    "https://www.codevscolor.com/java-number-guessing-game",
  "How to overload main method in Java":
    "https://www.codevscolor.com/java-overload-main-method",
  "Java program to find the perimeter of a circle":
    "https://www.codevscolor.com/java-find-circle-perimeter",
  "Java program to find the cube of a number":
    "https://www.codevscolor.com/java-find-cube-number",
  "How to reset a Scanner in Java":
    "https://www.codevscolor.com/java-reset-scanner",
  "Java program to sort array elements by frequency":
    "https://www.codevscolor.com/java-sort-elements-by-frequency",
  "Java program to reverse an array without using an additional array":
    "https://www.codevscolor.com/java-reverse-array-without-additional-array",
  "Java HashMap.merge() method explanation with examples":
    "https://www.codevscolor.com/java-hashmap-merge-method",
  "Java program to convert a boolean array to string array":
    "https://www.codevscolor.com/java-convert-boolean-array-to-string-array",
  "5 Different ways to append text to a file in Java":
    "https://www.codevscolor.com/java-append-text-to-file",
  "Can Enum implements interfaces in Java":
    "https://www.codevscolor.com/java-enum-implements-interface",
  "Java program to find special numbers in a range":
    "https://www.codevscolor.com/java-find-special-numbers-in-range.png",
  "Create a Rectangle class in Java and calculate area, perimeter":
    "https://www.codevscolor.com/java-create-rectangle-class-area-perimeter",
  "Java program to check if a number is special or not":
    "https://www.codevscolor.com/java-check-number-special",
  "Java program to find the sum of 0, 1, 1, 2, 3, 5, 8.. or Fibonacci series":
    "https://www.codevscolor.com/java-find-sum-fibonacci-series",
  "How to find the velocity in Java using user-give values":
    "https://www.codevscolor.com/java-find-velocity",
  "Java program to convert a decimal to binary format for a float or double value":
    "https://www.codevscolor.com/java-convert-decimal-to-binary",
  "How to add a character to the start and end of a string in Java":
    "https://www.codevscolor.com/java-add-character-to-start-end-string",
  "Java program to add characters to the middle of a string":
    "https://www.codevscolor.com/java-add-character-to-middle-string",
  "How to remove the first element of an ArrayList in Java":
    "https://www.codevscolor.com/java-remove-first-element-arraylist",
  "Java program to check if a number is Automorphic or not":
    "https://www.codevscolor.com/java-check-automorphic-number",
  "Java program to check if two numbers are Amicable or not":
    "https://www.codevscolor.com/java-check-if-two-numbers-amicable",
  "Java program to check if a number is a happy number or not":
    "https://www.codevscolor.com/java-check-if-number-happy",
  "Java program to print the Neon numbers from 0 to 10000":
    "https://www.codevscolor.com/java-print-neon-numbers-range",
  "How to remove the first character of a string in Java":
    "https://www.codevscolor.com/java-remove-first-string-character",
  "How to remove the last character of a string in Java":
    "https://www.codevscolor.com/java-remove-last-string-character",
  "Java program to convert string characters lowercase to uppercase without using any library function":
    "https://www.codevscolor.com/java-convert-lowercase-to-uppercase-without-library-function",
  "How to convert miles to kilometers and kilometers to miles in Java":
    "https://www.codevscolor.com/java-convert-miles-to-km-vice-versa",
  "Java program to check if a number is valid IMEI or not":
    "https://www.codevscolor.com/java-check-number-valid-imei",
  "How to take a string with blank spaces as input in Java":
    "https://www.codevscolor.com/java-take-string-blank-spaces-input",
  "Java program to find the average of two numbers":
    "https://www.codevscolor.com/java-program-find-average-two-numbers",
  "Java array copyOfRange method explanation with example":
    "https://www.codevscolor.com/java-array-copyofrange-example",
  "Java program to check if a number is a tech number or not":
    "https://www.codevscolor.com/java-program-check-tech-number",
  "How to import math class in Java example":
    "https://www.codevscolor.com/java-how-to-import-math-class-java",
  "How to use pi value in Java with example":
    "https://www.codevscolor.com/java-use-pi-java-example",
  "Java program to check if a number is a ugly number or not":
    "https://www.codevscolor.com/java-program-check-number-ugly",
  "Java program to check if a number is a unique number or not":
    "https://www.codevscolor.com/java-program-check-number-unique",
  "Java program to check if a number is Nelson number or not":
    "https://www.codevscolor.com/java-check-nelson-number",
  "Java java.util.Arrays.copyOf() method explanation with example":
    "https://www.codevscolor.com/java-util-arrays-copyof",
  "Java program to print a cross star pattern":
    "https://www.codevscolor.com/java-program-print-cross-star-pattern",
  "3 different Java programs to print Pascal's triangle for a given height":
    "https://www.codevscolor.com/java-program-print-pascals-triangle",
  "Java program to check if a number is a spy number or not":
    "https://www.codevscolor.com/java-program-check-spy-number",
  "Java program to check if a number is a duck number or not":
    "https://www.codevscolor.com/java-program-check-duck-number",
  "Java program to check if a number is evil number or not":
    "https://www.codevscolor.com/java-check-number-evil",
  "Java Math.random() method example to create random numbers":
    "https://www.codevscolor.com/java-math-random-method",
  "Java program to check if a number is a spy number or not":
    "https://www.codevscolor.com/java-check-spy-number",
  "4 different Java program to check if a number is a sunny number or not":
    "https://www.codevscolor.com/java-check-sunny-number",
  "Java Arrays binarySearch method explanation with example":
    "https://www.codevscolor.com/java-util-arrays-binarysearch",
  "java.util.Arrays.deepEquals method explanation with examples":
    "https://www.codevscolor.com/java-util-arrays-deepequals",
  "java.util.Arrays.fill method explanation with examples":
    "https://www.codevscolor.com/java-arrays-fill-method-example",
  "Java Arrays toString method explanation with example":
    "https://www.codevscolor.com/java-arrays-tostring-method-example",
  "Java Program to check if a number is magic number or not":
    "https://www.codevscolor.com/java-program-check-magic-number",
  "Java Arrays hashCode() method explanation with examples":
    "https://www.codevscolor.com/java-arrays-hashcode",
  "Java Arrays sort method explanation with example":
    "https://www.codevscolor.com/java-arrays-sort-method",
  "7 different Java programs to check if a number is Even or odd":
    "https://www.codevscolor.com/java-check-if-number-even-odd",
  "Java program to find the roots of a quadratic equation":
    "https://www.codevscolor.com/java-program-find-roots-quadratic-equation",
  "How to pass an array to function in Java":
    "https://www.codevscolor.com/java-program-pass-array-to-function",
  "4 different Java program to find the distances between two points":
    "https://www.codevscolor.com/java-find-distance-between-points",
  "Java program to find the sum of digits of a number until a single digit is found":
    "https://www.codevscolor.com/java-find-sum-digits-number-until-single-digit",
  "Java program to remove all non-ASCII characters from a string":
    "https://www.codevscolor.com/java-remove-non-ascii-character",
  "Java program to swap two numbers without using a third number":
    "https://www.codevscolor.com/java-swap-two-numbers-without-using-third",
  "How to use try without catch in Java":
    "https://www.codevscolor.com/java-how-to-use-try-without-catch",
  "Java ArrayList addAll method explanation with examples":
    "https://www.codevscolor.com/java-arraylist-addall-method",
  "Java program to check if a number is Armstrong or not":
    "https://www.codevscolor.com/java-check-number-armstrong",
  "Java String toLowerCase and toUpperCase methods":
    "https://www.codevscolor.com/java-string-tolowercase-touppercase",
  "Java Math copySign method explanation with examples":
    "https://www.codevscolor.com/java-math-copysign",
  "Java Math signum function explanation with examples":
    "https://www.codevscolor.com/java-math-signum",
  "Java program to check if a number is Kaprekar number or not":
    "https://www.codevscolor.com/java-check-if-number-is-kaprekar",
  "Two different ways in Java to find all duplicate string characters":
    "https://www.codevscolor.com/java-find-all-duplicate-characters-string",
  "Java String.replace() method explanation with example":
    "https://www.codevscolor.com/java-string-replace",
  "Java StringBuffer.reverse() method explanation with examples":
    "https://www.codevscolor.com/java-stringbuffer-reverse-method",
  "Java program to check if a string is empty or not":
    "https://www.codevscolor.com/java-check-string-empty",
  "How to reverse each word of a string in Java":
    "https://www.codevscolor.com/java-reverse-each-word-string",
  "Java program to check if a string is palindrome or not":
    "https://www.codevscolor.com/java-check-string-palindrome",
  "Java program to check if a given number is a prime number or not":
    "https://www.codevscolor.com/java-check-number-is-prime",
  "Java program to find all prime numbers from 1 to N":
    "https://www.codevscolor.com/java-find-prime-one-to-n",
  "Java program to check if a string is a prime number or not":
    "https://www.codevscolor.com/java-check-string-prime",
  "Different ways to find the factorial of a number in Java":
    "https://www.codevscolor.com/java-find-factorial-program",
  "Java program to check if a year is a leap year or not":
    "https://www.codevscolor.com/java-check-leap-year",
  "4 different Java program to find a random value in an array":
    "https://www.codevscolor.com/java-find-random-value-array",
  "Java program to find the first repeating character in a string":
    "https://www.codevscolor.com/java-find-first-repeating-character-string",
  "Java program to check if two strings are an anagram or not":
    "https://www.codevscolor.com/java-check-two-strings-are-anagram",
  "Java program to print the harmonic series":
    "https://www.codevscolor.com/java-print-harmonic-series",
  "Java program to convert a Hexadecimal value to Decimal":
    "https://www.codevscolor.com/java-hexadecimal-to-decimal",
  "3 ways in Java to print a Fibonacci triangle":
    "https://www.codevscolor.com/java-print-fibonacci-triangle",
  "4 ways in Java to print a right-angled triangle":
    "https://www.codevscolor.com/java-print-right-angled-triangle",
  "4 ways in Java to print an inverted right-angled triangle":
    "https://www.codevscolor.com/java-print-inverted-right-angled-triangle",
  "Java program to check if a number is circular prime or not":
    "https://www.codevscolor.com/java-check-number-circular-prime",
  "3 different Java program to find the volume of a cylinder":
    "https://www.codevscolor.com/java-find-cylinder-volume",
  "5 different Java program to print a hollow square star pattern with diagonal":
    "https://www.codevscolor.com/java-hollow-square-star-pattern-with-diagonal",
  "Java program to find quotient and remainder in two different ways":
    "https://www.codevscolor.com/java-find-quotient-remainder",
  "Java program to add, subtract, multiply and divide using switch case":
    "https://www.codevscolor.com/java-add-subtract-multiply-divide-switch",
  "Java program to check if a number is a special number or not":
    "https://www.codevscolor.com/java-check-special-number",
  "Java program to check if a number is a composite number or not":
    "https://www.codevscolor.com/java-check-composite-number",
  "Java next() vs nextLine() differences with examples":
    "https://www.codevscolor.com/java-next-nextline-difference",
  "Java program to check for disjoint sets in two ways":
    "https://www.codevscolor.com/java-check-disjoint-sets",
  "4 different Java programs to convert a list to set":
    "https://www.codevscolor.com/java-convert-list-to-set",
  "Java program to convert an image to Base64 in 2 different ways":
    "https://www.codevscolor.com/java-convert-image-base",
  "Java program to print odd numbers from 1 to 100":
    "https://www.codevscolor.com/java-print-odd-numbers-in-range",
  "Java program to print an upper triangular matrix":
    "https://www.codevscolor.com/java-print-upper-triangular-matrix",
  "How to remove all white spaces from a file in Java":
    "https://www.codevscolor.com/java-remove-white-spaces-from-file",
  "5 ways in Java to print the total number of days in a month":
    "https://www.codevscolor.com/java-print-days-of-month",
  "Java program to find the power of a number using recursion":
    "https://www.codevscolor.com/java-find-power-number-recursion",
  "Java program to calculate compound interest":
    "https://www.codevscolor.com/java-calculate-compound-interest",
  "3 ways in Java to print Hello World without semicolon":
    "https://www.codevscolor.com/java-print-hello-world-without-semicolon",
  "3 ways in Java to print a reverse half pyramid pattern":
    "https://www.codevscolor.com/java-print-reverse-half-pyramid",
  "Java program to find the largest and smallest of three numbers":
    "https://www.codevscolor.com/java-find-largest-smallest-three-numbers",
  "Java vector addAll method explanation with example":
    "https://www.codevscolor.com/java-vector-addall-method",
  "Java program to find the largest and smallest of n user input numbers":
    "https://www.codevscolor.com/java-find-largest-smallest-n-numbers",
  "Java program to print left-aligned and right-aligned staircase patterns":
    "https://www.codevscolor.com/java-staircase-pattern-example",
  "4 ways in Java to convert a decimal value to octal":
    "https://www.codevscolor.com/java-convert-decimal-to-octal",
  "Java program to round a number to n decimal places":
    "https://www.codevscolor.com/java-round-number-n-decimal",
  "Java program to print the vowels in a string":
    "https://www.codevscolor.com/java-print-vowels-in-string",
  "Java program to print inverted Pyramid patterns in different ways":
    "https://www.codevscolor.com/java-print-inverted-pyramid-pattern",
  "Java program to print a diamond pattern with stars":
    "https://www.codevscolor.com/java-print-diamond-pattern-with-stars",
  "2 different Java programs to check for Moran number":
    "https://www.codevscolor.com/java-check-moran-number",
  "Java program to calculate student grades in 2 different ways":
    "https://www.codevscolor.com/java-calculate-student-grades",
  "3 different Java programs to find the next prime number":
    "https://www.codevscolor.com/java-find-next-prime",
  "Can we have multiple public Java classes in one file":
    "https://www.codevscolor.com/java-multiple-public-class-one-file",
  "How to handle multiple exceptions in Java":
    "https://www.codevscolor.com/java-multiple-exceptions-handling",
  "Can we execute a Java program without the main method":
    "https://www.codevscolor.com/java-execute-program-without-main-method",
  "Different ways to add elements to an ArrayList in Java":
    "https://www.codevscolor.com/java-add-elements-to-arraylist",
  "Java String charAt method explanation with examples":
    "https://www.codevscolor.com/java-string-charat-method",
  "3 ways to convert System.nanoTime to seconds in Java":
    "https://www.codevscolor.com/java-convert-system-nanotime-to-seconds",
  "4 different Java program to find the HCF or GCD of two numbers":
    "https://www.codevscolor.com/java-find-hcf-gcd",
  "Java ArrayList ensureCapacity method":
    "https://www.codevscolor.com/java-arraylist-ensurecapacity",
  "Java ArrayList clone method explanation with example":
    "https://www.codevscolor.com/java-arraylist-clone",
  "How to find the product of digits of a number in Java":
    "https://www.codevscolor.com/java-find-product-of-digits",
  "3 ways to find perfect numbers in a range in Java":
    "https://www.codevscolor.com/java-find-perfect-numbers-in-range",
  "How to print a Hollow Rhombus pattern in Java":
    "https://www.codevscolor.com/java-print-hollow-rhombus-pattern",
  "Java program to print hollow diamond star pattern":
    "https://www.codevscolor.com/java-print-hollow-diamond-star-pattern",
  "Java program to print a plus star pattern":
    "https://www.codevscolor.com/java-print-plus-star-pattern",
  "Java program to print X star pattern":
    "https://www.codevscolor.com/java-print-x-star-pattern",
  "Java program to check if a character is Alphabet or not":
    "https://www.codevscolor.com/java-check-alphabet-character",
  "Java program to print from A to Z":
    "https://www.codevscolor.com/java-print-a-to-z",
  "Java program to filter a map by key and value":
    "https://www.codevscolor.com/java-filter-map-key-and-value",
  "Java program to check if a number is perfect square or not":
    "https://www.codevscolor.com/java-perfect-square-number",
  "7 ways to sort an ArrayList of objects in Java":
    "https://www.codevscolor.com/java-sort-arraylist-of-objects",
  "Java checked and unchecked exceptions example":
    "https://www.codevscolor.com/java-checked-unchecked-exception",
  "What is hybrid inheritance in java":
    "https://www.codevscolor.com/java-hybrid-inheritance",
  "How to format a Date in AM/PM in Java":
    "https://www.codevscolor.com/java-format-date-am-pm",
  "Java method overriding explanation with example":
    "https://www.codevscolor.com/java-method-overriding",
  "Java method overloading explanation with example":
    "https://www.codevscolor.com/java-method-overloading",
  "Java ArithmeticException explanation with examples":
    "https://www.codevscolor.com/java-arithmeticexception-example",
  "Java program to read user input numbers with blank spaces":
    "https://www.codevscolor.com/java-read-user-input-numbers-blank-spaces",
};
export const js = {
  "How to remove element from an array in Javascript":
    "https://www.codevscolor.com/javascript-remove-element-from-array",
  "How to reverse a string in Javascript in one line":
    "https://www.codevscolor.com/javascript-reverse-string-one-line",
  "How to check if a number is perfect or not in Javascript":
    "https://www.codevscolor.com/javascript-check-perfect-number",
  "3 different ways in Javascript to find if a string contains a substring or not":
    "https://www.codevscolor.com/javascript-find-string-contains-substring",
  "Create one number comparison application in JavaScript":
    "https://www.codevscolor.com/javascript-number-comparison",
  "How to add and delete last and first elements in a JavaScript array":
    "https://www.codevscolor.com/javascript-array-delete-first-last-element",
  "Javascript Array splice and slice method explanation with examples":
    "https://www.codevscolor.com/javascript-array-splice-slice",
  "Count specific character occurrence in a string in Javascript":
    "https://www.codevscolor.com/javascript-count-character-occurrence-string",
  "How to compare two dates in JavaScript":
    "https://www.codevscolor.com/javascript-compare-two-dates",
  "JavaScript Date getter methods for normal date and UTC date":
    "https://www.codevscolor.com/javascript-date-getter-methods-normal-utc-date",
  "Setter methods in JavaScript normal date and UTC date":
    "https://www.codevscolor.com/javascript-setter-normal-utc-date",
  "Javascript string indexOf( method explanation with example":
    "https://www.codevscolor.com/javascript-string-indexof-example",
  "How to sort array objects in JavaScript by value property":
    "https://www.codevscolor.com/javascript-sort-array-objects",
  "Join two or more strings using concat in Javascript":
    "https://www.codevscolor.com/join-strings-concat-javascript",
  "JavaScript substr( function explanation with example":
    "https://www.codevscolor.com/javascript-substr-example",
  "How to trim a string in JavaScript with examples":
    "https://www.codevscolor.com/javascript-trim-string",
  "JavaScript copyWithin( method example":
    "https://www.codevscolor.com/javascript-copywithin-example",
  "Convert date to ISO 8601 and UTC in JavaScript":
    "https://www.codevscolor.com/javascript-iso-utc",
  "JavaScript join, toString example to convert array to string":
    "https://www.codevscolor.com/javascript-join-tostring",
  "JavaScript program to find the sum of all odd numbers below one given number":
    "https://www.codevscolor.com/javascript-find-sum-odd-below-number",
  "JavaScript program to find out the area and perimeter of a circle":
    "https://www.codevscolor.com/javascript-find-area-perimeter-circle",
  "Different ways in JavaScript to check if all elements of one array are in a second array":
    "https://www.codevscolor.com/javascript-check-elements-array-second-array",
  "JavaScript find if an object is in an array of object":
    "https://www.codevscolor.com/javascript-find-object-in-array",
  "How to check if an object is empty or not in JavaScript":
    "https://www.codevscolor.com/javascript-check-empty-object",
  "3 different ways to remove the last character of a string in JavaScript":
    "https://www.codevscolor.com/javascript-remove-last-character-string",
  "JavaScript program to find the element with highest occurrence in an array":
    "https://www.codevscolor.com/javascript-find-highest-occurrence-array-element",
  "JavaScript program to find out the largest of three numbers":
    "https://www.codevscolor.com/javascript-find-largest-three",
  "Find out the largest Date in a JavaScript array":
    "https://www.codevscolor.com/javascript-array-largest-date",
  "JavaScript program to find years with first January Sunday":
    "https://www.codevscolor.com/javascript-find-years-first-january-sunday",
  "Different ways in JavaScript to check for palindrome":
    "https://www.codevscolor.com/javascript-palindrome-check",
  "JavaScript program to check if a number is multiple of 3 without using modulo":
    "https://www.codevscolor.com/javascript-check-number-multiple-three",
  "JavaScript program to find if a number is prime or not":
    "https://www.codevscolor.com/javascript-check-prime-number",
  "JavaScript logarithmic functions":
    "https://www.codevscolor.com/javascript-logarithmic-functions",
  "How to find the sign of a number in JavaScript":
    "https://www.codevscolor.com/javascript-find-sign-number",
  "How to remove only the fractional part of a number in JavaScript":
    "https://www.codevscolor.com/javascript-remove-fractional-part",
  "JavaScript program to find the largest of five numbers":
    "https://www.codevscolor.com/javascript-find-largest-of-five",
  "JavaScript program to find the nearest number in an array":
    "https://www.codevscolor.com/javascript-nearest-number-in-array",
  "JavaScript program to find all years in a range with first January Monday":
    "https://www.codevscolor.com/javascript-find-years-first-january-monday",
  "JavaScript Math expm1( function":
    "https://www.codevscolor.com/javascript-math-expm1",
  "Date constructors in JavaScript":
    "https://www.codevscolor.com/javascript-date-constructors",
  "Difference between null and undefined in JavaScript":
    "https://www.codevscolor.com/javascript-null-undefined",
  "JavaScript setTimeout( method example":
    "https://www.codevscolor.com/javascript-settimeout",
  "How to change HTML page using JavaScript":
    "https://www.codevscolor.com/how-to-change-html-page-using-javascript",
  "JavaScript program to open one url in a new tab":
    "https://www.codevscolor.com/javascript-open-url-new-tab",
  "JavaScript map with an array of objects":
    "https://www.codevscolor.com/javascript-map-array-of-objects",
  "How to check if an array is empty or not in JavaScript":
    "https://www.codevscolor.com/javascript-check-array-empty",
  "JavaScript program to get unique values in an array":
    "https://www.codevscolor.com/javascript-get-unique-values-array",
  "Javascript program to get all unique characters from a string":
    "https://www.codevscolor.com/javascript-get-unique-characters-from-string",
  "How to join elements of an array in JavaScript":
    "https://www.codevscolor.com/javascript-join-array-elements",
  "JavaScript program to get the current URL of the browser":
    "https://www.codevscolor.com/javascript-get-current-url",
  "Introduction to JavaScript Arrow function":
    "https://www.codevscolor.com/javascript-arrow-function",
  "Introduction to JavaScript rest parameter":
    "https://www.codevscolor.com/javascript-rest-parameter",
  "Introduction to local and global scope in JavaScript":
    "https://www.codevscolor.com/javascript-local-global-scope",
  "Introduction to strcat function in C with example":
    "https://www.codevscolor.com/c-strcat-function",
  "How to exit from a function in JavaScript":
    "https://www.codevscolor.com/javascript-exit-from-a-function",
  "How to use npm uninstall to uninstall a npm package":
    "https://www.codevscolor.com/npm-uninstall-command",
  "Learn to implement bubble sort in JavaScript":
    "https://www.codevscolor.com/bubble-sort-javascript",
  "2 different JavaScript programs to count the number of digits in a string":
    "https://www.codevscolor.com/javascript-count-digits-string",
  "3 JavaScript programs to get the first character of each words in a string":
    "https://www.codevscolor.com/javascript-get-first-character-each-word-string",
  "2 different JavaScript methods to remove first n characters from a string":
    "https://www.codevscolor.com/javascript-remove-first-n-characters-string",
  "2 different JavaScript program to remove last n characters from a string":
    "https://www.codevscolor.com/javascript-remove-last-n-characters-string",
  "JavaScript program to add two numbers - 3 different ways":
    "https://www.codevscolor.com/javascript-add-two-numbers",
  "2 different JavaScript program to calculate age from date of birth":
    "https://www.codevscolor.com/javascript-calculate-age-from-date-of-birth",
  "How to print a multiplication table in HTML,CSS, and JavaScript":
    "https://www.codevscolor.com/javascript-print-multiplication-table",
  "JavaScript program to get the selected value from a dropdown list of items":
    "https://www.codevscolor.com/javascript-get-selected-from-dropdown",
  "How to stop forEach() method in JavaScript":
    "https://www.codevscolor.com/javascript-stop-foreach",
  "3 different JavaScript program to convert a set to array":
    "https://www.codevscolor.com/javascript-convert-set-to-array",
  "JavaScript program to convert Celsius to Fahrenheit":
    "https://www.codevscolor.com/javascript-convert-celsius-fahrenheit",
  "JavaScript string repeat method":
    "https://www.codevscolor.com/javascript-string-repeat",
  "Example of JavaScript reduce with an array of objects":
    "https://www.codevscolor.com/javascript-reduce-array-objects",
  "JavaScript setDate function explanation with example":
    "https://www.codevscolor.com/javascript-setdate-function",
  "JavaScript program to read the current date time":
    "https://www.codevscolor.com/javascript-read-current-date-time",
  "JavaScript program to find the sum of all even numbers below a given number":
    "https://www.codevscolor.com/javascript-find-sum-even-below-number",
  "JavaScript program to find the lcm of two numbers":
    "https://www.codevscolor.com/javascript-lcm",
  "Different index related methods in JavaScript array":
    "https://www.codevscolor.com/javascript-index-methods",
  "How to change the text color in JavaScript on button click":
    "https://www.codevscolor.com/javascript-change-text-color-button-click",
  "JavaScript program to find the volume of a sphere":
    "https://www.codevscolor.com/javascript-find-sphere-volume",
  "How to reverse a number in JavaScript":
    "https://www.codevscolor.com/javascript-reverse-number",
  "JavaScript program to check if a number is power of another number":
    "https://www.codevscolor.com/javascript-check-number-power-another-number",
  "JavaScript program to get the selected radio button value":
    "https://www.codevscolor.com/javascript-get-selected-radio-button",
  "How to check if a variable is undefined or null in JavaScript":
    "https://www.codevscolor.com/javascript-check-variable-undefined-null",
  "JavaScript program to disable a button on click":
    "https://www.codevscolor.com/javascript-disable-button-on-click",
  "JavaScript program to close the current tab with OK/Cancel popup":
    "https://www.codevscolor.com/javascript-close-current-tab-ok-cancel-popup",
  "How to find the absolute value of a number in JavaScript":
    "https://www.codevscolor.com/javascript-find-absolute-value-number",
  "Different ways to get the last character from a string in JavaScript":
    "https://www.codevscolor.com/javascript-get-last-character-string",
  "JavaScript program to mask the start digits of a phone number":
    "https://www.codevscolor.com/javascript-mask-start-digit-phone-number",
  "JavaScript Map forEach method example":
    "https://www.codevscolor.com/javascript-map-foreach-example",
  "How to add one second delay in JavaScript":
    "https://www.codevscolor.com/javascript-one-second-delay",
  "JavaScript example to add padding to the end of a string using padEnd":
    "https://www.codevscolor.com/javascript-add-padding-string-end-padend",
  "JavaScript Array every method explanation with example":
    "https://www.codevscolor.com/javascript-array-every",
  "JavaScript program to check if an array is a subarray of another array":
    "https://www.codevscolor.com/javascript-check-array-subarray",
  "JavaScript program to delete an item from a set":
    "https://www.codevscolor.com/javascript-delete-item-from-set",
  "JavaScript set add() method explanation with example":
    "https://www.codevscolor.com/javascript-set-add-method",
  "How to check if a date is older than one month or 30 days in JavaScript":
    "https://www.codevscolor.com/javascript-check-date-older-than-one-month",
  "How to convert date to number in JavaScript":
    "https://www.codevscolor.com/javascript-convert-date-to-number",
  "How to find the ASCII value of a character in JavaScript":
    "https://www.codevscolor.com/javascript-find-ascii-value-character",
  "How to find the base64 of a string in JavaScript":
    "https://www.codevscolor.com/javascript-base64-string",
  "JavaScript String search method explanation with example":
    "https://www.codevscolor.com/javascript-string-search-method",
  "How to take one array as input from the user in JavaScript":
    "https://www.codevscolor.com/javascript-take-array-input-from-user",
  "How to return objects from JavaScript functions":
    "https://www.codevscolor.com/javascript-return-objects-from-functions",
  "2 ways to check if a variable exists or defined in JavaScript or not":
    "https://www.codevscolor.com/javascript-check-variable-exists-or-defined",
  "How to convert a comma-separated string to an array in JavaScript":
    "https://www.codevscolor.com/javascript-convert-comma-separated-string-to-array",
  "How to add an element to an array at a specific position in JavaScript":
    "https://www.codevscolor.com/javascript-add-element-to-array-specific-position",
  "Binary search implementation in JavaScript":
    "https://www.codevscolor.com/javascript-implement-binary-search",
  "Difference between JavaScript Promise.all and Promise.allSettled":
    "https://www.codevscolor.com/javascript-promise-all-promise-allsettled",
  "JavaScript array some() function explanation with examples":
    "https://www.codevscolor.com/javascript-array-some-function",
  "JavaScript Array isArray method explanation with examples":
    "https://www.codevscolor.com/javascript-array-isarray",
  "JavaScript string codePointAt method explanation with example":
    "https://www.codevscolor.com/javascript-string-codepointat",
  "3 ways in JavaScript to remove all hyphens from a string":
    "https://www.codevscolor.com/javascript-remove-hyphens-from-string",
  "How to remove all zeros from a number string in JavaScript":
    "https://www.codevscolor.com/javascript-remove-zeros-from-number-string",
  "6 different ways in JavaScript to print the content of an array":
    "https://www.codevscolor.com/javascript-print-array-content",
  "JavaScript array values() function":
    "https://www.codevscolor.com/javascript-array-values",
  "3 ways to get a random value from an array in JavaScript":
    "https://www.codevscolor.com/javascript-get-random-value-array",
  "4 ways in JavaScript to check if a string starts with a number":
    "https://www.codevscolor.com/javascript-check-string-starts-with-number",
  "How to check if an object is null or undefined in JavaScript":
    "https://www.codevscolor.com/javascript-check-object-null-or-undefined",
  "4 JavaScript program to check if the first character of a string is in lower case or not":
    "https://www.codevscolor.com/javascript-check-first-character-string-lower-case",
  "4 ways in JavaScript to check if the first character of a string is in upper case":
    "https://www.codevscolor.com/javascript-check-first-string-character-upper-case",
  "How to use JavaScript string lastIndexOf method":
    "https://www.codevscolor.com/javascript-string-lastindexof-method",
  "How to use the substring method in JavaScript string":
    "https://www.codevscolor.com/javascript-string-substring-method",
  "How to check if a string ends with another string or character in JavaScript":
    "https://www.codevscolor.com/javascript-check-string-ends-with-another-string-character",
  "JavaScript program to add padding to the start of a string":
    "https://www.codevscolor.com/javascript-add-padding-start-string",
  "JavaScript array fill method explanation with examples":
    "https://www.codevscolor.com/javascript-array-fill-method",
  "How to merge arrays in JavaScript using concat() method":
    "https://www.codevscolor.com/javascript-merge-arrays-concat",
  "JavaScript reduceRight() method explanation with examples":
    "https://www.codevscolor.com/javascript-reduceright-example",
  "How to reverse an array in JavaScript in place":
    "https://www.codevscolor.com/javascript-reverse-array-in-place",
  "How to add elements to the start of JavaScript arrays by using unshift":
    "https://www.codevscolor.com/javascript-add-elements-start-array-unshift",
  "JavaScript filter method explanation with example":
    "https://www.codevscolor.com/javascript-filter-method",
  "How to replace an item in an Array in JavaScript":
    "https://www.codevscolor.com/javascript-array-replace-item",
  "JavaScript parseFloat method explanation with examples":
    "https://www.codevscolor.com/javascript-parsefloat-examples",
  "JavaScript parseInt function example to convert a string to integer":
    "https://www.codevscolor.com/javascript-convert-string-to-integer-parseint",
  "How to check if a number is NaN in JavaScript":
    "https://www.codevscolor.com/javascript-check-if-number-nan",
  "3 ways to check if an object is string or not in JavaScript":
    "https://www.codevscolor.com/javascript-check-if-object-is-string",
  "How to remove object properties in JavaScript":
    "https://www.codevscolor.com/javascript-remove-object-properties",
  "How to convert objects to string in JavaScript":
    "https://www.codevscolor.com/javascript-convert-object-to-string",
  "How to get all Keys of a JavaScript Object":
    "https://www.codevscolor.com/javascript-get-all-keys-object",
  "JavaScript program to print the ASCII values from A to Z alphabet":
    "https://www.codevscolor.com/javascript-print-ascii-a-z-alphabet",
  "4 different JavaScript program to find the factorial of a number":
    "https://www.codevscolor.com/javascript-find-factorial-number",
  "3 ways in JavaScript to remove duplicate items from an array":
    "https://www.codevscolor.com/javascript-remove-duplicate-items-array",
  "How to sort the array elements in descending order in JavaScript":
    "https://www.codevscolor.com/javascript-sort-array-elements-descending",
  "JavaScript program to calculate BMI with user input values":
    "https://www.codevscolor.com/javascript-calculate-bmi-user-input-values",
  "JavaScript program to convert a seconds value to HH:mm:ss":
    "https://www.codevscolor.com/javascript-convert-seconds-hh-mm-ss",
  "3 ways in JavaScript to print the Fibonacci series":
    "https://www.codevscolor.com/javascript-print-fibonacci-series",
  "How to print Floyd's triangle in JavaScript in 3 ways":
    "https://www.codevscolor.com/javascript-print-floyds-triangle",
  "Leap year program in JavaScript with example":
    "https://www.codevscolor.com/javascript-check-leap-year",
  "5 different JavaScript programs to find the average of array values":
    "https://www.codevscolor.com/javascript-find-average-array-values",
  "JavaScript program to check if a number is Moran":
    "https://www.codevscolor.com/javascript-check-number-moran",
  "How to convert an image to Base64 in JavaScript":
    "https://www.codevscolor.com/javascript-convert-image-to-base64",
  "JavaScript program to find if a number is a Magic number or not":
    "https://www.codevscolor.com/javascript-find-if-number-magic",
  "JavaScript replace multiple characters using single replace call":
    "https://www.codevscolor.com/javascript-replace-multiple-characters-one-replace",
  "How to find simple interest with JavaScript":
    "https://www.codevscolor.com/javascript-find-simple-interest",
  "Show hide a div in JavaScript on button click":
    "https://www.codevscolor.com/javascript-button-click-div-show-hide",
  "JavaScript program to check if an element is present in an Array or not":
    "https://www.codevscolor.com/javascript-check-element-is-in-array",
  "How to find all matches in an array of objects in JavaScript":
    "https://www.codevscolor.com/javascript-find-matches-array-objects",
  "6 ways in JavaScript to iterate over an array of objects":
    "https://www.codevscolor.com/javascript-iterate-array-of-objects",
  "4 ways to add the digits of a number in JavaScript":
    "https://www.codevscolor.com/javascript-add-digits-number",
  "How to check if an object is in an array or not in JavaScript":
    "https://www.codevscolor.com/javascript-find-object-is-in-array",
};
export const kotlin = {
  "Kotlin tutorial : String in Kotlin with examples":
    "https://www.codevscolor.com/kotlin-string-example",
  "Kotlin tutorial for beginner : Introduction and setup":
    "https://www.codevscolor.com/kotlin-introduction-setup",
  "Kotlin development tutorial – Array in Kotlin":
    "https://www.codevscolor.com/kotlin-tutorial-array",
  "Kotlin tutorial : Character in kotlin and functions of Character class":
    "https://www.codevscolor.com/character-in-kotlin",
  "Kotlin program to change uppercase and lowercase of a string":
    "https://www.codevscolor.com/kotlin-program-convert-uppercase-to-lowercase-and-lowercase-to-uppercase-string",
  "How to run a Kotlin program using command line":
    "https://www.codevscolor.com/how-to-run-kotlin-program-command-line",
  "Kotlin program to calculate the total number of digits in a number":
    "https://www.codevscolor.com/kotlin-program-calculate-total-number-of-digits-in-a-number",
  "Kotlin program to check if an alphabet is vowel or not":
    "https://www.codevscolor.com/kotlin-check-alphabet-vowel",
  "What is primary constructor and secondary constructor in Kotlin":
    "https://www.codevscolor.com/kotlin-primary-secondary-constructor",
  "Data class in Kotlin : Explanation with example":
    "https://www.codevscolor.com/kotlin-data-class",
  "Kotlin program to find out the factors of a number":
    "https://www.codevscolor.com/kotlin-find-factors-number",
  "Kotlin example program to find out the largest element in an array":
    "https://www.codevscolor.com/kotlin-find-largest-element-in-array",
  "Kotlin program to reverse an array ( 2 different ways":
    "https://www.codevscolor.com/kotlin-reverse-array",
  "Kotlin String template : Explanation with Examples":
    "https://www.codevscolor.com/kotlin-string-template",
  "Trim leading whitespace characters using trimMargin in Kotlin":
    "https://www.codevscolor.com/kotlin-trim-leading-whitespace",
  "6 different ways to sort an array in Kotlin":
    "https://www.codevscolor.com/6-ways-sort-array-kotlin",
  "Kotlin program to find out the average marks of a list of students":
    "https://www.codevscolor.com/kotlin-find-average-marks-students",
  "3 ways to concatenate two collections with distinct elements in Kotlin":
    "https://www.codevscolor.com/kotlin-concatenate-two-collections",
  "How to use fold, foldIndexed, foldRight and foldRightIndexed in Kotlin":
    "https://www.codevscolor.com/kotlin-fold-foldindexed-foldright-foldrightindexed",
  "5 different ways to sort a list in ascending/descending order in Kotlin":
    "https://www.codevscolor.com/kotlin-5-ways-sort-list-ascending-descending",
  "How to intersect two arrays in Kotlin":
    "https://www.codevscolor.com/kotlin-array-intersect",
  "Learn default arguments in Kotlin functions with example":
    "https://www.codevscolor.com/kotlin-default-arguments",
  "What is double bang or double exclamation operator in kotlin":
    "https://www.codevscolor.com/kotlin-double-bang-exclamation",
  "What is elvis operator in Kotlin":
    "https://www.codevscolor.com/kotlin-elvis-operator",
  "Learn Named argument in Kotlin with examples":
    "https://www.codevscolor.com/learn-named-argument-in-kotlin-with-examples",
  "Safe call operator in Kotlin with example":
    "https://www.codevscolor.com/kotlin-safe-call-operator",
  "How to read user input in Kotlin":
    "https://www.codevscolor.com/read-user-input-kotlin",
  "How to convert a string to Date in Kotlin":
    "https://www.codevscolor.com/how-to-convert-a-string-to-date-in-kotlin",
  "How to check if a number is positive, negative or zero in Kotlin":
    "https://www.codevscolor.com/how-to-check-if-a-number-is-positive-negative-or-zero-in-kotlin",
  "Kotlin program to reverse a string recursively":
    "https://www.codevscolor.com/kotlin-reverse-string",
  "Kotlin program to print each character of a string (4 different ways":
    "https://www.codevscolor.com/kotlin-print-each-character-string",
  "Kotlin program to access a character in a string by index":
    "https://www.codevscolor.com/kotlin-program-to-access-a-character-in-a-string-by-index",
  "Kotlin take method explanation with different examples":
    "https://www.codevscolor.com/kotlin-take-method",
  "Find the maximum of two or three values in Kotlin using maxOf function":
    "https://www.codevscolor.com/kotlin-maxof-find-maximum-value",
  "Kotlin program to calculate simple interest with user input values":
    "https://www.codevscolor.com/kotlin-calculate-simple-interest",
  "Kotlin program to check if a string contains another substring":
    "https://www.codevscolor.com/kotlin-substring-check",
  "Kotlin program to find out the largest among three numbers":
    "https://www.codevscolor.com/kotlin-find-largest-among-three-numbers",
  "Kotlin if-else expression explanation with examples":
    "https://www.codevscolor.com/kotlin-if-else-expression",
  "Kotlin example program to reverse a number":
    "https://www.codevscolor.com/kotlin-reverse-number",
  "Boolean functions in Kotlin":
    "https://www.codevscolor.com/kotlin-boolean-functions",
  "How to use plus and minus operators in Kotlin":
    "https://www.codevscolor.com/kotlin-plus-minus-operator",
  "How to find all vowels in a string in Kotlin":
    "https://www.codevscolor.com/kotlin-find-vowels-string",
  "Check odd or even using ‘when’ in Kotlin":
    "https://www.codevscolor.com/kotlin-when-even-odd",
  "Kotlin for loop explanation with examples":
    "https://www.codevscolor.com/kotlin-for-loop",
  "Kotlin program to get the substring after a special character":
    "https://www.codevscolor.com/kotlin-get-substring-after-character",
  "Kotlin program to print the Fibonacci series":
    "https://www.codevscolor.com/kotlin-print-fibonacci-series",
  "How to use Scanner class in Kotlin to read user inputs":
    "https://www.codevscolor.com/kotlin-use-scanner-class",
  "Kotlin program to get the current time in milliseconds":
    "https://www.codevscolor.com/kotlin-current-time-milliseconds",
  "Kotlin also example": "https://www.codevscolor.com/kotlin-also-examples",
  "Kotlin program to convert character array to string":
    "https://www.codevscolor.com/kotlin-character-array-to-string",
  "Kotlin program to remove special characters from a string":
    "https://www.codevscolor.com/kotlin-remove-special-characters-string",
  "Kotlin program to Capitalize the first character or letter of a string":
    "https://www.codevscolor.com/kotlin-capitalize-first-character-string",
  "Kotlin program to capitalize first letter/character of each words in a sentence":
    "https://www.codevscolor.com/kotlin-capitalize-first-character-word-sentence",
  "Finding out random numbers in Kotlin":
    "https://www.codevscolor.com/kotlin-random-numbers",
  "Different ways to convert a string to number in Kotlin":
    "https://www.codevscolor.com/kotlin-convert-string-to-number",
  "Difference between double and triple equal in Kotlin":
    "https://www.codevscolor.com/kotlin-difference-double-triple-equal",
  "Different ways to read the content of a file in Kotlin":
    "https://www.codevscolor.com/kotlin-read-file-content",
  "Visibility modifiers: Private, protected, internal, and public":
    "https://www.codevscolor.com/kotlin-visibility-modifiers",
  "Get the versions info in Kotlin runtime":
    "https://www.codevscolor.com/kotlin-get-version-runtime",
  "Kotlin find index of first element in an iterable/list":
    "https://www.codevscolor.com/kotlin-index-first-iterable-list",
  "Kotlin program to find one element in a list of objects":
    "https://www.codevscolor.com/kotlin-find-element-list-objects",
  "Kotlin program to check if an array contains any one of multiple values":
    "https://www.codevscolor.com/kotlin-check-array-contains-one-multiple-values",
  "Kotlin program to convert one comma separated string to list":
    "https://www.codevscolor.com/kotlin-convert-comma-separated-string-list",
  "Kotlin program to convert one list to string":
    "https://www.codevscolor.com/kotlin-convert-list-string",
  "Different ways to find the length of a string in Kotlin":
    "https://www.codevscolor.com/kotlin-string-length",
  "Different ways to get substring in a string in Kotlin":
    "https://www.codevscolor.com/kotlin-get-substing",
  "Kotlin program to find the sum of all numbers of an array":
    "https://www.codevscolor.com/kotlin-sum-numbers-array",
  "zip and unzip methods in Kotlin array":
    "https://www.codevscolor.com/kotlin-array-zip-unzip",
  "Kotlin program to remove first and last characters of a string":
    "https://www.codevscolor.com/kotlin-remove-first-last-string-character",
  "How to concatenate strings in Kotlin":
    "https://www.codevscolor.com/kotlin-concatenate-strings",
  "Kotlin program to concat one string and integer":
    "https://www.codevscolor.com/kotin-concate-string-integer",
  "Kotlin string slice method example":
    "https://www.codevscolor.com/kotlin-string-slice",
  "Kotlin sortedBy method example":
    "https://www.codevscolor.com/kotlin-sortedby-example",
  "Kotlin program to get binary representation of integer":
    "https://www.codevscolor.com/kotlin-binary-representation-integer",
  "Kotlin program to decapitalize the first character of a string":
    "https://www.codevscolor.com/kotlin-decapitalize-first-character-string",
  "Kotlin program to delete all files in a folder":
    "https://www.codevscolor.com/kotlin-delete-all-files-folder",
  "Kotlin program to convert one string to character array":
    "https://www.codevscolor.com/kotlin-string-to-character-array",
  "Kotlin program to filter one list using another list":
    "https://www.codevscolor.com/kotlin-filter-one-list-based-on-another-list",
  "Kotlin inheritance explanation with example":
    "https://www.codevscolor.com/kotlin-inheritance-explanation",
  "Kotlin program to remove all whitespaces from a string":
    "https://www.codevscolor.com/kotlin-program-remove-whitespaces-string",
  "Kotlin program to check if a string is numeric":
    "https://www.codevscolor.com/kotlin-check-string-numeric",
  "Kotlin companion object explanation with example":
    "https://www.codevscolor.com/kotlin-companion-object",
  "Kotlin program to remove all negative numbers from a list":
    "https://www.codevscolor.com/kotlin-remove-negative-from-list",
  "How to partition a list in Kotlin":
    "https://www.codevscolor.com/kotlin-partition-list",
  "Kotlin program to find the positive value of negative numbers":
    "https://www.codevscolor.com/kotlin-negative-to-positive",
  "Kotlin program to remove character at specific index of a String":
    "https://www.codevscolor.com/kotlin-remove-character-specific-string-index",
  "Kotlin program to convert one character to integer":
    "https://www.codevscolor.com/kotlin-convert-character-to-integer",
  "Different ways to convert string to long in Kotlin":
    "https://www.codevscolor.com/kotlin-convert-string-long",
  "Kotlin groupBy method explanation with example":
    "https://www.codevscolor.com/kotlin-groupby-method-explanation-with-example",
  "Kotlin groupByTo method explanation with examples":
    "https://www.codevscolor.com/kotlin-groupbyto-example",
  "Kotlin groupingBy explanation with example":
    "https://www.codevscolor.com/kotlin-groupingby",
  "What is JvmStatic annotation in Kotlin and why we use it":
    "https://www.codevscolor.com/what-is-jvmstatic-annotation-in-kotlin-and-why-we-use-it",
  "Kotlin example to use aggregate with groupingBy":
    "https://www.codevscolor.com/kotlin-aggregate-groupingby",
  "How to handle exceptions using try catch in Kotlin":
    "https://www.codevscolor.com/kotlin-handle-exceptions-try-catch",
  "How to rethrow an exception in Kotlin":
    "https://www.codevscolor.com/kotlin-rethrow-exception",
  "Numbers in Kotlin and different useful methods":
    "https://www.codevscolor.com/kotlin-number",
  "How to use default parameters in Kotlin constructor":
    "https://www.codevscolor.com/kotlin-default-parameters",
  "repeat in Kotlin explanation with example":
    "https://www.codevscolor.com/kotlin-repeat",
  "Extension function in Kotlin explanation with examples":
    "https://www.codevscolor.com/kotlin-extension-function",
  "Three different ways to create an empty string array in Kotlin":
    "https://www.codevscolor.com/kotlin-empty-string-array",
  "5 different Kotlin program to iterate through a mutablelist":
    "https://www.codevscolor.com/kotlin-iterate-mutablelist",
  "5 different ways in Kotlin to find a string in a list of strings":
    "https://www.codevscolor.com/kotlin-find-string-in-list-strings",
  "How to sort a kotlin map by value":
    "https://www.codevscolor.com/kotlin-sort-map-by-value",
  "Binary search implementation in Kotlin for a list of custom objects":
    "https://www.codevscolor.com/kotlin-binary-search-list-of-custom-objects",
  "6 ways to add items to a list in Kotlin":
    "https://www.codevscolor.com/kotlin-add-items-to-list",
  "Different ways to write to a file in Kotlin":
    "https://www.codevscolor.com/kotlin-write-to-file",
  "Kotlin program to print a multiplication table":
    "https://www.codevscolor.com/kotlin-multiplication-table",
  "Kotlin program to convert a list to Array":
    "https://www.codevscolor.com/kotlin-convert-list-to-array",
  "How to convert a stack trace to string in Kotlin":
    "https://www.codevscolor.com/kotlin-convert-stacktrace-to-string",
  "4 different Kotlin programs to add two numbers":
    "https://www.codevscolor.com/kotlin-add-two-numbers-examples",
  "2 ways in Kotlin to check if a year is a leap year or not":
    "https://www.codevscolor.com/kotlin-check-leap-year",
  "How to print Hello World in Kotlin in IntelliJ-Idea":
    "https://www.codevscolor.com/kotlin-print-hello-world",
  "Kotlin program to print an integer entered by the user":
    "https://www.codevscolor.com/kotlin-print-integer-entered-by-user",
  "5 ways to swap two numbers in Kotlin":
    "https://www.codevscolor.com/kotlin-swap-numbers-different-ways",
  "2 ways to find the average of array numbers in kotlin":
    "https://www.codevscolor.com/kotlin-average-array-numbers",
  "How to remove specific elements from an array using index in Kotlin":
    "https://www.codevscolor.com/kotlin-remove-specific-elements-array",
  "Kotlin program to create a simple calculator":
    "https://www.codevscolor.com/kotlin-create-simple-calculator",
  "How to remove the first n characters from a string in Kotlin":
    "https://www.codevscolor.com/kotlin-remove-first-n-characters-from-string",
  "Check if a string starts with a character or sub-string in Kotlin":
    "https://www.codevscolor.com/kotlin-check-string-starts-sub-string-character",
  "Check if a string ends with another string or character in Kotlin":
    "https://www.codevscolor.com/kotlin-check-string-ends-with-another-string-character",
  "How to compare two strings in Kotlin in different ways":
    "https://www.codevscolor.com/kotlin-compare-two-strings",
  "5 different examples to split a string in Kotlin":
    "https://www.codevscolor.com/kotlin-split-string-examples",
  "How to convert a string to byte array in Kotlin":
    "https://www.codevscolor.com/kotlin-convert-string-to-byte-array",
  "3 different ways to convert a byte array to string in Kotlin":
    "https://www.codevscolor.com/kotlin-convert-byte-array-to-string",
  "Introduction to Kotlin Interpolation with examples":
    "https://www.codevscolor.com/kotlin-string-interpolation-explanation-example",
  "2 different ways to use Kotlin enum with string values":
    "https://www.codevscolor.com/kotlin-enum-with-string-values",
  "2 different Kotlin programs to find the root of quadratic equation":
    "https://www.codevscolor.com/kotlin-find-root-quadratic-equation",
};
export const mongodb = {
  "How to create a database in MongoDB and insert data":
    "https://www.codevscolor.com/mongodb-create-database-insert-data",
  "MongoDB tutorial : How to drop a database in MongoDB":
    "https://www.codevscolor.com/drop-database-mongodb",
  "How to create a simple and capped collection in MongoDB":
    "https://www.codevscolor.com/create-simple-capped-collection-mongodb",
  "How to check the type of a field in Mongo shell":
    "https://www.codevscolor.com/how-to-check-type-of-a-field-in-mongo-shell",
  "How to drop a collection in MongoDB":
    "https://www.codevscolor.com/mongodb-drop-collection",
  "Insert multiple documents to a MongoDB collection using insertMany":
    "https://www.codevscolor.com/insert-multiple-documents-mongodb-collection",
  "MongoDB : Insert one single document to a collection":
    "https://www.codevscolor.com/mongodb-insert-single-document",
  "pretty( method in MongoDB":
    "https://www.codevscolor.com/pretty-method-in-mongodb",
  "Backup and restore MongoDB using mongodump and mongorestore":
    "https://www.codevscolor.com/backup-and-restore-mongodb-using-mongodump-and-mongorestore",
  "How to dump and restore mongodb data from cloud.mongodb easily":
    "https://www.codevscolor.com/dump-restore-mongodb-data-from-cloud-mongodb",
  "How to change the port of a mongod instance":
    "https://www.codevscolor.com/mongod-change-port",
  "How to use limit method in MongoDB with examples":
    "https://www.codevscolor.com/mongodb-limit-method-example",
  "How to use skip( method in MongoDB":
    "https://www.codevscolor.com/mongodb-skip-method",
  "How to sort documents in MongoDB":
    "https://www.codevscolor.com/mongodb-sort-documents",
  "How to update one or multiple documents in MongoDB":
    "https://www.codevscolor.com/mongodb-update-document",
  "MongoDB find( method introduction":
    "https://www.codevscolor.com/mongodb-find-method",
  "MongoDB find documents within two dates":
    "https://www.codevscolor.com/mongodb-find-documents-within-date",
};
export const nodejs = {
  "setTimeout, setImmediate and setInterval of Timer module in Node.js":
    "https://www.codevscolor.com/nodejs-timer-module",
  "Node.js console module explanation with examples":
    "https://www.codevscolor.com/nodejs-console-module",
  "NodeJS create directory and temp-directory":
    "https://www.codevscolor.com/nodejs-directory-temp-directory",
  "NodeJS OS module methods and properties":
    "https://www.codevscolor.com/nodejs-os-module",
  "Different ways to cancel active timers in Node.js":
    "https://www.codevscolor.com/nodejs-cancel-timer",
  "How to read CSV files in Node.js":
    "https://www.codevscolor.com/nodejs-read-csv-file",
};
export const python = {
  "Python Introduction":
    "https://www.codevscolor.com/python-tutorial-for-beginner-introduction",
  "Python Variables":
    "https://www.codevscolor.com/python-tutorial-part-2-variables",
  "Python Datatype":
    "https://www.codevscolor.com/python-tutorial-part-3-python-datatype",
  "Python Numbers":
    "https://www.codevscolor.com/python-tutorial-part-4-python-numbers",
  "Python Math Module":
    "https://www.codevscolor.com/python-tutorial-part-5-math-module",
  "Python List": "https://www.codevscolor.com/python-list-tutorial",
  "Python Tuple": "https://www.codevscolor.com/python-tuple-tutorial",
  "Python String":
    "https://www.codevscolor.com/python-tutorial-part-8-python-string",
  "Python Common String methods":
    "https://www.codevscolor.com/python-common-string-methods",
  "Python Set":
    "https://www.codevscolor.com/python-tutorial-part-10-python-set",
  "Python Dictionary": "https://www.codevscolor.com/python-dictionary-tutorial",
  "Python Dictionary methods":
    "https://www.codevscolor.com/python-dictionary-method",
  "Python Conditional Statements":
    "https://www.codevscolor.com/python-conditional-statements-python-tutorial-13",
  "Python While and for loop":
    "https://www.codevscolor.com/python-while-and-for-loop-python-tutorial",
  "Python Break , continue and pass":
    "https://www.codevscolor.com/python-break-continue-pass-statement-python-tutorial",
  "Python Function":
    "https://www.codevscolor.com/python-function-python-tutorial",
  "Python Anonymous Lambda Function":
    "https://www.codevscolor.com/python-anonymous-lambda-function",
  "Python Module":
    "https://www.codevscolor.com/python-module-python-tutorial-18",
  "Python Package":
    "https://www.codevscolor.com/python-package-python-tutorial",
  "Python File operations":
    "https://www.codevscolor.com/python-file-operations-python-tutorial",
  "Python Exceptions":
    "https://www.codevscolor.com/python-exceptions-python-tutorial",
  "Python class and objects":
    "https://www.codevscolor.com/python-class-objects-python-tutorial",
  "Regular Expression in python":
    "https://www.codevscolor.com/regular-expression-python-tutorial",
  "Calendar module in python":
    "https://www.codevscolor.com/calendar-module-python-tutorial",
  "Using pip in python":
    "https://www.codevscolor.com/using-pip-in-python-python-tutorial",
  "What is Docstring and how to write docsrting in python":
    "https://www.codevscolor.com/write-docsrting-python",
  "*args and **kwargs in Python and difference between them":
    "https://www.codevscolor.com/args-kwargs-python-difference",
  "getattr in Python 3 with example":
    "https://www.codevscolor.com/python-getattr-example",
  "How to use Hashlib to encrypt a string in python":
    "https://www.codevscolor.com/use-hashlib-encrypt-string-python",
  "shutil module in python 3 with examples":
    "https://www.codevscolor.com/shutil-module-in-python-example",
  "zip function in python and how to use it":
    "https://www.codevscolor.com/python-zip-example",
  "Python index method to get the index of an item in a list":
    "https://www.codevscolor.com/python-index-method-get-index-list",
  "Python time.sleep method explanation with Example":
    "https://www.codevscolor.com/python-time-sleep",
  "Python 3 Ordered Dictionary (OrderedDict with example":
    "https://www.codevscolor.com/ordereddict-python-example",
  "How to copy or clone a list in python":
    "https://www.codevscolor.com/copy-clone-list-python",
  "List all the files in a Zip file using Python 3":
    "https://www.codevscolor.com/list-all-files-zip-python",
  "Python range explanation with example":
    "https://www.codevscolor.com/python-range-example",
  "How to delete a key from a python dictionary":
    "https://www.codevscolor.com/python-delete-key-dictionary",
  "Python print current date,time,hour,minute,increment each":
    "https://www.codevscolor.com/python-print-date-time-hour-minute",
  "Python program to take user input and check validity of a password":
    "https://www.codevscolor.com/python-check-validity-password",
  "Working with random in python , generate a number,float in range etc.":
    "https://www.codevscolor.com/python-random-number-float-range",
  "Find the factorial of a number using recursion":
    "https://www.codevscolor.com/python-program-find-factorial-python-tutorial",
  "Find the factorial of a number using for loop, while loop and recursion":
    "https://www.codevscolor.com/python-factorial-of-a-number",
  "Check palindrome Using one if-else":
    "https://www.codevscolor.com/python-program-to-check-palindrome-python-tutorial",
  "Find area of a circle in python":
    "https://www.codevscolor.com/find-area-circle-python-tutorial",
  "Find average of numbers in a list":
    "https://www.codevscolor.com/average-numbers-list-python",
  "Count the number of digits in a number":
    "https://www.codevscolor.com/count-number-digits-number-python",
  "Python program to check if a date is valid or not":
    "https://www.codevscolor.com/date-valid-check-python",
  "Python program to find LCM of two numbers":
    "https://www.codevscolor.com/python-program-find-lcm-two-numbers",
  "Python program to sort words of a string in alphabetical order":
    "https://www.codevscolor.com/python-program-sort-words-string-alphabetical-order",
  "Python program to find if a number is armstrong or not":
    "https://www.codevscolor.com/python-find-if-number-is-armstrong",
  "Write a python program to find the number of cpu count":
    "https://www.codevscolor.com/write-python-program-find-number-cpu-count",
  "Python 3 program to check if a number is positive, negative or zero":
    "https://www.codevscolor.com/python-3-program-check-number-positive-negative-zero",
  "Python program to count the number of words in a file":
    "https://www.codevscolor.com/python-program-count-number-of-words-file",
  "Python 3 program to check if a string is pangram or not":
    "https://www.codevscolor.com/python-program-check-if-string-pangram",
  "Python 3 program to count the total number of characters in a string":
    "https://www.codevscolor.com/python-count-characters-string",
  "Find total number of lowercase characters in a string using Python 3":
    "https://www.codevscolor.com/find-total-number-lowercase-characters-string-using-python",
  "Write a simple calculator program in Python 3":
    "https://www.codevscolor.com/write-calculator-python",
  "Python program to concatenate two dictionaries":
    "https://www.codevscolor.com/python-program-concatenate-two-dictionaries",
  "Python program to find the circumference of a circle":
    "https://www.codevscolor.com/python-find-circumference-circle",
  "Python 3 program to count the number of blank spaces in a file":
    "https://www.codevscolor.com/python-count-blank-spaces-file",
  "Python program to print all even numbers in a range":
    "https://www.codevscolor.com/python-even-numbers-range",
  "5 ways in Python to print inverted right-angled triangle":
    "https://www.codevscolor.com/python-print-invert-triangle",
  "Python program to print a triangle using star":
    "https://www.codevscolor.com/python-print-triangle-star",
  "Python 3 program to find union of two lists using set":
    "https://www.codevscolor.com/python-union-two-lists",
  "Python program to find the largest even and odd numbers in a list":
    "https://www.codevscolor.com/python-largest-even-odd-list",
  "Python program to check if a year is leap year or not":
    "https://www.codevscolor.com/python-check-leap-year",
  "Python program to sort values of one list using second list":
    "https://www.codevscolor.com/python-sort-one-list-using-second-list",
  "Python program to find the sum of all values of a dictionary":
    "https://www.codevscolor.com/python-find-sum-values-dictionary",
  "Python program to remove characters from odd or even index of a string":
    "https://www.codevscolor.com/python-remove-characters-odd-even-index-string",
  "Python program to print a right angled triangle":
    "https://www.codevscolor.com/python-program-right-angle-triangle",
  "Python program to replace character in a string with a symbol":
    "https://www.codevscolor.com/python-replace-character-string-symbol",
  "Python tutorial to remove duplicate lines from a text file":
    "https://www.codevscolor.com/python-remove-duplicate-lines-text-file",
  "Python program to find the maximum and minimum element in a list":
    "https://www.codevscolor.com/python-find-maximum-minimum-list",
  "Python program to find the multiplication of all elements in a list":
    "https://www.codevscolor.com/python-find-multiplication-elements-list",
  "Python program to find the square root of a number":
    "https://www.codevscolor.com/python-program-find-square-root",
  "Python program to exchange two numbers without using third number":
    "https://www.codevscolor.com/python-exchange-two-number-without-third",
  "Python program to remove an element from a list using ‘del’ statement":
    "https://www.codevscolor.com/python-remove-element-from-list",
  "Python program to merge two lists and sort it":
    "https://www.codevscolor.com/python-merge-sort-two-lists",
  "Python program to convert a list to string":
    "https://www.codevscolor.com/python-convert-list-string",
  "Python program to print one identity matrix":
    "https://www.codevscolor.com/python-print-identity-matrix",
  "Python program to count the total number of lines in a file":
    "https://www.codevscolor.com/python-count-total-lines-file",
  "Python program to find larger string among two strings":
    "https://www.codevscolor.com/python-find-larger-string-among-two",
  "Python program to find the first odd Abundant or excessive number":
    "https://www.codevscolor.com/python-program-find-abundant-excessive-number",
  "Python program to count the frequency of each words in a string":
    "https://www.codevscolor.com/python-count-frequency-words-string",
  "Python program to check if a number is abundant/excessive or not":
    "https://www.codevscolor.com/python-check-abundant-excessive-number",
  "Python program to capitalize first letter of each words of a string":
    "https://www.codevscolor.com/python-capitalize-first-letter-words-string",
  "Python tutorial to call a function using keyword argument":
    "https://www.codevscolor.com/python-keyword-argument",
  "Python program to convert a string to an integer":
    "https://www.codevscolor.com/python-convert-string-integer",
  "Python 3 program to convert a decimal number to ternary (base 3":
    "https://www.codevscolor.com/python-convert-decimal-ternarybase-3",
  "Python tutorial to calculate the sum of two string numbers":
    "https://www.codevscolor.com/python-calculate-sum-two-string-numbers",
  "Python program to pad zeros to a string":
    "https://www.codevscolor.com/python-program-pad-zeros-string",
  "Logical operators in Python : Explanation with example":
    "https://www.codevscolor.com/logical-operators-in-python-explanation-with-example",
  "Python add and remove elements from a list":
    "https://www.codevscolor.com/python-add-and-remove-elements-from-list",
  "Use any( function in python to check if anything inside a iterable is True":
    "https://www.codevscolor.com/python-any-check-anything-inside-iterable-true",
  "Four different methods to check if all items are similar in python list":
    "https://www.codevscolor.com/python-check-all-list-items-similar",
  "How to create a dictionary from two lists in python":
    "https://www.codevscolor.com/python-create-dictionary-from-two-lists",
  "Python program to find the middle element of a random number list":
    "https://www.codevscolor.com/python-find-middle-element-random-number-list",
  "Python program to find out numbers in a list divisible by two numbers":
    "https://www.codevscolor.com/python-find-numbers-list-divisible-by-two-numbers",
  "Python isinstance( and issubclass( functions":
    "https://www.codevscolor.com/python-isinstance-issubclass",
  "Python issubclass function in details":
    "https://www.codevscolor.com/python-issubclass-function",
  "Python program to iterate over the list in reverse order":
    "https://www.codevscolor.com/python-iterate-list-reverse-order",
  "Python program to remove all occurrence of a value from a list":
    "https://www.codevscolor.com/python-remove-value-from-list",
  "Python program to replace single or multiple character,substring in a string":
    "https://www.codevscolor.com/python-replace-character-substring-in-string",
  "Python tutorial to check if a user is eligible for voting or not":
    "https://www.codevscolor.com/python-check-voting-eligibility",
  "How to find the length of a string in python":
    "https://www.codevscolor.com/python-find-string-length",
  "Python program to find a substring in a string":
    "https://www.codevscolor.com/python-program-find-substring-in-string",
  "Python program to print a star hollow square pattern":
    "https://www.codevscolor.com/python-print-star-hollow-square-pattern",
  "Convert an integer or float to hex in Python":
    "https://www.codevscolor.com/python-convert-int-float-to-hex",
  "Python raw strings : Explanation with examples":
    "https://www.codevscolor.com/python-raw-string",
  "Python translate method":
    "https://www.codevscolor.com/python-translate-method",
  "Find out the multiplication of two numbers in Python":
    "https://www.codevscolor.com/python-multiplication-two-numbers",
  "Python Set intersection example":
    "https://www.codevscolor.com/python-set-intersection",
  "Convert string to float in python":
    "https://www.codevscolor.com/convert-string-to-float",
  "How to remove item from a list in python":
    "https://www.codevscolor.com/python-remove-item-from-list",
  "Python swap case of each character of a string":
    "https://www.codevscolor.com/python-swapcase-example",
  "Python example program to split a string at linebreak using splitlines":
    "https://www.codevscolor.com/python-split-string-splitlines-example",
  "Python program to calculate simple interest":
    "https://www.codevscolor.com/python-program-calculate-simple-interest",
  "Write a python program to reverse a number":
    "https://www.codevscolor.com/python-reverse-number",
  "Python program to remove all duplicate elements from a list":
    "https://www.codevscolor.com/python-remove-list-duplicate",
  "Python program to rename a directory or file":
    "https://www.codevscolor.com/python-rename-directory-file",
  "Python program to delete all files with specific extension in a folder":
    "https://www.codevscolor.com/python-delete-files-specific-extension-in-folder",
  "Python dictionary example to find keys with the same value":
    "https://www.codevscolor.com/python-dictionary-find-keys-with-the-same-value",
  "Python program to find out the sum of odd and even numbers in a list":
    "https://www.codevscolor.com/python-find-sum-odd-even-list",
  "Python program to swap the first and the last element of a list":
    "https://www.codevscolor.com/python-swap-first-last-list-element",
  "Python print dictionary keys and values":
    "https://www.codevscolor.com/python-print-key-value-dictionary",
  "Python program to solve the quadratic equation":
    "https://www.codevscolor.com/python-solve-quadratic-equation",
  "Two ways to find the set difference in Python":
    "https://www.codevscolor.com/python-set-difference",
  "Python program to convert kilometers to miles":
    "https://www.codevscolor.com/python-convert-kilometres-to-miles",
  "Python program to find out the perimeter of a triangle":
    "https://www.codevscolor.com/python-find-perimeter-triangle",
  "Python program to find out the largest divisor of a number":
    "https://www.codevscolor.com/python-find-largest-divisor-number",
  "Python String isspace( explanation with example":
    "https://www.codevscolor.com/python-string-isspace-explanation-with-example",
  "How to read a user input list in python":
    "https://www.codevscolor.com/python-read-user-input-list",
  "Python string center method explanation with example":
    "https://www.codevscolor.com/python-string-center-method",
  "Python program to find factors of a number":
    "https://www.codevscolor.com/python-program-find-factors-number",
  "Python program to find the smallest divisor of a number":
    "https://www.codevscolor.com/python-find-smallest-divisor-number",
  "Python program to insert multiple elements to a list at any specific position":
    "https://www.codevscolor.com/python-program-insert-multiple-elements-to-list-specific-position",
  "Python program to calculate total vowels in a string":
    "https://www.codevscolor.com/python-calculate-total-vowels-string",
  "Python program to convert Unicode or ASCII value to a character":
    "https://www.codevscolor.com/python-convert-unicode-ascii-character",
  "Python program to convert an integer number to octal":
    "https://www.codevscolor.com/python-convert-integer-octal",
  "Python program to print the odd numbers in a given range":
    "https://www.codevscolor.com/python-print-odd-numbers-in-range",
  "Python program to rename a file or directory":
    "https://www.codevscolor.com/python-program-to-rename-a-file-or-directory",
  "Python program to check if two strings are an anagram or not":
    "https://www.codevscolor.com/python-program-to-check-if-two-strings-are-an-anagram-or-not",
  "Python set isdisjoint( explanation with an example":
    "https://www.codevscolor.com/python-isdisjoint-example",
  "Python set discard method explanation with an example":
    "https://www.codevscolor.com/python-set-discard",
  "Python program to count the words and characters in a string":
    "https://www.codevscolor.com/python-count-words-characters-string",
  "Python program to check if an array is monotonic or not":
    "https://www.codevscolor.com/python-check-monotonic-array",
  "Python gamma( function explanation with example":
    "https://www.codevscolor.com/python-example-gamma-function",
  "Python program to find the gcd of two numbers using fractions module":
    "https://www.codevscolor.com/python-gcd-numbers-using-fractions",
  "Python program to convert character to its ASCII value":
    "https://www.codevscolor.com/python-convert-character-to-ascii",
  "Python program to print all combinations of three numbers":
    "https://www.codevscolor.com/python-combination-three-numbers",
  "Python program to swap the first and the last character of a string":
    "https://www.codevscolor.com/python-swap-first-last-string-character",
  "Python symmetric_difference_update example":
    "https://www.codevscolor.com/python-symmetric-difference-update",
  "How to find the intersection of two list elements in python":
    "https://www.codevscolor.com/python-list-intersection",
  "Python string ljust( method explanation with example":
    "https://www.codevscolor.com/python-string-ljust",
  "Python program to find out the sum of all digits of a number":
    "https://www.codevscolor.com/python-program-to-find-out-the-sum-of-all-digits-of-a-number",
  "Python Set difference_update explanation with an example":
    "https://www.codevscolor.com/python-set-difference_update",
  "Python program to remove special characters from all files in a folder":
    "https://www.codevscolor.com/python-remove-special-character-all-files-folder",
  "How to find the md5 hash of a string in python":
    "https://www.codevscolor.com/python-md5-string",
  "Python Set pop( method explanation with example":
    "https://www.codevscolor.com/python-set-pop",
  "Python program to check and create one directory":
    "https://www.codevscolor.com/python-check-create-directory",
  "Python program to find all numbers in a string":
    "https://www.codevscolor.com/python-find-all-numbers-string",
  "Python flatten a nested list or list of lists":
    "https://www.codevscolor.com/python-flat-list-from-nested-list",
  "Python find the key of a dictionary with maximum value":
    "https://www.codevscolor.com/python-dictionary-key-maximum-value",
  "Find the product of all odd, even numbers in a python list":
    "https://www.codevscolor.com/python-find-product-odd-even",
  "Python program to find the cube sum of first n numbers":
    "https://www.codevscolor.com/python-find-cube-sum",
  "Sort a python dictionary by values":
    "https://www.codevscolor.com/python-sort-dictionary-values",
  "Python program to find the area and perimeter of a triangle":
    "https://www.codevscolor.com/python-find-area-perimeter-triangle",
  "Python program to remove one occurrence of a word in a list":
    "https://www.codevscolor.com/python-remove-occurrence-word-list",
  "Python program to convert meter to yard":
    "https://www.codevscolor.com/python-meter-yard-conversion",
  "Python math.hypot method explanation with example":
    "https://www.codevscolor.com/python-math-hypot",
  "Python degree and radian conversion":
    "https://www.codevscolor.com/python-degree-radian-conversion",
  "Enumeration in python with examples":
    "https://www.codevscolor.com/python-enumeration-examples",
  "Trigonometric functions in python":
    "https://www.codevscolor.com/python-trigonometric-functions",
  "Example of Python casefold method":
    "https://www.codevscolor.com/python-casefold-example",
  "Example of Python strip method":
    "https://www.codevscolor.com/python-strip-method",
  "Python examples to create list of objects":
    "https://www.codevscolor.com/python-list-of-objects",
  "Python program to print numbers with comma as thousand separators":
    "https://www.codevscolor.com/python-print-comma-thousand-separators",
  "Python program to print list elements in different ways":
    "https://www.codevscolor.com/python-print-list-different-ways",
  "Different ways in Python to find the square of a number":
    "https://www.codevscolor.com/python-find-square-number",
  "Python program to find the area and perimeter of a rectangle":
    "https://www.codevscolor.com/python-area-perimeter-rectangle",
  "What is __init__ in Python": "https://www.codevscolor.com/python-init",
  "Python modulo explanation with example":
    "https://www.codevscolor.com/python-modulo-example",
  "How to sort all files in a folder in Python":
    "https://www.codevscolor.com/python-sort-folder-files",
  "How to calculate permutation in Python":
    "https://www.codevscolor.com/python-find-permutation",
  "How to calculate combination in Python":
    "https://www.codevscolor.com/python-find-combination",
  "Python program to calculate compound interest":
    "https://www.codevscolor.com/python-compound-interest-program",
  "lgamma function of python math":
    "https://www.codevscolor.com/python-math-lgamma",
  "Find the number of days between two dates in Python":
    "https://www.codevscolor.com/python-find-difference-dates",
  "Python program to print the current installed version":
    "https://www.codevscolor.com/python-print-current-installed-version",
  "Python program to create one list from set and dictionary":
    "https://www.codevscolor.com/python-create-list-from-set-dictionary",
  "Split a string with multiple delimiters in Python":
    "https://www.codevscolor.com/python-split-string-multiple-delimiters",
  "Python get quotient and remainder using divmod( method":
    "https://www.codevscolor.com/python-divmod-example",
  "How to reverse all words of a string in Python":
    "https://www.codevscolor.com/python-reverse-words-string",
  "Python infinite numbers and how to check infinite numbers":
    "https://www.codevscolor.com/python-infinite-numbers",
  "Python calendar iterweekdays function example":
    "https://www.codevscolor.com/python-calendar-iterweekdays",
  "Python calendar itermonthdays method with example":
    "https://www.codevscolor.com/python-calendar-itermonthdays",
  "Python calendar monthdatescalendar tutorial":
    "https://www.codevscolor.com/python-calendar-monthdatescalendar-tutorial",
  "Python calendar monthdays2calendar method examples":
    "https://www.codevscolor.com/python-calendar-monthdays2calendar",
  "Python calendar yeardatescalendar method explanation with examples":
    "https://www.codevscolor.com/python-calendar-yeardatescalendar",
  "Python calendar yeardays2calendar method explanation with example":
    "https://www.codevscolor.com/python-calendar-yeardays2calendar",
  "Python calendar yeardayscalendar explanation with examples":
    "https://www.codevscolor.com/python-calendar-yeardayscalendar",
  "Python calendar module HTMLCalendar class":
    "https://www.codevscolor.com/python-calendar-htmlcalendar",
  "How to read the content of a specific column of csv file in Python":
    "https://www.codevscolor.com/python-read-csv-column",
  "How to ceil all values of an array using python numpy ceil":
    "https://www.codevscolor.com/python-numpy-ceil",
  "Different ways to convert one boolean to string in python":
    "https://www.codevscolor.com/python-boolean-to-string",
  "Python program to select an item randomly from a list":
    "https://www.codevscolor.com/python-select-item-randomly-from-list",
  "write a python program to do a case insensitive string replacement":
    "https://www.codevscolor.com/python-case-insensitive-string-replacement",
  "Different ways in python to remove vowels from a string":
    "https://www.codevscolor.com/python-remove-vowels-from-string",
  "Python program to get random values from a list, dictionary, tuple or set":
    "https://www.codevscolor.com/python-random-sample-example",
  "Python program to find out the third largest number in a list":
    "https://www.codevscolor.com/python-find-third-largest-number-in-list",
  "Python tutorial pretty print JSON to console and file":
    "https://www.codevscolor.com/python-pretty-print-json",
  "How to replace date and time of a python datetime object":
    "https://www.codevscolor.com/python-replace-date-time-datetime-object",
  "How to find the last occurrence of a character in a python string":
    "https://www.codevscolor.com/python-find-last-character-occurrence-in-string",
  "How to remove https from a url in python":
    "https://www.codevscolor.com/python-remove-https-from-url",
  "Python program to find all indices of a character in a string":
    "https://www.codevscolor.com/python-program-find-all-indices-character-string",
  "How can we print spaces in python":
    "https://www.codevscolor.com/python-print-spaces",
  "Python program to generate secure random string of length n":
    "https://www.codevscolor.com/python-generate-secure-random-string",
  "python program to do inplace replace of string in a file":
    "https://www.codevscolor.com/python-inplace-replace-string-in-file",
  "How to accept sequence of numbers in python and find out the average":
    "https://www.codevscolor.com/python-accept-sequence-of-numbers",
  "Python map(lambda) function explanation with example":
    "https://www.codevscolor.com/python-map-lambda",
  "How to take inputs from user in Python":
    "https://www.codevscolor.com/python-take-user-input",
  "Python program to calculate discount based on selling price":
    "https://www.codevscolor.com/python-calculate-discount",
  "Python program to find change in percentage between two numbers":
    "https://www.codevscolor.com/python-find-change-percentage-two-numbers",
  "end parameter in python print statement and how to use it":
    "https://www.codevscolor.com/python-print-statement-end-parameter",
  "Python replace in numpy array more or less than a specific value":
    "https://www.codevscolor.com/python-replace-numpy-array",
  "Python numpy log10 explanation with example":
    "https://www.codevscolor.com/python-numpy-log10",
  "Python program to declare variables without assigning any value":
    "https://www.codevscolor.com/python-declare-variable-without-assigning-value",
  "Example to use Numpy log2 method to find natural logarithm of an array of numbers":
    "https://www.codevscolor.com/python-numpy-log2-method",
  "Python program to find out the sum of all numbers in an array":
    "https://www.codevscolor.com/python-find-sum-all-numbers-in-array",
  "How to print inverted half-pyramid in python using star":
    "https://www.codevscolor.com/python-print-inverted-half-star-pyramid",
  "Python program to print a half pyramid in star":
    "https://www.codevscolor.com/python-print-half-star-pyramid",
  "Python program to find the sum of digits in a string":
    "https://www.codevscolor.com/python-find-sum-digits-string",
  "How to check if a email address is valid or not in Python":
    "https://www.codevscolor.com/python-check-email-valid",
  "How to find if a string is a valid URL or not in Python":
    "https://www.codevscolor.com/python-find-string-valid-url",
  "Python example to zip list of lists using zip method":
    "https://www.codevscolor.com/python-zip-list-of-lists",
  "3 different ways in Python to convert string to a tuple of integers":
    "https://www.codevscolor.com/python-convert-string-tuple-integers",
  "Linear search implementation in python":
    "https://www.codevscolor.com/python-linear-search",
  "Python program to convert one string to JSON":
    "https://www.codevscolor.com/python-convert-string-to-json",
  "Python program to read and write JSON from a file":
    "https://www.codevscolor.com/python-read-write-json-from-file",
  "Three different Python examples to remove items from a list while iterating":
    "https://www.codevscolor.com/python-remove-items-list-iterating",
  "Python program to convert string to date using datetime module":
    "https://www.codevscolor.com/python-convert-string-to-date-datetime-module",
  "Use python bin() function to convert integer to binary":
    "https://www.codevscolor.com/python-bin-convert-integer-to-binary",
  "pass statement in Python explanation with example":
    "https://www.codevscolor.com/python-pass-statement",
  "How to remove the last n characters of a string in python":
    "https://www.codevscolor.com/python-remove-last-n-characters-string",
  "How to use rjust() method in python to right justified a string":
    "https://www.codevscolor.com/python-rjust-method-example",
  "Python program to remove the first n characters from a string":
    "https://www.codevscolor.com/python-remove-first-n-characters-string",
  "How to get all sublists of a list in Python":
    "https://www.codevscolor.com/python-get-all-sublists-list",
  "Example of python operator module lt":
    "https://www.codevscolor.com/python-operator-module-lt",
  "How to compare one string with an integer value in python":
    "https://www.codevscolor.com/python-compare-string-with-integer",
  "Python program to read all numbers from a file":
    "https://www.codevscolor.com/python-read-all-numbers-from-file",
  "Python program to find the sum of all numbers in a file":
    "https://www.codevscolor.com/python-find-sum-numbers-file",
  "Python program to append a single line to the end of a file":
    "https://www.codevscolor.com/python-append-single-line-to-end-file",
  "Difference between python append() and extend() methods of list":
    "https://www.codevscolor.com/python-difference-append-extend",
  "How to check if a triangle is valid or not in python":
    "https://www.codevscolor.com/python-check-if-triangle-valid",
  "Find all prime numbers in a range in python":
    "https://www.codevscolor.com/python-find-prime-numbers-in-range",
  "How to create a linked list in python":
    "https://www.codevscolor.com/python-create-a-linked-list",
  "Python program to print a mirrored right-angle star triangle":
    "https://www.codevscolor.com/python-print-mirrored-right-angle-triangle",
  "How to truncate number to integer in python":
    "https://www.codevscolor.com/python-truncate-number-to-integer",
  "How to convert a python string to hexadecimal value":
    "https://www.codevscolor.com/python-convert-string-hexadecimal",
  "Python string lower() method explanation with example":
    "https://www.codevscolor.com/python-string-lower-method-example",
  "Python string upper() method explanation with example":
    "https://www.codevscolor.com/python-string-upper",
  "IntEnum in python explanation with example":
    "https://www.codevscolor.com/python-intenum-example",
  "Python program to check two integer arrays contains same elements":
    "https://www.codevscolor.com/python-check-two-arrays-contains-same",
  "Python numpy append method explanation with example":
    "https://www.codevscolor.com/python-numpy-append",
  "How to check the Numpy version in linux, mac and windows":
    "https://www.codevscolor.com/python-numpy-check-version",
  "How to implement insertion sort in python":
    "https://www.codevscolor.com/python-insertion-sort",
  "Selection sort in python explanation with example":
    "https://www.codevscolor.com/python-selection-sort",
  "Python program to right rotate the elements of an array n number of times":
    "https://www.codevscolor.com/python-right-rotate-array-elements",
  "Python program to print a full pyramid":
    "https://www.codevscolor.com/python-print-full-pyramid",
  "How to convert a python dictionary to list":
    "https://www.codevscolor.com/python-convert-dictionary-to-list",
  "How to convert JSON to a python dictionary":
    "https://www.codevscolor.com/python-convert-json-to-dictionary",
  "How to read excel data in python using xlrd":
    "https://www.codevscolor.com/python-read-excel-xlrd",
  "Python list pop() method": "https://www.codevscolor.com/python-list-pop",
  "Python list remove() method":
    "https://www.codevscolor.com/python-list-remove",
  "numpy.log() method explanation with examples":
    "https://www.codevscolor.com/python-numpy-log",
  "Python os.system() method explanation with example":
    "https://www.codevscolor.com/python-os-system-example",
  "Python numpy reshape() method for array reshaping":
    "https://www.codevscolor.com/python-numpy-reshape",
  "Introduction to Python tkinter module":
    "https://www.codevscolor.com/python-tkinter-module",
  "Python program to multiply two float values using a function":
    "https://www.codevscolor.com/python-multiply-two-float-using-function",
  "Python program to convert a string to list":
    "https://www.codevscolor.com/python-convert-string-to-list",
  "Python string expandtabs explanation with example":
    "https://www.codevscolor.com/python-string-expandtabs",
  "Python program to convert a string to a sequence of byte":
    "https://www.codevscolor.com/python-string-to-sequence-byte",
  "Python program to convert a byte object to string":
    "https://www.codevscolor.com/python-byte-to-string",
  "How to find the cube root in python numpy":
    "https://www.codevscolor.com/python-numpy-cube-root-cbrt",
  "How to convert octal to decimal in python":
    "https://www.codevscolor.com/python-octal-to-decimal-conversion",
  "Python program to print all alphabets from A to Z in uppercase and lowercase":
    "https://www.codevscolor.com/python-print-alphabets-a-z-lower-upper-case",
  "Python program to reverse all strings in a list of strings":
    "https://www.codevscolor.com/python-reverse-strings-in-list-of-strings",
  "Python program to create a list of random numbers":
    "https://www.codevscolor.com/python-create-list-random-numbers",
  "Python program to concatenate a list of characters to a string":
    "https://www.codevscolor.com/python-concatenate-list-characters-to-string",
  "Python numpy logical AND example":
    "https://www.codevscolor.com/python-numpy-logical-and",
  "Python program to find the IP address":
    "https://www.codevscolor.com/python-find-ip-address",
  "Different ways to take screenshot in python programmatically":
    "https://www.codevscolor.com/python-take-screenshot-programmatically",
  "Python Set intersection_update() Method":
    "https://www.codevscolor.com/python-set-intersection-update",
  "How to find the md5 hash of a file in python":
    "https://www.codevscolor.com/python-find-md5-hash",
  "How to find the system battery information using Python":
    "https://www.codevscolor.com/python-find-battery-information",
  "How to find all running processes using python":
    "https://www.codevscolor.com/python-find-running-processes",
  "How to find the relative path of a file in python":
    "https://www.codevscolor.com/python-find-relative-path-file",
  "Python program to check if the characters in a string are sequential":
    "https://www.codevscolor.com/python-characters-string-sequential",
  "Python program to add items to a list without using append()":
    "https://www.codevscolor.com/python-add-items-list-append",
  "Python program to capitalize all characters of a string without using inbuilt functions":
    "https://www.codevscolor.com/python-capitalize-string-characters",
  "Python program to get the string between two substrings":
    "https://www.codevscolor.com/python-string-between-substring",
  "Python string join() method explanation with example":
    "https://www.codevscolor.com/python-string-join",
  "How to copy string in python":
    "https://www.codevscolor.com/python-copy-string",
  "Python check if a string is alphanumeric":
    "https://www.codevscolor.com/python-string-alphanumeric",
  "Python check if a string characters are ASCII using isascii":
    "https://www.codevscolor.com/python-string-ascii",
  "Python string index method explanation with example":
    "https://www.codevscolor.com/python-string-index-method",
  "Python program to remove special characters from a string":
    "https://www.codevscolor.com/python-remove-special-characters-string",
  "How to append a list, tuple or set to a set in python":
    "https://www.codevscolor.com/python-append-list-tuple-set-to-set",
  "Python find the base name of a given path":
    "https://www.codevscolor.com/python-os-path-basename",
  "Python dictionary get() method explanation with example":
    "https://www.codevscolor.com/python-dictionary-get-method",
  "Python program to check if a path exists":
    "https://www.codevscolor.com/python-os-path-exists",
  "Python os.path.lexists() method explanation with example":
    "https://www.codevscolor.com/python-os-path-lexists",
  "How to check if a path is file or directory in Python":
    "https://www.codevscolor.com/python-check-path-file-directory",
  "How to get the last access time of a path in python":
    "https://www.codevscolor.com/python-path-last-access-time",
  "Python program to get the last modified time of a path":
    "https://www.codevscolor.com/python-path-last-modified-time",
  "How to find the common path in a list of paths in python":
    "https://www.codevscolor.com/python-find-common-path-list-paths",
  "Python program to get the absolute path of a file":
    "https://www.codevscolor.com/python-get-absolute-path",
  "How to get the directory name of a given path in Python":
    "https://www.codevscolor.com/python-get-directory-name-given-path",
  "Python program to change the current working directory":
    "https://www.codevscolor.com/python-change-current-working-directory",
  "Python program to get the current working directory":
    "https://www.codevscolor.com/python-get-current-working-directory",
  "How to execute a python code from a string":
    "https://www.codevscolor.com/python-execute-code-from-string",
  "Python program to check if a string holds binary content":
    "https://www.codevscolor.com/python-check-string-holds-binary-content",
  "Python dictionary setdefault() method explanation with example":
    "https://www.codevscolor.com/python-dictionary-setdefault",
  "Python remove the last inserted item from a dictionary using popitem()":
    "https://www.codevscolor.com/python-dictionary-popitem",
  "Python program to add separator between parameters while using print() method":
    "https://www.codevscolor.com/python-add-separator-between-params-print",
  "How to flush a print in python":
    "https://www.codevscolor.com/python-flush-print",
  "How to take integer inputs until a valid response is found in python":
    "https://www.codevscolor.com/python-take-int-input-until-valid-response",
  "4 ways to reverse a string in python":
    "https://www.codevscolor.com/python-reverse-a-string",
  "Python program to check if a subarray is in an array":
    "https://www.codevscolor.com/python-check-subarray-in-array",
  "How to calculate gross pay for hourly paid employees in Python":
    "https://www.codevscolor.com/python-calculate-gross-pay-employee",
  "Python program to find the volume of a tetrahedron":
    "https://www.codevscolor.com/python-volume-tetrahedron",
  "Python program to search for a text in a file":
    "https://www.codevscolor.com/python-search-text-file",
  "How to insert an item to the start of an Ordered dictionary in Python":
    "https://www.codevscolor.com/python-insert-item-start-ordered-dictionary",
  "How to write a simple stopwatch in python":
    "https://www.codevscolor.com/python-write-simple-stopwatch",
  "Python program to check if two sets are equal":
    "https://www.codevscolor.com/python-check-sets-equal",
  "How to create a color choosing dialog in tkinter python":
    "https://www.codevscolor.com/python-tkinter-color-choosing-dialog",
  "Python program to remove the last character of a string":
    "https://www.codevscolor.com/python-remove-string-last-character",
  "Recursion program to find the power of a number in Python":
    "https://www.codevscolor.com/python-find-power-recursion",
  "Write a python Bank account class with withdraw/deposit features":
    "https://www.codevscolor.com/python-bank-account-class",
  "Python program to convert centimeter to inches":
    "https://www.codevscolor.com/python-convert-centimeter-to-inches",
  "How to calculate the average sum of all digits of a number in python":
    "https://www.codevscolor.com/python-find-average-sum-digits-number",
  "Python find the average of all numbers in a string":
    "https://www.codevscolor.com/python-string-find-average-numbers",
  "Python program to iterate over a tuple using a for loop":
    "https://www.codevscolor.com/python-iterate-tuple-using-for-loop",
  "How to find the power of a number using loop in Python":
    "https://www.codevscolor.com/python-find-power-number-using-loop",
  "Python program to find the power of a number using Anonymous function":
    "https://www.codevscolor.com/python-find-power-using-anonymous-function",
  "How to sort a list of tuple in python":
    "https://www.codevscolor.com/python-sort-list-of-tuple",
  "Python string hexdigits explanation with example":
    "https://www.codevscolor.com/python-string-hexdigits",
  "How to check if a tuple contains an element in Python":
    "https://www.codevscolor.com/python-check-tuple-contains-element",
  "Print the even and odd index characters of a string in python":
    "https://www.codevscolor.com/python-print-even-odd-index-characters-string",
  "Python program to convert a tuple of strings to string":
    "https://www.codevscolor.com/python-convert-tuple-of-strings-to-string",
  "Python program to print Arithmetic progression series":
    "https://www.codevscolor.com/python-print-arithmetic-progression-series",
  "Python program to check if a series is Arithmetic progression or not":
    "https://www.codevscolor.com/python-check-series-arithmetic-progression",
  "How to print Geometric progression or GP in python":
    "https://www.codevscolor.com/python-print-geometric-progression",
  "Python program to check if a series is Geometric progression":
    "https://www.codevscolor.com/python-check-series-geometric-progression",
  "Python program to count total digits in a string in four ways":
    "https://www.codevscolor.com/python-count-digits-in-string",
  "Python program to count total repeating digits in a number":
    "https://www.codevscolor.com/python-count-repeating-digits-in-number",
  "Python program to convert key-value string to dictionary":
    "https://www.codevscolor.com/python-convert-key-value-string-dictionary",
  "Python program to find the nth number which is square and cube of another number":
    "https://www.codevscolor.com/python-find-nth-number-square-and-cube-another",
  "How to convert a date to ISO8601 format in python":
    "https://www.codevscolor.com/python-convert-date-to-iso8601",
  "How to convert hours to seconds in Python":
    "https://www.codevscolor.com/python-convert-hours-to-seconds",
  "Python program to convert inch to centimeter":
    "https://www.codevscolor.com/python-program-convert-inch-centimeter",
  "3 ways to create a list of alternate elements in Python":
    "https://www.codevscolor.com/python-create-list-alternate-elements",
  "Python string replace method explanation with example":
    "https://www.codevscolor.com/python-string-replace-method",
  "Python program to remove commas from a string":
    "https://www.codevscolor.com/python-remove-commas-from-string",
  "Python program to append a string to a list":
    "https://www.codevscolor.com/python-append-string-to-list",
  "Python program to append/add or update key/value pairs in a dictionary":
    "https://www.codevscolor.com/python-append-add-update-key-value-pairs-dictionary",
  "How to do floor division in python":
    "https://www.codevscolor.com/python-floor-division",
  "Python conver integer to hexadecimal using hex()":
    "https://www.codevscolor.com/python-hex-method-example",
  "How to copy a directory recursively in Python":
    "https://www.codevscolor.com/python-copy-directory-recursively",
  "How to convert a set to tuple in Python":
    "https://www.codevscolor.com/python-convert-set-to-tuple",
  "How to take Hexadecimal numbers as input in Python":
    "https://www.codevscolor.com/python-take-hexadecimal-input",
  "How to convert a tuple to set in Python":
    "https://www.codevscolor.com/python-convert-tuple-to-set",
  "Python numpy.random.choice method example":
    "https://www.codevscolor.com/python-numpy-random-choice",
  "Python program to append text to a file":
    "https://www.codevscolor.com/python-append-text-to-file",
  "How to convert float to integer in Python":
    "https://www.codevscolor.com/python-convert-float-to-integer",
  "How to create a new text file in python":
    "https://www.codevscolor.com/python-create-new-text-file",
  "How to truncate datetime object and get the date in Python":
    "https://www.codevscolor.com/python-truncate-datetime-object-get-date",
  "How to decrement a for loop in Python":
    "https://www.codevscolor.com/python-decrement-for-loop",
  "Split the root, extension of a path in Python using os.path.splitext":
    "https://www.codevscolor.com/python-split-root-extension-path-splittext",
  "Python program to replace all negative numbers with zero in a list":
    "https://www.codevscolor.com/python-replace-negative-numbers-with-zero-list",
  "Python program to check if a file exists":
    "https://www.codevscolor.com/python-check-file-exists",
  "Python program to check if a number is prime or not":
    "https://www.codevscolor.com/python-check-prime-number",
  "Python program to convert inches to millimeters":
    "https://www.codevscolor.com/python-convert-inches-millimeters",
  "5 different ways to print multiple values in Python":
    "https://www.codevscolor.com/python-print-multiple-values",
  "Python numpy interp method example":
    "https://www.codevscolor.com/python-numpy-interp",
  "How to use empty_like in numpy with example":
    "https://www.codevscolor.com/python-numpy-empty-like",
  "3 ways to concatenate tuple elements by delimeter in Python":
    "https://www.codevscolor.com/python-concatenate-tuple-elements-by-delimeter",
  "How to iterate and print an array in reverse order in Python":
    "https://www.codevscolor.com/python-iterate-print-array-reverse-order",
  "How to use Python numpy.all method with examples":
    "https://www.codevscolor.com/python-numpy-all-example",
  "Python program to convert a dictionary to JSON":
    "https://www.codevscolor.com/python-convert-dictionary-to-json",
  "How to convert a dictionary to string in Python":
    "https://www.codevscolor.com/python-convert-dictionary-to-string",
  "4 Python ways to multiply the items in two lists":
    "https://www.codevscolor.com/python-multiply-items-in-two-lists",
  "Python program to read the content of a file to a list":
    "https://www.codevscolor.com/python-read-file-content-to-list",
  "How to find the exponential value for a number in Python":
    "https://www.codevscolor.com/python-find-exponential-number",
  "Python program to print a box pattern with plus at the center":
    "https://www.codevscolor.com/python-print-box-pattern-with-plus-center",
  "How to print the ASCII values all characters in Python":
    "https://www.codevscolor.com/python-print-ascii-values-all-characters",
  "Python program to read inputs within an interval of time":
    "https://www.codevscolor.com/python-read-inputs-within-time-interval",
  "Python program to check if a set contains an element or not":
    "https://www.codevscolor.com/python-check-set-contains-element",
  "How to subtract two numbers in Python":
    "https://www.codevscolor.com/python-subtract-two-numbers",
  "Python program to convert a binary to decimal":
    "https://www.codevscolor.com/python-convert-binary-to-decimal",
  "Python in and not in operators explanation with examples":
    "https://www.codevscolor.com/python-in-and-not-in-operators",
  "Python program to print a cross pattern using star":
    "https://www.codevscolor.com/python-print-cross-pattern-star",
  "4 ways to convert a datetime object to epoch in Python":
    "https://www.codevscolor.com/python-convert-datetime-to-epoch",
  "How to convert a decimal value to hexadecimal in Python":
    "https://www.codevscolor.com/python-convert-decimal-to-hexadecimal",
  "Learn to get the class name in Python in 2 ways":
    "https://www.codevscolor.com/python-get-class-name",
  "Introduction to yield in Python with example":
    "https://www.codevscolor.com/python-introduction-to-yield",
  "How to delete all files in a folder older than n days using Python":
    "https://www.codevscolor.com/python-delete-all-files-in-folder-older-than-n-days",
  "4 ways to find the average of 10 numbers in Python":
    "https://www.codevscolor.com/python-find-average-of-ten-numbers",
  "Python program to convert a hexadecimal value to decimal":
    "https://www.codevscolor.com/python-convert-hexadecimal-to-decimal",
  "Python string lstrip() method explanation with example":
    "https://www.codevscolor.com/python-string-lstrip-method",
  "Python rstrip() method explanation with example":
    "https://www.codevscolor.com/python-string-rstrip-method",
  "Python ticket booking program with JSON data":
    "https://www.codevscolor.com/python-ticket-booking-program-json-data",
  "Python program to check if a number is a disarium number or not":
    "https://www.codevscolor.com/python-check-disarium-number",
  "2 ways to check if a number is Pronic number or not in Python":
    "https://www.codevscolor.com/python-check-number-pronic",
  "Python numpy square method explanation with examples":
    "https://www.codevscolor.com/python-numpy-square-method-examples",
  "Python program to merge a dictionary to a tuple":
    "https://www.codevscolor.com/python-merge-dictionary-to-tuple",
  "Python dictionary fromkeys method":
    "https://www.codevscolor.com/python-dictionary-fromkeys",
  "Python dictionary pop method explanation with examples":
    "https://www.codevscolor.com/python-dictionary-pop-method",
  "11 differences between Python 2 vs Python 3 with examples":
    "https://www.codevscolor.com/python-2-vs-python-3",
  "Learn Python numpy clip method with examples":
    "https://www.codevscolor.com/python-numpy-clip-method-examples",
  "How to find Determinant in Python Numpy":
    "https://www.codevscolor.com/python-numpy-find-determinant",
  "Get evenly spaced numbers in an interval using numpy linspace":
    "https://www.codevscolor.com/python-numpy-linspace-example",
  "Python string isnumeric method":
    "https://www.codevscolor.com/python-string-isnumeric",
  "How to use Python string partition method":
    "https://www.codevscolor.com/python-string-partition",
  "Python numpy floor_divide method explanation with examples":
    "https://www.codevscolor.com/python-numpy-floor-divide",
  "How to use logical operator with strings in Python":
    "https://www.codevscolor.com/python-logical-operator-with-strings",
  "Python Matplotlib horizontal histogram or bar graph":
    "https://www.codevscolor.com/python-matplotlib-horizontal-histogram",
  "Python program to sort lines of a text file alphabetically":
    "https://www.codevscolor.com/python-sort-lines-text-file-alphabetically",
  "Read and write the content of a file backward in Python":
    "https://www.codevscolor.com/python-read-write-content-file-backward",
  "Python program to find duplicate words in a file":
    "https://www.codevscolor.com/python-find-duplicate-words-file",
  "Python program to extract emails from a file":
    "https://www.codevscolor.com/python-extract-emails-from-file",
  "Python program to print the harmonic series":
    "https://www.codevscolor.com/python-print-harmonic-series",
  "Python math fabs() method explanation with example":
    "https://www.codevscolor.com/python-math-fabs-example",
  "What is generator function in Python and how to use it":
    "https://www.codevscolor.com/python-generator-function",
  "Inheritance in Python explanation with example":
    "https://www.codevscolor.com/python-inheritance-example",
  "Python numpy.around() method explanation with example":
    "https://www.codevscolor.com/python-numpy-around",
  "Python string rindex method explanation with example":
    "https://www.codevscolor.com/python-string-rindex",
  "Python math trunc method explanation with example":
    "https://www.codevscolor.com/python-math-trunc",
  "Python string rpartition method explanation with example":
    "https://www.codevscolor.com/python-string-rpartition",
  "Python string rsplit method explanation with example":
    "https://www.codevscolor.com/python-string-rsplit",
  "Python string zfill method explanation with example":
    "https://www.codevscolor.com/python-string-zfill",
  "Python string endswith method explanation with example":
    "https://www.codevscolor.com/python-string-endswith",
  "Python string isalnum method explanation with example":
    "https://www.codevscolor.com/python-string-isalnum",
  "Python string isalpha method explanation with example":
    "https://www.codevscolor.com/python-string-isalpha",
  "Python string isdecimal method explanation with example":
    "https://www.codevscolor.com/python-string-isdecimal",
  "Python string isdigit() method explanation with example":
    "https://www.codevscolor.com/python-string-isdigit",
  "Python string isidentifier() method":
    "https://www.codevscolor.com/python-string-isidentifier",
  "Python string islower method explanation with example":
    "https://www.codevscolor.com/python-string-islower",
  "Python program to check if a number is divisible by another number or not":
    "https://www.codevscolor.com/python-check-number-divisible-by-another-number",
  "Python program to check if a number is duck number or not":
    "https://www.codevscolor.com/python-check-duck-number",
  "Python program to convert celsius to Fahrenheit and vice versa":
    "https://www.codevscolor.com/python-convert-celsius-to-fahrenheit",
  "Python program to check if a number is a magic number or not":
    "https://www.codevscolor.com/python-check-magic-number",
  "Difference between random.sample() vs random.choice() in Python":
    "https://www.codevscolor.com/python-difference-random-sample-choice",
  "Python program to check for Moran numbers":
    "https://www.codevscolor.com/python-check-moran-numbers",
  "Python program to check if a number is a perfect number or not":
    "https://www.codevscolor.com/python-check-perfect-number",
  "3 different Python programs to remove the first character of string":
    "https://www.codevscolor.com/python-remove-first-string-character",
  "Python assert statement explanation with examples":
    "https://www.codevscolor.com/python-assert-statement",
  "3 different Python programs to get a string after a substring":
    "https://www.codevscolor.com/python-get-string-after-substring",
  "Python example to print the function name as string with `__name__` and `__qualname__`":
    "https://www.codevscolor.com/python-get-function-name-as-string",
  "Python program to check if a number is a Niven or Harshad number":
    "https://www.codevscolor.com/python-check-niven-harshad-number",
  "3 ways in Python to calculate GCD or HCF of two numbers":
    "https://www.codevscolor.com/python-calculate-gcd-hcf",
  "Python program to print the multiplication table of a specific number":
    "https://www.codevscolor.com/python-print-multiplication-table",
  "4 different Python programs to check if a number is a perfect number":
    "https://www.codevscolor.com/python-check-perfect-number-different-ways",
  "2 ways in Python to convert temperature in Celsius to Fahrenheit":
    "https://www.codevscolor.com/python-two-ways-celsius-fahrenheit",
  "3 ways in Python to find the middle n list elements":
    "https://www.codevscolor.com/python-find-n-middle-list-elements",
  "How to remove items from a dictionary in Python":
    "https://www.codevscolor.com/python-remove-dictionary-items",
  "How to change the values of a dictionary in Python":
    "https://www.codevscolor.com/python-dictionary-change-values",
  "Python id() function explanation with examples":
    "https://www.codevscolor.com/python-id-function",
  "How to remove the first occurrence of an item in a list in Python":
    "https://www.codevscolor.com/python-remove-first-occurrence-list-item",
};
export const reactnative = {
  "How to show an alert in React Native":
    "https://www.codevscolor.com/show-alert-react-native",
  "React Native : How to detect text change and edit ends in TextInput":
    "https://www.codevscolor.com/react-native-detect-text-change",
  "How to show a Toast message in a react native application":
    "https://www.codevscolor.com/showing-a-toast-message-in-a-react-native-application",
  "How to parse JSON from local file in React Native":
    "https://www.codevscolor.com/react-native-parse-json",
  "React Native switch component explanation with examples":
    "https://www.codevscolor.com/react-native-switch",
  "How to make password TextInput style in React Native":
    "https://www.codevscolor.com/react-native-password-textinput",
  "How to create one circular image in React Native":
    "https://www.codevscolor.com/react-native-circular-image",
  "How to create a rounded corner button in React Native":
    "https://www.codevscolor.com/react-native-rounded-corner-button",
  "ActivityIndicator in React Native":
    "https://www.codevscolor.com/react-native-activityindicator",
  "How to show hide Activity Indicator spinner on button click in React Native":
    "https://www.codevscolor.com/react-native-show-hide-spinner-activity-indicator-click",
  "React Native button component example":
    "https://www.codevscolor.com/react-native-button",
  "React native program to place two buttons side by side":
    "https://www.codevscolor.com/react-native-two-buttons-side",
  "React Native text input with a clear button":
    "https://www.codevscolor.com/react-native-text-input-clear-button",
  "How to load image from url in React Native":
    "https://www.codevscolor.com/react-native-load-image-url",
  "How to load gif from url in React Native":
    "https://www.codevscolor.com/react-native-load-gif-url",
  "How to run React Native project on specific iOS simulator":
    "https://www.codevscolor.com/react-native-run-specific-ios-simulator",
  "How to add vibration to a React Native project":
    "https://www.codevscolor.com/react-native-vibration",
  "How to add Background image in React Native":
    "https://www.codevscolor.com/react-native-imagebackground",
  "React Native KeyboardAvoidingView explanation with example":
    "https://www.codevscolor.com/react-native-keyboardavoidingview",
  "Add pull to refresh in React Native using RefreshControl":
    "https://www.codevscolor.com/react-native-refreshcontrol-example",
  "React Native modal explanation with example":
    "https://www.codevscolor.com/react-native-modal",
  "How to create one picker component in React Native":
    "https://www.codevscolor.com/react-native-picker-component",
  "Explanation and example of React Native FlatList":
    "https://www.codevscolor.com/react-native-flatlist",
  "Load data from url and show in a flatlist in React Native using hook and async/await":
    "https://www.codevscolor.com/load-show-data-react-native",
  "React Native sectionlist explanation with example":
    "https://www.codevscolor.com/react-native-sectionlist",
  "Status bar in React Native explanation with example":
    "https://www.codevscolor.com/react-native-status-bar",
  "SafeAreaView in React Native and where to use it":
    "https://www.codevscolor.com/react-native-safeareaview",
  "TouchableHighlight in React Native with example":
    "https://www.codevscolor.com/react-native-touchablehighlight",
  "React Native program to change the value of a text on button click":
    "https://www.codevscolor.com/react-native-change-text-button-click",
  "How to create circular buttons in React Native":
    "https://www.codevscolor.com/react-native-circular-buttons",
  "How to transform an object in React Native (skew, scale, transform, rotate":
    "https://www.codevscolor.com/react-native-transform-object",
  "How to add react navigation 5.0 in React Native projectReact navigation Part 1: How to add react navigation 5.0 in React Native project":
    "https://www.codevscolor.com/add-react-navigation-react-native",
  "React navigation part 2: Manage multiple screens":
    "https://www.codevscolor.com/react-navigation-manage-screens",
  "React Navigation part 3: program to move between screens using react navigation":
    "https://www.codevscolor.com/react-navigation-move-between-screens",
  "React Navigation part 4: React native program to pass data between screens":
    "https://www.codevscolor.com/react-native-pass-data-screens",
  "React Navigation part 5: How to update params of a screen":
    "https://www.codevscolor.com/react-navigation-update-params",
  "React Navigation part 6: How to set and change the header title":
    "https://www.codevscolor.com/react-navigation-set-change-title",
  "React navigation tutorial 7: How to add header and header text color, font etc.":
    "https://www.codevscolor.com/react-navigation-change-header-text-color-font",
  "React navigation tutorial 8: How to add one image as the header title":
    "https://www.codevscolor.com/react-navigation-image-header-title",
  "How to add buttons on header in React navigation":
    "https://www.codevscolor.com/react-navigation-header-buttons",
  "How to use one WebView in react native":
    "https://www.codevscolor.com/react-native-webview",
  "How to create blur view in React Native":
    "https://www.codevscolor.com/react-native-blur-view",
  "How to create horizontal scrollbar with views in React native":
    "https://www.codevscolor.com/react-native-horizontal-scroll",
  "React native program to create one vertical scroll view with horizontal scrollable items":
    "https://www.codevscolor.com/react-native-horizontal-vertical-scroll-view",
  "How to add bottom tab navigation bar in react native":
    "https://www.codevscolor.com/react-native-bottom-tab-navigation-bar",
  "React native example to create Text with different colors or multicolored Text":
    "https://www.codevscolor.com/react-native-multi-color-text",
  "How to remove yellow warning box in React Native":
    "https://www.codevscolor.com/react-native-remove-yellow-warning-box",
  "How to hide the keyboard on touch outside in react native":
    "https://www.codevscolor.com/hide-keyboard-touch-outside-react-native",
  "Handling keyboard with react-native ScrollView":
    "https://www.codevscolor.com/react-native-scrollview-handle-keyboard",
  "How to show pdf files in react native applications":
    "https://www.codevscolor.com/react-native-show-pdf",
  "How to add scroll to top to a FlatList in ReactNative app":
    "https://www.codevscolor.com/react-native-add-scroll-to-top-flatlist",
  "How to change the background color of a View dynamically in React Native":
    "https://www.codevscolor.com/react-native-change-view-background-color-dynamically",
  "How to read platform-specific values in React Native":
    "https://www.codevscolor.com/react-native-read-platform-specific-data",
  "How to use SVG or vector images in React native":
    "https://www.codevscolor.com/react-native-use-svg-images",
  "3 ways to create platform-specific designs in React Native":
    "https://www.codevscolor.com/react-native-platform-specific-designs",
  "How to change the text size of TextInput in React Native":
    "https://www.codevscolor.com/react-native-change-text-size-textinput",
  "How to hide the keyboard in React Native on tapping outside of TextInput":
    "https://www.codevscolor.com/react-native-hide-keyboard-tap-outside-textinput",
  "3 ways to detect if Keyboard is opened or closed in React Native":
    "https://www.codevscolor.com/react-native-detect-keyboard-opened-closed",
  "How to hide the keyboard on scrolling through a FlatList in React Native":
    "https://www.codevscolor.com/react-native-hide-keyboard-scrolling-list",
  "Learn to create a custom progress button in React Native and TypeScript":
    "https://www.codevscolor.com/react-native-custom-progress-button",
};
export const reactjs = {
  "An introduction to Reactjs for beginners":
    "https://www.codevscolor.com/react-introduction",
  "Typechecking in react js using propTypes":
    "https://www.codevscolor.com/reactjs-proptypes-example",
  "Find the file name, size, type and modified date of a file in ReactJS":
    "https://www.codevscolor.com/reactjs-file-name-size-type-date",
  "How to create your first reactjs app using create-react-app":
    "https://www.codevscolor.com/react-create-react-app",
  "An introduction to jsx in reactjs":
    "https://www.codevscolor.com/reactjs-introduction-to-jsx",
  "What are Components in Reactjs and how to use these components":
    "https://www.codevscolor.com/reactjs-components",
  "How to add Material-UI to an existing Reactjs app":
    "https://www.codevscolor.com/reactjs-add-material-ui",
  "Box component in material UI reactjs library":
    "https://www.codevscolor.com/reactjs-material-ui-box",
  "Container component in Reactjs material-ui library":
    "https://www.codevscolor.com/reactjs-material-ui-container",
  "How to open a link in a new tab in Reactjs":
    "https://www.codevscolor.com/reactjs-open-link-new-tab",
  "How to get the value of an input field in React.js":
    "https://www.codevscolor.com/reactjs-get-value-input-field",
};
export const swift = {
  "Swift Array Tutorial – swift 3/swift 4":
    "https://www.codevscolor.com/swift-array-tutorial",
  "Swift Set tutorial : Create , access, modify and iterating a Set":
    "https://www.codevscolor.com/swift-tutorial-set",
  "Swift 4 Tutorial : Dictionary":
    "https://www.codevscolor.com/swift-4-tutorial-dictionary",
  "Swift switch tutorial with Example":
    "https://www.codevscolor.com/swift-switch-tutorial-example",
  "Swift 4 for-in loop Tutorial with Example":
    "https://www.codevscolor.com/swift-4-for-in-loop-tutorial",
  "Swift 4 while and repeat-while loop tutorial with example":
    "https://www.codevscolor.com/swift-4-while-repeat-while-loop-tutorial-example",
  "Swift 4 tutorial : continue statement":
    "https://www.codevscolor.com/swift-4-tutorial-continue-statement",
  "How to run a piece of code on main thread in Swift 4":
    "https://www.codevscolor.com/swift-4-run-a-piece-of-code-main-thread",
  "Swift 4 tutorial : Creating a multidimensional array":
    "https://www.codevscolor.com/swift-4-tutorial-creating-multidimensional-array",
  "Swift 4 Tutorial : Split and Join a String":
    "https://www.codevscolor.com/swift-4-tutorial-split-join-string",
  "Different return types in swift functions":
    "https://www.codevscolor.com/different-swift-return-types",
  "Using raw values in swift enumeration":
    "https://www.codevscolor.com/using-raw-values-swift-enumeration",
  "Enumeration in Swift : explanation with examples":
    "https://www.codevscolor.com/enumeration-in-swift-explanation-with-examples",
  "Associated values in swift enumeration and how to use them":
    "https://www.codevscolor.com/swift-enumeration-associated-values",
  "Swift tutorial : Recursive enumeration in Swift":
    "https://www.codevscolor.com/recursive-enumeration-swift-tutorial",
  "Checking Prefix and Postfix of a String in Swift 4":
    "https://www.codevscolor.com/checking-prefix-postfix-string-swift",
  "Swift Tutorial – Check if two strings or characters are equal in Swift 4":
    "https://www.codevscolor.com/string-character-equality-swift-4",
  "How to create a Rounded corner UIView in iOS with Swift 4":
    "https://www.codevscolor.com/create-rounded-corner-uiview-ios-swift",
  "How to update application badge count locally in iOS swift":
    "https://www.codevscolor.com/update-application-badge-count-swift",
  "How to dismiss a keyboard on tap outside view in iOS swift":
    "https://www.codevscolor.com/ios-swift-dismiss-keyboard-tap-outside",
  "(iOS Adding Swipe gesture to a view in Swift 4":
    "https://www.codevscolor.com/ios-adding-swipe-gesture-to-a-view-in-swift-4",
  "Swift program to get the index for a key in Dictionary":
    "https://www.codevscolor.com/swift-program-index-for-key-dictionary",
  "Create a button programmatically in iOS using Swift 4":
    "https://www.codevscolor.com/ios-create-button-programmatically",
  "How to add NSPhotoLibraryUsageDescription key in XCode for an iOS project":
    "https://www.codevscolor.com/ios-nsphotolibraryusagedescription-key-xcode",
  "Swift program to check if a number is a multiple of another":
    "https://www.codevscolor.com/swift-check-number-multiple-another",
  "How to find the remainder in swift using modulo":
    "https://www.codevscolor.com/swift-find-remainder",
  "How to use pod try to test an iOS library":
    "https://www.codevscolor.com/pod-try-example",
  "Swift program to check if a number is odd or even":
    "https://www.codevscolor.com/swift-odd-even-check",
  "How to check if an array of integers contains two numbers appeared twice in swift":
    "https://www.codevscolor.com/swift-check-array-contains-two-numbers-appeared-twice",
  "Three different Swift programs to check if a dictionary contains a key or not":
    "https://www.codevscolor.com/swift-check-dictionary-contains-key",
  "Swift program to get all keys and values of a dictionary":
    "https://www.codevscolor.com/swift-get-all-key-value-of-dictionary",
  "Swift dictionary append method explanation with example":
    "https://www.codevscolor.com/swift-dictionary-append",
  "Swift dictionary allSatisfy method - check if all elements satisfy a given predicate":
    "https://www.codevscolor.com/swift-dictionary-allsatisfy",
  "How to check if a swift dictionary is empty or not":
    "https://www.codevscolor.com/swift-dictionary-check-empty",
  "How to merge two Dictionaries in swift":
    "https://www.codevscolor.com/swift-merge-two-dictionaries",
  "How to create an array of dictionary elements in swift":
    "https://www.codevscolor.com/swift-create-array-of-dictionary",
  "Swift dictionary map explanation with example":
    "https://www.codevscolor.com/swift-dictionary-map-method-example",
  "How to transform swift dictionary values using mapValues()":
    "https://www.codevscolor.com/transform-swift-dictionary-values-using-mapvalues",
  "Search and filter in a Swift array of dictionaries for specific value":
    "https://www.codevscolor.com/swift-search-filter-in-array-of-dictionaries",
  "How to give default values for swift dictionary":
    "https://www.codevscolor.com/swift-dictionary-default-values",
  "Swift string characters in unicode, UTF-16 and UTF-8 representation":
    "https://www.codevscolor.com/swift-string-unicode-utf-representation",
  "How to find the length of a string in swift":
    "https://www.codevscolor.com/swift-find-length-of-string",
  "Swift optional explanation with example":
    "https://www.codevscolor.com/swift-optional",
  "Swift program to convert an array of string to a string":
    "https://www.codevscolor.com/swift-convert-array-of-strings-to-strings",
  "How to trim whitespaces and other characters from a string in swift":
    "https://www.codevscolor.com/swift-trim-whitespaces-string",
  "How to create different types of alerts and actionsheets in iOS swift":
    "https://www.codevscolor.com/ios-different-alerts-actionsheets",
  "Swift program to find the first index of a character in a string":
    "https://www.codevscolor.com/swift-find-first-index-character-string",
  "Swift String interpolation in 5 minutes":
    "https://www.codevscolor.com/swift-string-interpolation",
  "String Prefix methods in Swift explanation with example":
    "https://www.codevscolor.com/swift-string-prefix",
  "Swift program to check if two strings are equal or not":
    "https://www.codevscolor.com/swift-check-two-strings-equal",
  "Learn to iterate through the key-value pairs of a swift dictionary":
    "https://www.codevscolor.com/swift-dictionary-iterate-key-value",
  "Swift program to convert a string to date":
    "https://www.codevscolor.com/swift-convert-string-to-date",
  "How to find the maximum or largest element in a swift array":
    "https://www.codevscolor.com/swift-find-maximum-element-in-array",
  "2 ways to find the first and last character of a string in Swift":
    "https://www.codevscolor.com/swift-find-first-last-character-string",
  "How to create a basic tableview in iOS swift in XCode":
    "https://www.codevscolor.com/ios-swift-xcode-create-tableview",
  "How to insert characters to a string in Swift":
    "https://www.codevscolor.com/swift-insert-characters-to-string",
  "How to return multiple values from a function in Swift":
    "https://www.codevscolor.com/swift-return-multiple-values-from-function",
  "How to convert a string to float and double in Swift":
    "https://www.codevscolor.com/swift-convert-string-to-float-double",
  "Swift program to find the smallest of three numbers":
    "https://www.codevscolor.com/swift-smallest-three-numbers",
  "3 Swift programs to find the largest of three numbers":
    "https://www.codevscolor.com/swift-largest-three-numbers",
  "Find the maximum of n values using max() in Swift":
    "https://www.codevscolor.com/swift-maximum-n-values",
  "Find the smallest of n values using min() in Swift":
    "https://www.codevscolor.com/swift-smallest-n-values",
};
export const typescript = {
  "TypeScript character at specific index and index of character in string":
    "https://www.codevscolor.com/typescript-index-string-character",
  "TypeScript for and for-in loop explanation & examples":
    "https://www.codevscolor.com/typescript-for-forin",
  "for…of loop of typescript explanation with examples":
    "https://www.codevscolor.com/typescript-for-of",
  "Typescript concat and split explanation with example":
    "https://www.codevscolor.com/typescript-concat-split",
  "TypeScript template string examples":
    "https://www.codevscolor.com/typescript-template-string",
  "How to uppercase or lowercase all characters of a string in TypeScript":
    "https://www.codevscolor.com/typescript-upper-lowercase-string-characters",
  "How to use TypeScript in Visual Studio Code":
    "https://www.codevscolor.com/typescript-visual-studio-code",
  "How to iterate over an array in TypeScript":
    "https://www.codevscolor.com/typescript-iterate-over-array",
  "TypeScript add one or more elements to an array":
    "https://www.codevscolor.com/typescript-add-array-items",
  "Different ways to convert a string to number in TypeScript":
    "https://www.codevscolor.com/typescript-convert-string-to-number",
  "How to parse JSON in TypeScript":
    "https://www.codevscolor.com/typescript-parse-json",
  "Type assertion in typescript explanation with example":
    "https://www.codevscolor.com/typescript-type-assertion",
  "How to import JSON from a file in TypeScript":
    "https://www.codevscolor.com/import-json-typescript",
  "Interface in typescript explanation with example":
    "https://www.codevscolor.com/typescript-interface",
  "3 different ways to split a string in typescript":
    "https://www.codevscolor.com/typescript-split-string",
  "What is union type in typescript and how to use":
    "https://www.codevscolor.com/typescript-union-type",
  "Switch-case statement in typescript with examples":
    "https://www.codevscolor.com/typescript-switch-statement",
  "Introduction to Set in TypeScript with examples":
    "https://www.codevscolor.com/typescript-set-example",
  "How to use forEach in typescript array":
    "https://www.codevscolor.com/typescript-foreach-example",
  "TypeScript string replace() method explanation with example":
    "https://www.codevscolor.com/typescript-string-replace",
  "readonly keyword in typescript with example":
    "https://www.codevscolor.com/typescript-readonly-keyword",
  "static in typescript with example":
    "https://www.codevscolor.com/typescript-static-keyword",
  "Never type in typescript with example":
    "https://www.codevscolor.com/typescript-never-type",
  "How to convert string to date in typescript":
    "https://www.codevscolor.com/typescript-string-to-date",
  "Introduction to modules in typescript":
    "https://www.codevscolor.com/typescript-modules",
  "How to convert a string to an array of characters in TypeScript using split":
    "https://www.codevscolor.com/typescript-string-array-split",
  "Typescript any explanation with example":
    "https://www.codevscolor.com/typescript-any-example",
  "How to create a class in typescript with example":
    "https://www.codevscolor.com/typescript-class-example",
  "How to convert any to string in typescript":
    "https://www.codevscolor.com/typescript-any-to-string",
  "TypeScript string search method":
    "https://www.codevscolor.com/typescript-string-search-method",
  "How to create an array of objects in TypeScript":
    "https://www.codevscolor.com/typescript-array-of-objects",
  "TypeScript program to add two numbers":
    "https://www.codevscolor.com/typescript-add-two-numbers",
  "4 ways in TypeScript to reverse a string":
    "https://www.codevscolor.com/typescript-reverse-string-different-ways",
  "How to compile and run a TypeScript program":
    "https://www.codevscolor.com/typescript-compile-run-program",
  "How to get the current date in TypeScript":
    "https://www.codevscolor.com/typescript-get-current-date",
  "How to add one day to a date object in TypeScript":
    "https://www.codevscolor.com/typescript-add-one-day-to-date",
  "How to get the previous year in TypeScript":
    "https://www.codevscolor.com/typescript-get-previous-year",
};
